
const WIZZY_COLOR_SWATCH_FALLBACK = "#808080";
const WIZZY_MULTICOLOR_SWATCH_URL =
  "https://i.ibb.co/BVjj74X/classic-color-spectrum-rgb-line-gradient-vector-522680-173-copy.png";

const colorMap = new Map([
  ["black", "#000000"],
  ["white", "#FFFFFF"],
  ["grey", "#808080"],
  ["navy blue", "#273854"],
  ["red", "#d13b38"],
  ["green", "#008000"],
  ["purple", "#800080"],
  ["blue", "#1d5caa"],
  ["orange", "#e5990e"],
  ["peach", "#ffdab9"],
  ["teal", "#008080"],
  ["yellow", "#ffff00"],
  ["brown", "#8B4513"],
  ["pink", "#FFC0CB"],
  ["maroon", "#800000"],
  ["olive", "#808000"],
  ["navy", "#000080"],
  ["khaki", "#C3B091"],
  ["mint", "#98FF98"],
  ["mauve", "#E0B0FF"],
  ["silver", "#C0C0C0"],
  ["gold", "#FFD700"],
  ["steel", "#71797E"],
  ["coral", "#FF7F50"],
  ["desert", "#C19A6B"],
  ["night", "#191970"],
  ["rust", "#B7410E"],
  ["assorted", WIZZY_MULTICOLOR_SWATCH_URL],
  ["multicolor", WIZZY_MULTICOLOR_SWATCH_URL],
  ["multicolour", WIZZY_MULTICOLOR_SWATCH_URL],
  ["multi", WIZZY_MULTICOLOR_SWATCH_URL],
  ["golden", "#FFD900"],
  ["off white", "#F5F5F5"],
  ["cream", "#FFFDD0"],
  ["sky blue", "#87CEEB"],
  ["light blue", "#ADD8E6"],
  ["olive green", "#556B2F"],
  ["light green", "#90EE90"],
  ["dark grey", "#A9A9A9"],
  ["dark blue", "#00008B"],
  ["jet black", "#000000"],
  ["bright white", "#FFFFFF"],
  ["light grey", "#D3D3D3"],
  ["wine", "#722F37"],
  ["teal blue", "#008080"],
  ["royal blue", "#4169E1"],
  ["indigo blue", "#4B0082"],
  ["mid blue", "#0000CD"],
  ["peacock blue", "#006994"],
  ["deep blue", "#000080"],
  ["aqua blue", "#00FFFF"],
  ["ice blue", "#BCE6E6"],
  ["night blue", "#191970"],
  ["denim blue", "#1560BD"],
  ["turquoise blue", "#40E0D0"],
  ["brick red", "#B22222"],
  ["light red", "#FF6961"],
  ["dark red", "#8B0000"],
  ["bright red", "#FF0000"],
  ["carrot red", "#FF4500"],
  ["burn red", "#9A3334"],
  ["cardinal red", "#C41E3A"],
  ["oxblood red", "#800020"],
  ["rio red", "#DA2C43"],
  ["rose red", "#FF033E"],
  ["rumba red", "#C76E70"],
  ["spice red", "#A23C3C"],
  ["tango red", "#E25822"],
  ["deep red", "#8B0000"],
  ["mustard yellow", "#FFDB58"],
  ["musturd yellow", "#FFDB58"],
  ["light yellow", "#FFFFE0"],
  ["lemon yellow", "#FFF44F"],
  ["mellow yellow", "#F8DE7E"],
  ["bright yellow", "#FFFF00"],
  ["golden yellow", "#FFD700"],
  ["honey yellow", "#E0CDA9"],
  ["chrome yellow", "#FFA700"],
  ["corn yellow", "#FBEC5D"],
  ["pale yellow", "#EEE8AA"],
  ["pastel yellow", "#FDFD96"],
  ["taffy yellow", "#F8DE7E"],
  ["dark green", "#006400"],
  ["light pink", "#FFB6C1"],
  ["onion pink", "#F5B9F5"],
  ["island pink", "#FFD1DC"],
  ["lilac pink", "#FFC0CB"],
  ["rose pink", "#FF66CC"],
  ["coral pink", "#FF7F50"],
  ["dusty pink", "#D8BFD8"],
  ["send pink", "#FF91A4"],
  ["blossom pink", "#FFC3A0"],
  ["delicacy pink", "#FEC3AC"],
  ["flamingo pink", "#FC8EAC"],
  ["pastel pink", "#FFD1BB"],
  ["baby pink", "#FFC0CB"],
  ["pastel purple", "#B39EB5"],
  ["dark purple", "#800080"],
  ["beige", "#F5F5DC"],
  ["light purple", "#E6E6FA"],
  ["cloud cream", "#FFF8E7"],
  ["custard cream", "#FFF0C1"],
  ["dark cream", "#EEE8AA"],
  ["dawn cream", "#FFFAF0"],
  ["fawn cream", "#E5AA70"],
  ["italian cream", "#F6ECD8"],
  ["light orange", "#FFD68F"],
  ["apricot orange", "#FDD5B1"],
  ["bright orange", "#FF8C00"],
  ["burnt orange", "#FF4500"],
  ["coral orange", "#FF7F50"],
  ["golden orange", "#FFD700"],
  ["dark olive", "#556B2F"],
  ["olive brown", "#806517"],
  ["light olive", "#AAB300"],
  ["olive grey", "#B5B35C"],
  ["branch olive", "#5F6527"],
  ["dark olive green", "#556B2F"],
  ["deep olive green", "#556B2F"],
  ["dusty olive", "#8A8662"],
  ["olive melange", "#6B6C4A"],
  ["dark maroon", "#800000"],
  ["maroon gold", "#B03060"],
  ["silver grey", "#C0C0C0"],
  ["lime green", "#00FF00"],
  ["state grey", "#808080"],
  ["teal green", "#008080"],
  ["dusty teal", "#4E5D4E"],
  ["teal black", "#003838"],
  ["teal grey", "#69838D"],
  ["midnight navy", "#000080"],
  ["grey melange", "#808080"],
  ["charcoal grey", "#36454F"],
  ["charcoal", "#36454F"],
  ["ercus melange", "#B5B5B5"],
  ["air force blue", "#5D8AA8"],
  ["aquamarine blue", "#7FFFD4"],
  ["carrot brown", "#ED9121"],
  ["colonial blue", "#002F6C"],
  ["cornet blue", "#6495ED"],
  ["deep wine", "#8B0000"],
  ["bottle green", "#092E20"],
  ["anthracite", "#293133"],
  ["black khaki bl", "#2B2B24"],
  ["black leather", "#1A1A1A"],
  ["black nubuck", "#212121"],
  ["black suede", "#1C1C1C"],
  ["bronze pink met", "#B07C7C"],
  ["chalk", "#F6F4F1"],
  ["champagne", "#F7E7CE"],
  ["clear sky met", "#8CB0CF"],
  ["dark flwr stamp", "#3A2E3B"],
  ["dungaree blue", "#566F87"],
  ["escape red", "#CC1100"],
  ["flower stamp", "#E8A2B5"],
  ["game grey", "#78808A"],
  ["intense rose", "#B93A6F"],
  ["linen", "#FAF0E6"],
  ["medium blue", "#4B89DC"],
  ["natural white", "#F8F6F0"],
  ["navy leather", "#1B263B"],
  ["navy nubuck", "#2C3E50"],
  ["snow", "#FAFAFA"],
  ["soccer prt", "#E0E0E0"],
  ["tan leather", "#B68A5D"],
]);

function isWizzyUrlSwatch(value) {
  return typeof value === "string" && /^https?:\/\//i.test(value.trim());
}

function isWizzyCssGradient(value) {
  return typeof value === "string" && /linear-gradient\(/i.test(value);
}

function isWizzyCssColorValue(value) {
  if (!value || typeof value !== "string") {
    return false;
  }
  const trimmed = value.trim();
  return (
    /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})$/.test(trimmed) ||
    /^rgba?\(/i.test(trimmed) ||
    /^hsla?\(/i.test(trimmed) ||
    isWizzyUrlSwatch(trimmed) ||
    isWizzyCssGradient(trimmed)
  );
}

function parseWizzyColorLabelParts(label) {
  return String(label || "")
    .split(/\s*(?:&|,)\s*/)
    .map(function (part) {
      return part.trim();
    })
    .filter(Boolean);
}

function getWizzyColorMapKey(key) {
  return normalizeWizzyColorKey(key).replace(/\bgray\b/g, "grey");
}

function findHaxCode(key, apiSwatchValue) {
  const label = getWizzyColorMapKey(key);
  const mapped = label && colorMap.get(label);

  if (mapped) {
    return [mapped, isWizzyUrlSwatch(mapped)];
  }

  const parts = parseWizzyColorLabelParts(label);
  if (parts.length > 1) {
    const hexes = parts.map(function (part) {
      return colorMap.get(part);
    });
    const canSplit = hexes.every(function (hex) {
      return hex && !isWizzyUrlSwatch(hex);
    });

    if (canSplit) {
      const stops =
        hexes.length === 2
          ? hexes[0] + " 50%, " + hexes[1] + " 50%"
          : hexes
              .map(function (hex, index) {
                const step = 100 / hexes.length;
                return (
                  hex +
                  " " +
                  (index * step).toFixed(2) +
                  "% " +
                  ((index + 1) * step).toFixed(2) +
                  "%"
                );
              })
              .join(", ");
      return ["linear-gradient(135deg, " + stops + ")", false];
    }
  }

  const apiValue = String(apiSwatchValue || "").trim();
  if (
    apiValue &&
    !/^(#?808080|gray|grey)$/i.test(apiValue) &&
    isWizzyCssColorValue(apiValue)
  ) {
    return [apiValue, isWizzyUrlSwatch(apiValue)];
  }

  return [WIZZY_COLOR_SWATCH_FALLBACK, false];
}

function getWizzyColorBackgroundCss(value) {
  if (!value) {
    return WIZZY_COLOR_SWATCH_FALLBACK;
  }
  if (isWizzyUrlSwatch(value)) {
    return 'url("' + value.replace(/"/g, "") + '") center / cover no-repeat';
  }
  return value;
}

document.addEventListener('DOMContentLoaded', function () {
  if (localStorage.getItem('wizzyIsRedirectedFlag') === "true" && window.location.pathname == '/collections/best-seller') {
    const wrapper = document.querySelector('.collection__wrapper .wrapper--full-padded');

    if (wrapper) {
      const message = document.createElement('h3');
      message.textContent = 'The product you are searching for is not available';

      wrapper.insertBefore(message, wrapper.firstChild);
    }
  }
});

const changeTemplate = function (div) {
  const oldDiv = document.getElementById(div);
  const newDiv = document.getElementById(div + "-new");
  if (!oldDiv || !newDiv) {
    return;
  }
  oldDiv.text = newDiv.text;
};

function getActiveWizzySearchInput() {
  const focused = document.activeElement;
  if (focused && focused.classList.contains("wizzy-search-input")) {
    return focused;
  }

  const mobileContainer = document.querySelector(".mobile-recommended-search__container");
  const mobileInput = document.querySelector("#mobile-Search-In-Modal");
  if (
    mobileContainer &&
    !mobileContainer.classList.contains("hidden") &&
    mobileInput
  ) {
    return mobileInput;
  }

  const desktopInput = document.querySelector("#searchInput-desktop");
  if (desktopInput && document.body.classList.contains("search-opened")) {
    return desktopInput;
  }

  if (desktopInput && desktopInput.getBoundingClientRect().width > 0) {
    return desktopInput;
  }

  return (
    mobileInput ||
    desktopInput ||
    document.querySelector(".wizzy-search-input")
  );
}

function isWizzyAutocompleteVisible(wrapper) {
  if (!wrapper) {
    return false;
  }

  const style = window.getComputedStyle(wrapper);
  return style.display !== "none" && style.visibility !== "hidden";
}

function positionWizzyAutocompleteWrapper() {
  const wrapper =
    document.querySelector(".wizzy-autocomplete-wrapper.onLeft") ||
    document.querySelector(".wizzy-autocomplete-wrapper");

  if (!isWizzyAutocompleteVisible(wrapper)) {
    document.body.classList.remove("wizzy-autocomplete-open");
    return;
  }

  const searchInput = getActiveWizzySearchInput();
  if (!searchInput) {
    return;
  }

  document.body.classList.add("wizzy-autocomplete-open");

  const positionInfo = searchInput.getBoundingClientRect();
  const top = positionInfo.top + positionInfo.height;

  if (window.innerWidth <= 768) {
    wrapper.style.setProperty("top", top + "px", "important");
    wrapper.style.setProperty("left", "0", "important");
    wrapper.style.setProperty("right", "0", "important");
    wrapper.style.setProperty("width", "100%", "important");
    return;
  }

  wrapper.style.setProperty("top", top + "px", "important");
  wrapper.style.setProperty("right", positionInfo.left + "px", "important");
  wrapper.style.removeProperty("left");
  wrapper.style.removeProperty("width");
}

var wizzyAutocompletePositionListenersRegistered = false;

function registerWizzyAutocompletePositionListeners() {
  if (wizzyAutocompletePositionListenersRegistered) {
    return;
  }
  wizzyAutocompletePositionListenersRegistered = true;

  window.addEventListener("scroll", positionWizzyAutocompleteWrapper, {
    passive: true,
  });
  window.addEventListener("resize", positionWizzyAutocompleteWrapper, {
    passive: true,
  });

  document.addEventListener("click", function (event) {
    if (
      event.target.closest("[data-popdown-close]") ||
      event.target.closest(".search-bar-close__button")
    ) {
      document.body.classList.remove("wizzy-autocomplete-open");
    }
  });
}

function getDesktopHeaderSearchInput() {
  return (
    document.querySelector("#searchInput-desktop") ||
    document.querySelector(
      "search-popdown[data-popdown-in-header] .search-form__input.wizzy-search-input"
    )
  );
}

function openWizzyAutocompleteFromDesktopSearchInput() {
  const input = getDesktopHeaderSearchInput();
  if (!input) {
    return;
  }

  input.focus({ preventScroll: true });
  input.click();
  input.dispatchEvent(new Event("input", { bubbles: true }));
  setTimeout(positionWizzyAutocompleteWrapper, 50);
}

var wizzyDesktopSearchIconAutocompleteBound = false;

function bindWizzyDesktopSearchIconAutocomplete() {
  if (wizzyDesktopSearchIconAutocompleteBound) {
    return;
  }
  wizzyDesktopSearchIconAutocompleteBound = true;

  document.addEventListener("click", function (event) {
    if (window.innerWidth < 768) {
      return;
    }

    const toggle = event.target.closest(
      ".search-popdown__toggle.navlink.navlink--icon, .search-popdown__toggle[data-popdown-toggle]"
    );
    const details = toggle?.closest("details");
    if (
      !toggle ||
      !toggle.closest("search-popdown[data-popdown-in-header]") ||
      details?.hasAttribute("open")
    ) {
      return;
    }

    setTimeout(openWizzyAutocompleteFromDesktopSearchInput, 400);
  });
}

const extractHandleFromUrl = function (url) {
  if (!url) return "";
  const match = String(url).match(/\/products\/([^/?#]+)/);
  return match ? match[1] : "";
};

const getAttributeValue = function (product, attributeId) {
  const attribute = product?.attributes?.find((item) => item.id === attributeId);
  if (!attribute?.values?.length) return "";
  const value = attribute.values[0].value;
  return Array.isArray(value) ? value[0] : value;
};

function addWizzyProductTag(tag, tags, seen) {
  if (tag == null || tag === "") {
    return;
  }
  if (typeof tag !== "string") {
    if (typeof tag === "number" || typeof tag === "boolean") {
      addWizzyProductTag(String(tag), tags, seen);
      return;
    }
    if (Array.isArray(tag)) {
      tag.forEach(function (item) {
        addWizzyProductTag(item, tags, seen);
      });
      return;
    }
    if (typeof tag === "object") {
      addWizzyProductTag(
        tag.value || tag.label || tag.name || tag.key || tag.title,
        tags,
        seen
      );
      return;
    }
    return;
  }

  const trimmed = tag.trim();
  if (!trimmed) {
    return;
  }
  if (trimmed.indexOf(",") > -1) {
    trimmed.split(",").forEach(function (part) {
      addWizzyProductTag(part, tags, seen);
    });
    return;
  }
  if (seen[trimmed]) {
    return;
  }
  seen[trimmed] = true;
  tags.push(trimmed);
}

function getWizzyProductTags(product) {
  const tags = [];
  const seen = {};

  addWizzyProductTag(product?.tags, tags, seen);

  (product?.attributes || []).forEach(function (attribute) {
    const id = String(attribute.id || "").toLowerCase();
    const isTagAttr =
      id === "product_tags" ||
      id === "shopify_tags" ||
      id.indexOf("product_tag") > -1 ||
      id.indexOf("tags") > -1;

    if (!isTagAttr) {
      return;
    }

    addWizzyProductTag(attribute.values, tags, seen);
  });

  return tags;
}

function getWizzyClpTagSuffix(tagValue) {
  const str = String(tagValue || "");
  const markerIndex = str.toLowerCase().indexOf("tag__");
  if (markerIndex === -1) {
    return "";
  }
  return (str.slice(markerIndex).split("__").pop() || "").toLowerCase().trim();
}

function isWizzyBestSellerTag(tagValue) {
  const raw = String(tagValue || "").trim();
  if (!raw) {
    return false;
  }
  const lower = raw.toLowerCase();
  if (
    lower === "bestseller" ||
    lower === "best seller" ||
    lower === "best-seller" ||
    lower === "best_seller"
  ) {
    return true;
  }
  const suffix = getWizzyClpTagSuffix(raw);
  return (
    suffix === "best seller" ||
    suffix === "bestseller" ||
    suffix === "best-seller" ||
    suffix === "best_seller"
  );
}

function capitalizeWizzyTagLabel(label) {
  const value = String(label || "").trim();
  if (!value) {
    return "";
  }
  return value.charAt(0).toUpperCase() + value.slice(1);
}

function normalizeValueTagLabel(label) {
  if (!label || typeof label !== "string") {
    return null;
  }
  const normalized = {
    "New Arrivals": "New Arrival",
    "NEW ARRIVAL": "New Arrival",
    "Best Seller": "Best seller",
    "BEST SELLER": "Best seller",
    "Best seller": "Best seller",
    bestseller: "Best seller",
    Bestseller: "Best seller",
  };
  return normalized[label] || label;
}

function resolveTagBadgeLabel(tags) {
  let clpLabel = "";
  let hasBestseller = false;

  (tags || []).forEach(function (tag) {
    const suffix = getWizzyClpTagSuffix(tag);
    if (suffix) {
      clpLabel = capitalizeWizzyTagLabel(suffix);
    }
    if (isWizzyBestSellerTag(tag)) {
      hasBestseller = true;
    }
  });

  if (hasBestseller) {
    if (clpLabel && /best\s*-?\s*seller/i.test(clpLabel)) {
      return clpLabel;
    }
    return "Best seller";
  }

  if (clpLabel) {
    return clpLabel;
  }

  return null;
}

const escapeHtml = function (value) {
  return String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
};

function parseWizzyPriceNumber(value) {
  if (value === undefined || value === null || value === "") {
    return NaN;
  }
  const parsed = parseFloat(String(value).replace(/[^\d.]/g, ""));
  return Number.isFinite(parsed) ? parsed : NaN;
}

function formatWizzyPriceDisplay(value) {
  const parsed = parseWizzyPriceNumber(value);
  if (Number.isFinite(parsed)) {
    return Math.round(parsed).toLocaleString("en-IN");
  }
  return String(value || "").replace(/\.00$/, "");
}

function enrichWizzyProductPricing(product) {
  if (!product || typeof product !== "object") {
    return product;
  }

  const selling = parseWizzyPriceNumber(product.sellingPrice);
  const compareCandidates = [
    product.compareAtPrice,
    product.price,
    product.listPrice,
    product.originalPrice,
    getAttributeValue(product, "compare_at_price"),
    getAttributeValue(product, "product_compare_at_price"),
    getAttributeValue(product, "compareAtPrice"),
  ];

  let compare = NaN;
  for (let i = 0; i < compareCandidates.length; i++) {
    const parsed = parseWizzyPriceNumber(compareCandidates[i]);
    if (
      Number.isFinite(parsed) &&
      Number.isFinite(selling) &&
      parsed > selling &&
      (!Number.isFinite(compare) || parsed > compare)
    ) {
      compare = parsed;
    }
  }

  let discountPct = parseInt(
    String(product.discountPercentage || product.discount || "").replace(/[^\d]/g, ""),
    10
  );

  const hasCompare = Number.isFinite(compare) && Number.isFinite(selling) && compare > selling;
  if ((!Number.isFinite(discountPct) || discountPct <= 0) && hasCompare) {
    discountPct = Math.floor(((compare - selling) / compare) * 100);
  }

  if (!hasCompare && Number.isFinite(discountPct) && discountPct > 0 && Number.isFinite(selling)) {
    compare = selling / (1 - discountPct / 100);
  }

  const showCompare = Number.isFinite(compare) && Number.isFinite(selling) && compare > selling;
  product.compareAtPrice = showCompare ? formatWizzyPriceDisplay(compare) : "";
  product.hasCompareAtPrice = showCompare;
  if (Number.isFinite(discountPct) && discountPct > 0) {
    product.discountPercentage = String(discountPct);
  }

  return product;
}

const WIZZY_SIZE_DISPLAY_MAP = {
  small: "S",
  medium: "M",
  large: "L",
  "small-medium": "S-M",
  "medium-large": "M-L",
  "small-medium-large": "Set of 3",
  "pack-of-7": "Pack 7",
  "pack-of-4": "Pack 4",
};

const WIZZY_SIZE_ORDER_MAP = {
  small: 1,
  medium: 2,
  large: 3,
  "small-medium": 4,
  "medium-large": 5,
  "small-medium-large": 6,
  "pack-of-7": 1,
  "pack-of-4": 2,
};

const wizzySlpProductCache = new Map();
const wizzySlpGroupColorVariantCache = new Map();
const wizzySiblingGroupColorOrderCache = new Map();
const wizzyCardColorStripBaselineCache = new Map();
const wizzySiblingSizePayloadCache = new Map();
const wizzyPayloadSizeByVariationId = new Map();
const wizzyPayloadSizeByHandle = new Map();
const wizzyPayloadSizeBySizeKey = new Map();
const wizzyPayloadSizeByProductId = new Map();
const wizzyHandleToProductIdCache = new Map();
const wizzyHandleToProductIdPending = new Map();
var wizzySlpVariantHandlersRegistered = false;
var wizzyPriceRangeHandlersRegistered = false;

function setWizzyCardGroupId(card, groupId) {
  const normalizedGroupId = String(groupId || "").trim();
  if (!card || !normalizedGroupId) {
    return "";
  }

  card.setAttribute("data-groupId", normalizedGroupId);
  card.setAttribute("data-groupid", normalizedGroupId);

  if (typeof window.jQuery === "function") {
    const $card = window.jQuery(card);
    $card.data("groupid", normalizedGroupId);
    $card.data("groupId", normalizedGroupId);
  }

  return normalizedGroupId;
}

function syncWizzyCardGroupIdFromSwatch(card, swatchEl) {
  if (!card || !swatchEl) {
    return "";
  }

  return setWizzyCardGroupId(
    card,
    swatchEl.getAttribute("data-groupid") ||
      swatchEl.getAttribute("data-groupId") ||
      ""
  );
}

function normalizeWizzyPayloadId(value) {
  const normalized = String(value || "").trim();
  return normalized || "";
}

function normalizeWizzyPayloadSizeEntry(entry) {
  if (!entry) {
    return null;
  }

  const productId = normalizeWizzyPayloadId(
    entry.productId || entry.groupId || entry.product_id || entry.group_id
  );
  const variationId = normalizeWizzyPayloadId(
    entry.variationId || entry.variantId || entry.id
  );
  const value = String(entry.value || entry.size || "").trim();
  const handle = entry.handle || entry.productHandle || "";

  if (!productId && !variationId && !value && !handle) {
    return null;
  }

  const sellingPrice = entry.sellingPrice ?? entry.selling_price;
  const price = entry.price ?? entry.compareAtPrice ?? entry.compare_at_price;

  return {
    value: value,
    productId: productId,
    variationId: variationId,
    handle: handle,
    inStock: entry.inStock !== false,
    sellingPrice:
      sellingPrice !== undefined && sellingPrice !== null && sellingPrice !== ""
        ? sellingPrice
        : null,
    price:
      price !== undefined && price !== null && price !== "" ? price : null,
  };
}

function indexWizzySiblingSizePayloadEntries(entries) {
  (entries || []).forEach(function (entry) {
    const normalized = normalizeWizzyPayloadSizeEntry(entry);
    if (!normalized) {
      return;
    }

    if (normalized.variationId) {
      wizzyPayloadSizeByVariationId.set(normalized.variationId, normalized);
    }
    if (normalized.handle) {
      wizzyPayloadSizeByHandle.set(normalized.handle, normalized);
    }
    if (normalized.value) {
      wizzyPayloadSizeBySizeKey.set(
        handleizeWizzySizeValue(normalized.value),
        normalized
      );
    }
    if (normalized.productId) {
      wizzyPayloadSizeByProductId.set(normalized.productId, normalized);
    }
  });
}

function findWizzyPayloadSizeEntryGlobal(criteria) {
  criteria = criteria || {};
  const variationId = normalizeWizzyPayloadId(criteria.variationId);
  const handle = normalizeWizzyPayloadId(criteria.handle);
  const sizeKey = criteria.value
    ? handleizeWizzySizeValue(criteria.value)
    : "";
  const productId = normalizeWizzyPayloadId(
    criteria.productId || criteria.groupId
  );

  if (variationId && wizzyPayloadSizeByVariationId.has(variationId)) {
    return wizzyPayloadSizeByVariationId.get(variationId);
  }
  if (handle && wizzyPayloadSizeByHandle.has(handle)) {
    return wizzyPayloadSizeByHandle.get(handle);
  }
  if (sizeKey && wizzyPayloadSizeBySizeKey.has(sizeKey)) {
    return wizzyPayloadSizeBySizeKey.get(sizeKey);
  }
  if (productId && wizzyPayloadSizeByProductId.has(productId)) {
    return wizzyPayloadSizeByProductId.get(productId);
  }

  return null;
}

function parseRawJsonAttributeEntries(product, attributeIds) {
  if (!product?.attributes?.length) {
    return [];
  }

  const ids = Array.isArray(attributeIds) ? attributeIds : [attributeIds];
  const merged = [];
  const seen = new Set();

  ids.forEach(function (attributeId) {
    const attribute = product.attributes.find(function (item) {
      return item.id === attributeId;
    });
    if (!attribute?.values?.length) {
      return;
    }

    attribute.values.forEach(function (row) {
      let raw = row?.value;
      if (Array.isArray(raw)) {
        raw = raw[0];
      }
      if (raw === null || raw === undefined || raw === "") {
        return;
      }

      try {
        let parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
        if (!Array.isArray(parsed)) {
          parsed =
            parsed && typeof parsed === "object" ? Object.values(parsed) : [];
        }

        parsed.forEach(function (item) {
          const key = JSON.stringify(item);
          if (seen.has(key)) {
            return;
          }
          seen.add(key);
          merged.push(item);
        });
      } catch (error) {
        return;
      }
    });
  });

  return merged;
}

function parseRawSiblingSizePayloadFromAttributes(product) {
  const rawSizeItems = parseRawJsonAttributeEntries(product, [
    "sibling_color_sizes",
    "Sibling Color Sizes",
    "product_sibling_color_sizes",
  ]);
  let entries = rawSizeItems
    .map(normalizeWizzyPayloadSizeEntry)
    .filter(function (entry) {
      return entry && (entry.productId || entry.variationId);
    });

  if (!entries.length) {
    parseRawJsonAttributeEntries(product, [
      "sibling_color_swatches",
      "Sibling Color Swatches",
      "product_sibling_color_swatches",
    ]).forEach(function (colorItem) {
      if (!Array.isArray(colorItem?.sizes) || !colorItem.sizes.length) {
        return;
      }

      colorItem.sizes.forEach(function (sizeItem) {
        const normalized = normalizeWizzyPayloadSizeEntry(
          Object.assign({}, sizeItem, {
            handle: sizeItem?.handle || colorItem?.handle || "",
          })
        );
        if (normalized) {
          entries.push(normalized);
        }
      });
    });
  }

  return dedupeWizzySwatches(
    entries.filter(Boolean),
    function (entry) {
      return (
        normalizeWizzyPayloadId(entry.productId) +
        ":" +
        normalizeWizzyPayloadId(entry.variationId) +
        ":" +
        handleizeWizzySizeValue(entry.value)
      );
    }
  );
}

function fetchWizzyProductIdByHandle(handle) {
  handle = String(handle || "").trim();
  if (!handle) {
    return Promise.resolve("");
  }

  if (wizzyHandleToProductIdCache.has(handle)) {
    return Promise.resolve(wizzyHandleToProductIdCache.get(handle));
  }

  if (wizzyHandleToProductIdPending.has(handle)) {
    return wizzyHandleToProductIdPending.get(handle);
  }

  const promise = fetch("/products/" + encodeURIComponent(handle) + ".js")
    .then(function (response) {
      if (!response.ok) {
        throw new Error("product js fetch failed");
      }
      return response.json();
    })
    .then(function (data) {
      const productId = normalizeWizzyPayloadId(data?.id);
      if (productId) {
        wizzyHandleToProductIdCache.set(handle, productId);
        indexWizzySiblingSizePayloadEntries([
          {
            productId: productId,
            handle: handle,
            variationId: "",
            value: "",
          },
        ]);
      }
      wizzyHandleToProductIdPending.delete(handle);
      return productId;
    })
    .catch(function () {
      wizzyHandleToProductIdPending.delete(handle);
      return "";
    });

  wizzyHandleToProductIdPending.set(handle, promise);
  return promise;
}

function applyGroupIdToSwatch(swatchEl, groupId) {
  const normalizedGroupId = normalizeWizzyPayloadId(groupId);
  if (!swatchEl || !normalizedGroupId) {
    return "";
  }

  swatchEl.setAttribute("data-groupid", normalizedGroupId);
  swatchEl.setAttribute("data-groupId", normalizedGroupId);
  syncWizzySwatchJqueryData(swatchEl);
  return normalizedGroupId;
}

function getWizzySiblingSizePayloadFromCard(card) {
  if (!card) {
    return [];
  }

  const payloadHost =
    card.querySelector("[data-wizzy-size-payload]") ||
    card.querySelector("product-card-variants[data-wizzy-size-payload]");
  if (!payloadHost) {
    return [];
  }

  const raw = payloadHost.getAttribute("data-wizzy-size-payload");
  if (!raw) {
    return [];
  }

  try {
    const parsed = JSON.parse(decodeURIComponent(raw));
    if (!Array.isArray(parsed)) {
      return [];
    }

    return parsed
      .map(normalizeWizzyPayloadSizeEntry)
      .filter(function (entry) {
        return entry && (entry.productId || entry.variationId);
      });
  } catch (error) {
    return [];
  }
}

function findWizzyPayloadSizeEntryWithContext(product, card, criteria) {
  if (card) {
    const cardMatch = findWizzyPayloadSizeEntryInList(
      getWizzySiblingSizePayloadFromCard(card),
      criteria
    );
    if (cardMatch) {
      return cardMatch;
    }
  }

  return findWizzyPayloadSizeEntry(product, criteria);
}

function resolveWizzySizeSwatchGroupId(swatchEl, product, card) {
  if (!swatchEl) {
    return Promise.resolve("");
  }

  const existingGroupId = normalizeWizzyPayloadId(
    swatchEl.getAttribute("data-groupid") || swatchEl.getAttribute("data-groupId")
  );
  if (existingGroupId) {
    return Promise.resolve(existingGroupId);
  }

  const isSizeSwatch = swatchEl.classList.contains("product-size__swatch-button");
  const sizeValue =
    swatchEl.querySelector(".product-size__text")?.dataset?.size ||
    swatchEl.querySelector(".product-size__text")?.textContent?.trim() ||
    "";
  const criteria = {
    value: isSizeSwatch ? sizeValue : "",
    handle: swatchEl.getAttribute("data-product-handle") || "",
    variationId:
      swatchEl.getAttribute("data-variationid") ||
      swatchEl.getAttribute("data-variation-id") ||
      "",
  };

  const match = findWizzyPayloadSizeEntryWithContext(product, card, criteria);
  if (match?.productId) {
    return Promise.resolve(normalizeWizzyPayloadId(match.productId));
  }

  const handle = criteria.handle;
  if (handle && wizzyHandleToProductIdCache.has(handle)) {
    return Promise.resolve(wizzyHandleToProductIdCache.get(handle));
  }

  if (handle) {
    return fetchWizzyProductIdByHandle(handle);
  }

  return Promise.resolve("");
}

function prefetchWizzySizeSwatchGroupIds(card, product) {
  if (!card) {
    return;
  }

  card.querySelectorAll(".product-size__swatch-button").forEach(function (swatchEl) {
    if (
      normalizeWizzyPayloadId(
        swatchEl.getAttribute("data-groupid") || swatchEl.getAttribute("data-groupId")
      )
    ) {
      syncWizzySwatchJqueryData(swatchEl);
      return;
    }

    resolveWizzySizeSwatchGroupId(swatchEl, product, card).then(function (groupId) {
      if (groupId) {
        applyGroupIdToSwatch(swatchEl, groupId);
      }
    });
  });
}

function extractWizzySiblingSizePayloadEntries(product) {
  let entries = parseRawSiblingSizePayloadFromAttributes(product);

  if (!entries.length) {
    entries = parseSiblingColorSizes(product)
      .map(normalizeWizzyPayloadSizeEntry)
      .filter(Boolean);
  }

  if (!entries.length) {
    parseSiblingColorSwatches(product).forEach(function (colorItem) {
      if (!Array.isArray(colorItem?.sizes) || !colorItem.sizes.length) {
        return;
      }

      colorItem.sizes.forEach(function (sizeItem) {
        const normalized = normalizeWizzySwatchEntry(sizeItem, {
          handle: sizeItem?.handle || colorItem?.handle || product?.productHandle,
          inStock: sizeItem?.inStock !== false,
        });
        if (normalized) {
          entries.push(normalized);
        }
      });
    });
  }

  entries = dedupeWizzySwatches(
    entries.filter(Boolean),
    function (entry) {
      return (
        normalizeWizzyPayloadId(entry.productId) +
        ":" +
        normalizeWizzyPayloadId(entry.variationId) +
        ":" +
        handleizeWizzySizeValue(entry.value)
      );
    }
  );

  return entries
    .map(normalizeWizzyPayloadSizeEntry)
    .filter(Boolean);
}

function storeWizzySiblingSizePayloadEntries(product, entries) {
  if (!entries?.length) {
    return [];
  }

  indexWizzySiblingSizePayloadEntries(entries);

  if (product && typeof product === "object") {
    product.wizzySiblingSizePayload = entries;
  }

  const groupKey = getWizzySiblingGroupKey(product);
  if (groupKey) {
    wizzySiblingSizePayloadCache.set(groupKey, entries);
  }

  const groupId = normalizeWizzyPayloadId(
    product?.groupId || product?.productId || product?.singleVarientGroupId
  );
  if (groupId) {
    wizzySiblingSizePayloadCache.set("gid:" + groupId, entries);
  }

  return entries;
}

function cacheWizzySiblingSizePayload(product) {
  const entries = extractWizzySiblingSizePayloadEntries(product);
  if (!entries.length) {
    return;
  }

  storeWizzySiblingSizePayloadEntries(product, entries);
}

function getWizzySiblingSizePayload(product) {
  if (Array.isArray(product?.wizzySiblingSizePayload) && product.wizzySiblingSizePayload.length) {
    return product.wizzySiblingSizePayload;
  }

  const groupKey = getWizzySiblingGroupKey(product);
  if (groupKey && wizzySiblingSizePayloadCache.has(groupKey)) {
    return wizzySiblingSizePayloadCache.get(groupKey);
  }

  const groupId = normalizeWizzyPayloadId(
    product?.groupId || product?.productId || product?.singleVarientGroupId
  );
  if (groupId && wizzySiblingSizePayloadCache.has("gid:" + groupId)) {
    return wizzySiblingSizePayloadCache.get("gid:" + groupId);
  }

  const entries = extractWizzySiblingSizePayloadEntries(product);
  if (entries.length) {
    return storeWizzySiblingSizePayloadEntries(product, entries);
  }

  if (groupKey && wizzySiblingSizePayloadCache.has(groupKey)) {
    return wizzySiblingSizePayloadCache.get(groupKey);
  }

  return [];
}

function findWizzyPayloadSizeEntryInList(payload, criteria) {
  criteria = criteria || {};
  if (!payload?.length) {
    return null;
  }

  const handle = normalizeWizzyPayloadId(criteria.handle);
  const productId = normalizeWizzyPayloadId(criteria.productId || criteria.groupId);
  const variationId = normalizeWizzyPayloadId(criteria.variationId);
  const sizeKey = criteria.value
    ? handleizeWizzySizeValue(criteria.value)
    : "";

  let match = null;

  if (variationId) {
    match = payload.find(function (entry) {
      return normalizeWizzyPayloadId(entry.variationId) === variationId;
    });
    if (match) {
      return match;
    }
  }

  if (productId && variationId) {
    match = payload.find(function (entry) {
      return (
        normalizeWizzyPayloadId(entry.productId) === productId &&
        normalizeWizzyPayloadId(entry.variationId) === variationId
      );
    });
    if (match) {
      return match;
    }
  }

  if (handle) {
    match = payload.find(function (entry) {
      return normalizeWizzyPayloadId(entry.handle) === handle;
    });
    if (match) {
      return match;
    }
  }

  if (sizeKey) {
    match = payload.find(function (entry) {
      return handleizeWizzySizeValue(entry.value) === sizeKey;
    });
    if (match) {
      return match;
    }
  }

  if (productId) {
    match = payload.find(function (entry) {
      return normalizeWizzyPayloadId(entry.productId) === productId;
    });
  }

  return match || null;
}

function findWizzyPayloadSizeEntry(product, criteria) {
  criteria = criteria || {};

  const globalMatch = findWizzyPayloadSizeEntryGlobal(criteria);
  if (globalMatch) {
    return globalMatch;
  }

  const payload = getWizzySiblingSizePayload(product);
  return findWizzyPayloadSizeEntryInList(payload, criteria);
}

function hydrateWizzySizeEntriesFromPayload(product, entries) {
  const payload = getWizzySiblingSizePayload(product);
  if (!payload.length || !Array.isArray(entries) || !entries.length) {
    return entries || [];
  }

  return entries.map(function (entry) {
    if (!entry) {
      return entry;
    }

    const match = findWizzyPayloadSizeEntry(product, {
      value: entry.value,
      handle: entry.handle,
      variationId: entry.variationId,
      productId: entry.productId || entry.groupId,
    });

    if (!match) {
      return entry;
    }

    const payloadProductId = normalizeWizzyPayloadId(match.productId);
    const currentProductId = normalizeWizzyPayloadId(entry.productId || entry.groupId);

    if (!payloadProductId) {
      return entry;
    }

    const priceFields = {};
    if (
      (entry.sellingPrice === undefined ||
        entry.sellingPrice === null ||
        entry.sellingPrice === "") &&
      match.sellingPrice
    ) {
      priceFields.sellingPrice = match.sellingPrice;
    }
    if (
      (entry.price === undefined || entry.price === null || entry.price === "") &&
      match.price
    ) {
      priceFields.price = match.price;
    }

    if (currentProductId === payloadProductId) {
      if (Object.keys(priceFields).length) {
        return Object.assign({}, entry, priceFields);
      }
      return entry;
    }

    return Object.assign({}, entry, priceFields, {
      productId: payloadProductId,
      variationId:
        normalizeWizzyPayloadId(entry.variationId) ||
        normalizeWizzyPayloadId(match.variationId) ||
        null,
      handle: entry.handle || match.handle || null,
    });
  });
}

function getWizzySwatchGroupId(swatch, product) {
  const match = findWizzyPayloadSizeEntry(product, {
    value: swatch?.value,
    handle: swatch?.handle,
    variationId: swatch?.variationId,
    productId: swatch?.productId || swatch?.groupId,
  });

  if (match?.productId) {
    return normalizeWizzyPayloadId(match.productId);
  }

  const directId = normalizeWizzyPayloadId(swatch?.productId || swatch?.groupId);
  if (directId) {
    return directId;
  }

  const handle = String(swatch?.handle || "").trim();
  if (handle && wizzyHandleToProductIdCache.has(handle)) {
    return wizzyHandleToProductIdCache.get(handle);
  }

  if (swatch?.selected && product) {
    const swatchVariationId = normalizeWizzyPayloadId(swatch?.variationId);
    const cardVariationId = normalizeWizzyPayloadId(
      product.id || product.wizzySelectedVariantId || product.variationId
    );
    const cardGroupId = normalizeWizzyPayloadId(
      product.groupId || product.productId || product.singleVarientGroupId
    );

    if (
      cardGroupId &&
      swatchVariationId &&
      (!cardVariationId || swatchVariationId === cardVariationId)
    ) {
      return cardGroupId;
    }
  }

  return "";
}

function getWizzySwatchVariationId(swatch, product, options) {
  options = options || {};

  const match = findWizzyPayloadSizeEntry(product, {
    value: swatch?.value,
    handle: swatch?.handle,
    variationId: swatch?.variationId,
    productId: swatch?.productId || swatch?.groupId,
  });

  if (match?.variationId) {
    return normalizeWizzyPayloadId(match.variationId);
  }

  const directId = normalizeWizzyPayloadId(
    swatch?.variationId || swatch?.variantId || swatch?.id
  );
  if (directId) {
    return directId;
  }

  if (options.selected && options.fallbackVariantId) {
    return normalizeWizzyPayloadId(options.fallbackVariantId);
  }

  return "";
}

function ensureWizzySwatchElementData(swatchEl, product, card) {
  if (!swatchEl) {
    return;
  }

  card = card || swatchEl.closest(".wizzy-result-product");

  const isSizeSwatch = swatchEl.classList.contains("product-size__swatch-button");
  const sizeValue =
    swatchEl.querySelector(".product-size__text")?.dataset?.size ||
    swatchEl.querySelector(".product-size__text")?.textContent?.trim() ||
    "";
  const lookupCriteria = {
    value: isSizeSwatch ? sizeValue : "",
    handle: swatchEl.getAttribute("data-product-handle") || "",
    variationId:
      swatchEl.getAttribute("data-variationid") ||
      swatchEl.getAttribute("data-variation-id") ||
      "",
  };
  const match = findWizzyPayloadSizeEntryWithContext(product, card, lookupCriteria);

  if (match?.productId) {
    applyGroupIdToSwatch(swatchEl, match.productId);
  } else if (isSizeSwatch && lookupCriteria.handle) {
    const cachedHandleId = wizzyHandleToProductIdCache.get(lookupCriteria.handle);
    if (cachedHandleId) {
      applyGroupIdToSwatch(swatchEl, cachedHandleId);
    }
  }

  if (match?.variationId) {
    swatchEl.setAttribute("data-variationid", match.variationId);
    swatchEl.setAttribute("data-variation-id", match.variationId);
  }
  if (match?.handle && !swatchEl.getAttribute("data-product-handle")) {
    swatchEl.setAttribute("data-product-handle", match.handle);
  }

  syncWizzySwatchJqueryData(swatchEl);
}

function syncWizzySwatchJqueryData(swatchEl) {
  if (!swatchEl || typeof window.jQuery !== "function") {
    return;
  }

  const groupId =
    swatchEl.getAttribute("data-groupid") ||
    swatchEl.getAttribute("data-groupId") ||
    "";
  const variationId =
    swatchEl.getAttribute("data-variationid") ||
    swatchEl.getAttribute("data-variation-id") ||
    "";

  const $swatch = window.jQuery(swatchEl);
  $swatch.data("groupid", groupId);
  $swatch.data("groupId", groupId);
  $swatch.data("variationid", variationId);
  $swatch.data("variationId", variationId);
}

function primeWizzySearchSwatchData(root) {
  const scope = root && root.querySelectorAll ? root : document;
  scope
    .querySelectorAll(".wizzy-search-wrapper .wizzy-result-product, .wizzy-autocomplete-wrapper .wizzy-result-product")
    .forEach(function (card) {
      const product = getWizzySlpProductFromCard(card);

      prefetchWizzySizeSwatchGroupIds(card, product);
      storeWizzyCardColorStripBaseline(card);

      card
        .querySelectorAll(
          ".product-item-swatch-item.swatch__button, .product-item-swatch-item.product-size__swatch-button"
        )
        .forEach(function (swatchEl) {
          ensureWizzySwatchElementData(swatchEl, product, card);
        });
    });
}

function getWizzyAttributeValues(product, attributeId) {
  if (!product?.attributes?.length || !attributeId) {
    return [];
  }

  const attribute = product.attributes.find(function (item) {
    return item.id === attributeId;
  });
  if (!attribute?.values?.length) {
    return [];
  }

  const results = [];
  attribute.values.forEach(function (entry) {
    let value = entry?.value;
    if (Array.isArray(value)) {
      value.forEach(function (item) {
        const normalized = String(item || "").trim();
        if (normalized) {
          results.push(normalized);
        }
      });
      return;
    }

    const normalized = String(value || "").trim();
    if (normalized) {
      results.push(normalized);
    }
  });

  return results.filter(function (value, index, list) {
    return list.indexOf(value) === index;
  });
}

function getWizzyAttributeVariationEntries(product, attributeId) {
  if (!product?.attributes?.length || !attributeId) {
    return [];
  }

  const attribute = product.attributes.find(function (item) {
    return item.id === attributeId;
  });
  if (!attribute?.values?.length) {
    return [];
  }

  const entries = [];
  attribute.values.forEach(function (entry) {
    const variationId = entry?.variationId || entry?.variantId || entry?.id || null;
    let value = entry?.value;

    if (Array.isArray(value)) {
      value.forEach(function (item) {
        const normalized = String(item || "").trim();
        if (normalized) {
          entries.push({
            value: normalized,
            variationId: variationId,
            inStock: entry?.inStock !== false && entry?.available !== false,
          });
        }
      });
      return;
    }

    const normalized = String(value || "").trim();
    if (normalized) {
      entries.push({
        value: normalized,
        variationId: variationId,
        inStock: entry?.inStock !== false && entry?.available !== false,
      });
    }
  });

  return entries;
}

function normalizeWizzyColorKey(value) {
  return String(value || "")
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();
}

function parseWizzyJsonAttribute(product, attributeIds) {
  const ids = Array.isArray(attributeIds) ? attributeIds : [attributeIds];

  for (let i = 0; i < ids.length; i++) {
    const rawValues = getWizzyAttributeValues(product, ids[i]);
    if (!rawValues.length) {
      continue;
    }

    try {
      let parsed = rawValues[0];
      if (typeof parsed === "string") {
        parsed = JSON.parse(parsed);
      }
      if (Array.isArray(parsed)) {
        return parsed;
      }
      if (parsed && typeof parsed === "object") {
        return Object.values(parsed);
      }
    } catch (error) {
      continue;
    }
  }

  return null;
}

function getWizzyProductColorValue(product) {
  const candidates = [
    "product_color_custom",
    "product_Color",
    "product_color",
    "colors",
  ];

  for (let i = 0; i < candidates.length; i++) {
    const value = getAttributeValue(product, candidates[i]);
    if (value) {
      return value;
    }
  }

  const selectedColor = (product?.wizzySwatches?.colors || []).find(function (entry) {
    return entry.selected;
  });
  return selectedColor?.value || "";
}

function getWizzyCurrentSizeKey(product) {
  const sizeValue =
    getAttributeValue(product, "product_Size") ||
    getAttributeValue(product, "product_size_custom") ||
    getAttributeValue(product, "product_value_tags_size") ||
    product?.sizes?.[0]?.value ||
    "";

  return handleizeWizzySizeValue(sizeValue);
}

function getWizzyProductTypeTag(product) {
  const attrType = getAttributeValue(product, "product_value_tags_single_type");
  if (attrType) {
    const normalized = String(attrType).toLowerCase();
    if (normalized.indexOf("type-sets") > -1) {
      return "type-sets";
    }
    if (normalized.indexOf("type-single") > -1) {
      return "type-single";
    }
  }

  const tags = getWizzyProductTags(product);
  for (let i = 0; i < tags.length; i++) {
    const tag = String(tags[i] || "").toLowerCase();
    if (tag === "type-sets" || tag.indexOf("type-sets") > -1) {
      return "type-sets";
    }
    if (tag === "type-single" || tag.indexOf("type-single") > -1) {
      return "type-single";
    }
  }

  return "";
}

function findWizzySiblingSizeTierMatch(sizes, sizeKey) {
  if (!sizeKey || !Array.isArray(sizes) || !sizes.length) {
    return null;
  }

  for (let i = 0; i < sizes.length; i++) {
    const sizeEntry = sizes[i];
    if (
      handleizeWizzySizeValue(sizeEntry?.value || sizeEntry?.size || "") ===
      sizeKey
    ) {
      return sizeEntry;
    }
  }

  return null;
}

function isWizzyCurrentColorSwatchItem(product, item) {
  const currentColorKey = normalizeWizzyColorKey(getWizzyProductColorValue(product));
  const itemColorKey = normalizeWizzyColorKey(
    item?.color || item?.value || item?.label || ""
  );
  const cardProductId = String(product?.groupId || product?.id || "");

  return (
    (currentColorKey !== "" && itemColorKey === currentColorKey) ||
    (cardProductId !== "" &&
      String(item?.productId || item?.groupId || "") === cardProductId)
  );
}

/**
 * Collection parity (product-as-variant): only show sibling colors that exist
 * at the same size/type/price tier as the card being rendered.
 */
function applyWizzyPricingTierToColorSwatches(product, items) {
  if (!Array.isArray(items) || !items.length) {
    return items || [];
  }

  const sizeKey = getWizzyCurrentSizeKey(product);
  const cardPrice = parseWizzyPriceNumber(product?.sellingPrice);
  const productType = getWizzyProductTypeTag(product);

  if (!sizeKey && !Number.isFinite(cardPrice) && !productType) {
    return items;
  }

  const filtered = [];

  items.forEach(function (item) {
    if (!item || typeof item !== "object") {
      return;
    }

    const isCurrent = isWizzyCurrentColorSwatchItem(product, item);
    const sizes = Array.isArray(item.sizes) ? item.sizes : [];
    let tierMatch = null;

    if (sizeKey && sizes.length) {
      tierMatch = findWizzySiblingSizeTierMatch(sizes, sizeKey);
      if (!tierMatch && !isCurrent) {
        return;
      }
    } else if (sizeKey && !sizes.length && !isCurrent) {
      const itemSizeKey = handleizeWizzySizeValue(item?.size || "");
      if (itemSizeKey && itemSizeKey !== sizeKey) {
        return;
      }
    }

    const remapped = Object.assign({}, item);
    if (tierMatch) {
      if (tierMatch.productId) {
        remapped.productId = tierMatch.productId;
      }
      if (tierMatch.variationId) {
        remapped.variationId = tierMatch.variationId;
      }
      if (tierMatch.handle) {
        remapped.handle = tierMatch.handle;
      }
      if (tierMatch.inStock !== undefined) {
        remapped.inStock = tierMatch.inStock;
      }
      if (tierMatch.price || tierMatch.sellingPrice) {
        remapped.sellingPrice = tierMatch.sellingPrice || tierMatch.price;
      }
    }

    if (
      Number.isFinite(cardPrice) &&
      !isCurrent &&
      (remapped.sellingPrice || remapped.price)
    ) {
      const siblingPrice = parseWizzyPriceNumber(
        remapped.sellingPrice || remapped.price
      );
      if (
        Number.isFinite(siblingPrice) &&
        Math.round(siblingPrice) !== Math.round(cardPrice)
      ) {
        return;
      }
    }

    filtered.push(remapped);
  });

  return filtered.length ? filtered : items.filter(function (item) {
    return isWizzyCurrentColorSwatchItem(product, item);
  });
}

function buildWizzyGroupColorVariantMap(groupProducts) {
  const colorMap = {};

  (groupProducts || []).forEach(function (groupProduct) {
    const colorValue = getWizzyProductColorValue(groupProduct);
    const sizeValue =
      getAttributeValue(groupProduct, "product_size_custom") ||
      getAttributeValue(groupProduct, "product_value_tags_size");
    const colorKey = normalizeWizzyColorKey(colorValue || groupProduct.productHandle);
    if (!colorKey) {
      return;
    }

    if (!colorMap[colorKey]) {
      colorMap[colorKey] = {
        value: colorValue || colorKey,
        handle: groupProduct.productHandle || extractHandleFromUrl(groupProduct.url),
        variationId: groupProduct.variationId || groupProduct.id || null,
        mainImage: groupProduct.mainImage || null,
        sellingPrice: groupProduct.sellingPrice || null,
        inStock: groupProduct.inStock !== false,
        hex: null,
        sizes: [],
      };
    }

    if (sizeValue) {
      colorMap[colorKey].sizes.push({
        value: sizeValue,
        productId:
          groupProduct.groupId ||
          groupProduct.productId ||
          groupProduct.singleVarientGroupId ||
          null,
        variationId: groupProduct.variationId || groupProduct.id || null,
        handle: groupProduct.productHandle || extractHandleFromUrl(groupProduct.url),
        inStock: groupProduct.inStock !== false,
      });
    }
  });

  Object.keys(colorMap).forEach(function (colorKey) {
    colorMap[colorKey].sizes = dedupeWizzySwatches(
      colorMap[colorKey].sizes.filter(Boolean),
      function (entry) {
        return handleizeWizzySizeValue(entry.value);
      }
    );
    colorMap[colorKey].sizes.sort(function (a, b) {
      return getWizzySizeSortOrder(a.value) - getWizzySizeSortOrder(b.value);
    });
  });

  return colorMap;
}

function buildWizzyColorVariantMap(product, groupColorMap) {
  const defaults = {
    variationId: product?.variationId || product?.id || null,
    handle: product?.productHandle || extractHandleFromUrl(product?.url),
    url: product?.url || null,
    mainImage: product?.mainImage || null,
    sellingPrice: product?.sellingPrice || null,
    inStock: product?.inStock !== false,
  };

  const colorMap = groupColorMap ? Object.assign({}, groupColorMap) : {};
  const siblingEntries = applyWizzyPricingTierToColorSwatches(
    product,
    parseSiblingColorSwatches(product)
  );

  siblingEntries.forEach(function (item) {
    const colorEntry = normalizeWizzySwatchEntry(item, defaults);
    if (!colorEntry) {
      return;
    }

    const colorKey = normalizeWizzyColorKey(colorEntry.value);
    if (!colorKey) {
      return;
    }

    const existing = colorMap[colorKey] || {};
    let sizes = Array.isArray(existing.sizes) ? existing.sizes.slice() : [];

    if (Array.isArray(item?.sizes) && item.sizes.length) {
      sizes = item.sizes
        .map(function (sizeItem) {
          return normalizeWizzySwatchEntry(sizeItem, {
            handle: sizeItem?.handle || colorEntry.handle || defaults.handle,
            inStock: sizeItem?.inStock !== false,
          });
        })
        .filter(Boolean);
    } else if (Array.isArray(item?.variants) && item.variants.length) {
      sizes = item.variants
        .map(function (variantItem) {
          return normalizeWizzySwatchEntry(
            {
              value: variantItem.size || variantItem.value || variantItem.label,
              variationId: variantItem.variationId || variantItem.variantId || variantItem.id,
              inStock: variantItem.inStock,
              handle: variantItem.handle || colorEntry.handle,
              selected: variantItem.selected,
            },
            {
              handle: colorEntry.handle || defaults.handle,
              inStock: defaults.inStock,
            }
          );
        })
        .filter(Boolean);
    }

    colorMap[colorKey] = Object.assign({}, existing, colorEntry, {
      sizes: sizes,
    });
  });

  const currentColorKey = normalizeWizzyColorKey(getWizzyProductColorValue(product));
  const currentColorSizes = resolveWizzyGlobalSizeEntries(product, defaults);
  const associatedColorSizes = parseSiblingColorSizes(product);
  if (currentColorKey && associatedColorSizes.length) {
    if (!colorMap[currentColorKey]) {
      colorMap[currentColorKey] = Object.assign({}, defaults, {
        value: getWizzyProductColorValue(product) || currentColorKey,
        sizes: associatedColorSizes.slice(),
      });
    } else if (!colorMap[currentColorKey].sizes?.length) {
      colorMap[currentColorKey].sizes = associatedColorSizes.slice();
    }
  }
  const siblingHasColorSizes = siblingEntries.some(function (item) {
    return Array.isArray(item?.sizes) && item.sizes.length;
  }) || associatedColorSizes.length > 0;

  Object.keys(colorMap).forEach(function (colorKey) {
    if (!colorMap[colorKey].sizes?.length && !siblingHasColorSizes) {
      if (colorKey === currentColorKey && currentColorSizes.length) {
        colorMap[colorKey].sizes = currentColorSizes.slice();
      }
    }

    colorMap[colorKey].sizes = dedupeWizzySwatches(
      (colorMap[colorKey].sizes || []).filter(Boolean),
      function (entry) {
        return handleizeWizzySizeValue(entry.value);
      }
    );
    colorMap[colorKey].sizes.sort(function (a, b) {
      return getWizzySizeSortOrder(a.value) - getWizzySizeSortOrder(b.value);
    });
  });

  if (
    currentColorKey &&
    currentColorSizes.length &&
    !siblingHasColorSizes &&
    !colorMap[currentColorKey]
  ) {
    colorMap[currentColorKey] = Object.assign({}, defaults, {
      value: getWizzyProductColorValue(product) || currentColorKey,
      sizes: currentColorSizes.slice(),
    });
  }

  return colorMap;
}

function resolveWizzyGlobalSizeEntries(product, defaults) {
  defaults = defaults || {
    variationId: product?.variationId || product?.id || null,
    handle: product?.productHandle || extractHandleFromUrl(product?.url),
    inStock: product?.inStock !== false,
  };

  const siblingSizeEntries = parseSiblingColorSizes(product);
  if (!Array.isArray(siblingSizeEntries) || !siblingSizeEntries.length) {
    return [];
  }

  return siblingSizeEntries
    .map(function (item) {
      return normalizeWizzySwatchEntry(item, defaults);
    })
    .filter(Boolean);
}

function handleizeWizzySizeValue(value) {
  return String(value || "")
    .toLowerCase()
    .trim()
    .replace(/[_\s]+/g, "-");
}

function getWizzySizeDisplayLabel(value) {
  const key = handleizeWizzySizeValue(value);
  return WIZZY_SIZE_DISPLAY_MAP[key] || value;
}

function getWizzySizeSortOrder(value) {
  const key = handleizeWizzySizeValue(value);
  return WIZZY_SIZE_ORDER_MAP[key] !== undefined ? WIZZY_SIZE_ORDER_MAP[key] : 99;
}

function isWizzyPackSizeDropdown(label, rawValue) {
  const key = handleizeWizzySizeValue(rawValue || label || "");
  if (
    key === "pack-of-7" ||
    key === "pack-of-4" ||
    key === "small-medium-large"
  ) {
    return true;
  }

  const normalized = String(label || "").toLowerCase();
  return /pack|set of/i.test(normalized);
}

function parseSiblingAttributeArray(product, attributeIdCandidates) {
  if (!product?.attributes?.length) {
    return [];
  }

  const candidates = Array.isArray(attributeIdCandidates)
    ? attributeIdCandidates
    : [attributeIdCandidates];
  let attribute = null;

  candidates.some(function (attributeId) {
    attribute = product.attributes.find(function (item) {
      return item.id === attributeId;
    });
    return !!attribute;
  });

  if (!attribute?.values?.length) {
    return [];
  }

  const cardVariantId = String(product?.id || "");
  const cardGroupId = String(product?.groupId || product?.singleVarientGroupId || "");
  const preferredRows = [];
  const preferredRow =
    attribute.values.find(function (row) {
      return String(row?.variationId || "") === cardVariantId;
    }) ||
    attribute.values.find(function (row) {
      return String(row?.variationId || "") === cardGroupId;
    }) ||
    attribute.values[0];

  if (preferredRow) {
    preferredRows.push(preferredRow);
  }

  attribute.values.forEach(function (row) {
    if (row && preferredRows.indexOf(row) === -1) {
      preferredRows.push(row);
    }
  });

  const merged = [];
  const seen = new Set();

  preferredRows.some(function (row) {
    let raw = row?.value;
    if (Array.isArray(raw)) {
      raw = raw[0];
    }
    if (raw === null || raw === undefined || raw === "") {
      return false;
    }

    try {
      let parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
      if (!Array.isArray(parsed)) {
        parsed =
          parsed && typeof parsed === "object" ? Object.values(parsed) : [];
      }

      parsed.forEach(function (item) {
        const key = JSON.stringify(item);
        if (seen.has(key)) {
          return;
        }
        seen.add(key);
        merged.push(item);
      });

      return merged.length > 0;
    } catch (error) {
      return false;
    }
  });

  return merged;
}

function parseSiblingColorSwatches(product) {
  return parseSiblingAttributeArray(product, [
    "sibling_color_swatches",
    "Sibling Color Swatches",
    "product_sibling_color_swatches",
  ]);
}

function parseSiblingColorSizes(product) {
  try {
    const parsed = parseSiblingAttributeArray(product, [
      "sibling_color_sizes",
      "Sibling Color Sizes",
      "product_sibling_color_sizes",
      
    ]);

    if (!parsed.length) {
      return [];
    }

    return parsed
      .map(function (sizeItem) {
        return normalizeWizzySwatchEntry(sizeItem, {
          handle:
            sizeItem?.handle ||
            product?.productHandle ||
            extractHandleFromUrl(product?.url),
          inStock: sizeItem?.inStock !== false,
        });
      })
      .filter(Boolean);
  } catch (error) {
    return [];
  }
}

function remapWizzySizeEntriesForProduct(entries, product) {
  const cardProductId = String(product?.groupId || product?.productId || "");
  const cardVariationId = String(product?.id || product?.variationId || "");
  const cardHandle =
    product?.productHandle || extractHandleFromUrl(product?.url) || "";
  const currentSizeValue =
    getAttributeValue(product, "product_Size") ||
    getAttributeValue(product, "product_size_custom") ||
    getAttributeValue(product, "product_value_tags_size") ||
    product?.sizes?.[0]?.value ||
    "";

  return (entries || []).map(function (entry) {
    if (!entry) {
      return entry;
    }

    const handleMatch =
      cardHandle !== "" &&
      String(entry.handle || "") === cardHandle;
    const sizeMatch =
      currentSizeValue !== "" &&
      handleizeWizzySizeValue(entry.value) ===
        handleizeWizzySizeValue(currentSizeValue);
    const idMatch =
      cardProductId !== "" &&
      String(entry.productId || "") === cardProductId;
    const variationMatch =
      cardVariationId !== "" &&
      String(entry.variationId || "") === cardVariationId;
    const selected = !!(
      entry.selected ||
      handleMatch ||
      sizeMatch ||
      idMatch ||
      variationMatch
    );
    const remapped = Object.assign({}, entry, { selected: selected });

if (selected) {
  if (cardVariationId && !remapped.variationId) {
    remapped.variationId = cardVariationId;
  }

  if (cardHandle && !remapped.handle) {
    remapped.handle = cardHandle;
  }
}

    return remapped;
  });
}

function getWizzySwatchGroupValues(product, groupKey) {
  const swatches = product?.swatches;
  if (!swatches) {
    return [];
  }

  if (swatches[groupKey] && Array.isArray(swatches[groupKey])) {
    return swatches[groupKey];
  }

  if (Array.isArray(swatches)) {
    const group = swatches.find(function (item) {
      const key = String(item?.key || item?.id || item?.name || "").toLowerCase();
      return key === groupKey || key.includes(String(groupKey).replace(/s$/, ""));
    });
    return group?.values || [];
  }

  return [];
}

function normalizeWizzySwatchEntry(entry, defaults) {
  defaults = defaults || {};

  if (entry === null || entry === undefined || entry === "") {
    return null;
  }

  if (typeof entry !== "object") {
    const value = String(entry).trim();
    if (!value) {
      return null;
    }
    return {
      value: value,
      productId: defaults.productId || null,
      variationId: defaults.variationId || null,
      inStock: defaults.inStock !== false,
      selected: !!defaults.selected,
      hex: null,
      handle: defaults.handle || null,
      url: defaults.url || null,
      mainImage: defaults.mainImage || null,
      sellingPrice: defaults.sellingPrice || null,
    };
  }

  const rawValue =
    entry.value ||
    entry.label ||
    entry.key ||
    entry.color ||
    entry.size ||
    (Array.isArray(entry.value) ? entry.value[0] : "");
  const value = String(rawValue || "").trim();
  if (!value) {
    return null;
  }

  const swatchMeta = entry.swatch || entry.data?.swatch || {};
  let hex =
    entry.hex ||
    entry.swatchValue ||
    swatchMeta.value ||
    (Array.isArray(swatchMeta.value) ? swatchMeta.value[0] : null);

  const resolved = findHaxCode(value, hex);
  hex = resolved[0];

  return {
    value: value,
    productId:
      entry.productId ||
      entry.groupId ||
      entry.product_id ||
      entry.group_id ||
      defaults.productId ||
      null,
    variationId:
      entry.variationId ||
      entry.variantId ||
      entry.id ||
      defaults.variationId ||
      null,
    inStock: entry.inStock !== false && entry.available !== false,
    selected: !!(entry.selected || entry.isSelected || defaults.selected),
    hex: hex || null,
    handle:
      entry.handle ||
      entry.productHandle ||
      extractHandleFromUrl(entry.url) ||
      defaults.handle ||
      null,
    url: entry.url || defaults.url || null,
    mainImage: entry.mainImage || entry.image || defaults.mainImage || null,
    sellingPrice: entry.sellingPrice || entry.price || defaults.sellingPrice || null,
  };
}

function dedupeWizzySwatches(entries, keyFn) {
  const seen = new Set();
  const output = [];

  entries.forEach(function (entry) {
    if (!entry) {
      return;
    }
    const key = keyFn(entry);
    if (!key || seen.has(key)) {
      return;
    }
    seen.add(key);
    output.push(entry);
  });

  return output;
}

function getWizzySiblingGroupKey(product) {
  if (!product) {
    return "";
  }

  let collectionHandle =
    product.collectionHandle ||
    getAttributeValue(product, "product_collection_handle") ||
    "";

  if (!collectionHandle) {
    getWizzyProductTags(product).some(function (tag) {
      const normalized = String(tag || "");
      if (normalized.indexOf("collection-") === 0) {
        collectionHandle = normalized.slice("collection-".length);
        return true;
      }
      return false;
    });
  }

  return collectionHandle ? "coll:" + collectionHandle : "";
}

function getWizzyCardColorStripAnchorCacheKey(anchor) {
  if (!anchor || anchor.currentIndex < 0) {
    return "";
  }

  return (
    "anchor:" +
    (anchor.anchorScope || "wrapper") +
    ":" +
    anchor.listIndex +
    ":" +
    anchor.currentIndex
  );
}

function storeWizzyCardColorStripBaseline(card) {
  if (!card) {
    return null;
  }

  const swatches = card.querySelector(".collection-cetegory--swatches");
  if (!swatches) {
    return null;
  }

  const anchor = getWizzyCardAnchorContext(card);
  const anchorKey = getWizzyCardColorStripAnchorCacheKey(anchor);
  if (!anchorKey) {
    return null;
  }

  if (wizzyCardColorStripBaselineCache.has(anchorKey)) {
    return wizzyCardColorStripBaselineCache.get(anchorKey);
  }

  const entry = {
    html: swatches.outerHTML,
    siblingSwatches: snapshotWizzyColorSwatchesFromDom(swatches),
    orderSignature: getWizzyColorStripOrderSignature(swatches),
    anchorKey: anchorKey,
  };

  wizzyCardColorStripBaselineCache.set(anchorKey, entry);
  card.setAttribute("data-wizzy-color-strip-anchor", anchorKey);
  card.setAttribute("data-wizzy-color-strip-order", entry.orderSignature);

  wizzySiblingGroupColorOrderCache.set(
    anchorKey,
    entry.siblingSwatches.map(function (item) {
      return {
        value: item.color || "",
        productId: item.productId || "",
        variationId: item.variationId || "",
        handle: item.handle || "",
        hex: item.hex || null,
      };
    })
  );

  return entry;
}

function getWizzyCardColorStripBaseline(card, pending) {
  if (!card && pending) {
    card = findWizzyCardFromPreserve(pending);
  }

  let anchorKey =
    card?.getAttribute("data-wizzy-color-strip-anchor") ||
    getWizzyCardColorStripAnchorCacheKey(
      card ? getWizzyCardAnchorContext(card) : null
    );

  if (!anchorKey && pending) {
    anchorKey = getWizzyCardColorStripAnchorCacheKey({
      anchorScope: pending.anchorScope || "wrapper",
      listIndex: pending.listIndex,
      currentIndex: pending.currentIndex,
    });
  }

  if (anchorKey && wizzyCardColorStripBaselineCache.has(anchorKey)) {
    return wizzyCardColorStripBaselineCache.get(anchorKey);
  }

  if (pending?.html) {
    return {
      html: pending.html,
      siblingSwatches: pending.siblingSwatches || [],
      orderSignature: "",
      anchorKey: anchorKey || "",
    };
  }

  return null;
}

function cacheWizzySiblingGroupColorOrder(product, entries) {
  const groupKey = getWizzySiblingGroupKey(product);
  if (!groupKey || !entries?.length) {
    return;
  }

  wizzySiblingGroupColorOrderCache.set(
    groupKey,
    entries.map(function (entry) {
      return {
        value: entry.value || "",
        productId: String(entry.productId || ""),
        variationId: String(entry.variationId || ""),
        handle: entry.handle || "",
        hex: entry.hex || null,
      };
    })
  );
}

function reorderWizzyColorEntriesToMatch(cachedOrder, entries) {
  if (!cachedOrder?.length || !entries?.length) {
    return entries;
  }

  const usedIndexes = new Set();
  const ordered = [];

  cachedOrder.forEach(function (cached) {
    const cachedColorKey = normalizeWizzyColorKey(cached.value || cached.color || "");
    const cachedHandle = String(cached.handle || "");
    const cachedProductId = String(cached.productId || "");

    let matchIndex = -1;
    entries.some(function (entry, index) {
      if (usedIndexes.has(index)) {
        return false;
      }

      if (
        cachedColorKey &&
        normalizeWizzyColorKey(entry.value) === cachedColorKey
      ) {
        matchIndex = index;
        return true;
      }
      if (cachedHandle && String(entry.handle || "") === cachedHandle) {
        matchIndex = index;
        return true;
      }
      if (
        cachedProductId &&
        String(entry.productId || "") === cachedProductId
      ) {
        matchIndex = index;
        return true;
      }
      return false;
    });

    if (matchIndex > -1) {
      ordered.push(entries[matchIndex]);
      usedIndexes.add(matchIndex);
    }
  });

  entries.forEach(function (entry, index) {
    if (!usedIndexes.has(index)) {
      ordered.push(entry);
    }
  });

  return ordered.length ? ordered : entries;
}

function resolveWizzyColorSwatches(product) {
  const preserve = window.__wizzySwatchPreserve;
  if (
    preserve?.siblingSwatches?.length &&
    shouldUseWizzySwatchPreserveForProduct(product)
  ) {
    return buildWizzyColorEntriesFromPreserve(product, preserve);
  }

  const defaults = {
    variationId: product?.variationId || product?.id || null,
    handle: product?.productHandle || extractHandleFromUrl(product?.url),
    url: product?.url || null,
    mainImage: product?.mainImage || null,
    sellingPrice: product?.sellingPrice || null,
  };

  let entries = applyWizzyPricingTierToColorSwatches(
    product,
    parseSiblingColorSwatches(product)
  ).map(function (item) {
    return normalizeWizzySwatchEntry(item, defaults);
  });

  if (!entries.length) {
    entries = getWizzySwatchGroupValues(product, "colors").map(function (item) {
      return normalizeWizzySwatchEntry(item, defaults);
    });
  }

  if (!entries.length && Array.isArray(product?.colors)) {
    entries = product.colors.map(function (item) {
      return normalizeWizzySwatchEntry(item, defaults);
    });
  }

  if (!entries.length && Array.isArray(product?.swatches)) {
    const swatchGroup =
      product.swatches.find(function (group) {
        return group?.values?.length;
      }) || product.swatches[0];
    entries = (swatchGroup?.values || []).map(function (item) {
      return normalizeWizzySwatchEntry(item, defaults);
    });
  }

  entries = dedupeWizzySwatches(
    entries.filter(Boolean),
    function (entry) {
      return String(entry.value || "").toLowerCase();
    }
  );

  let cachedOrder = null;

  if (preserve) {
    const anchorKey = getWizzyCardColorStripAnchorCacheKey({
      anchorScope: preserve.anchorScope || "wrapper",
      listIndex: preserve.listIndex,
      currentIndex: preserve.currentIndex,
    });
    if (anchorKey) {
      cachedOrder = wizzySiblingGroupColorOrderCache.get(anchorKey);
    }
  }

  if (cachedOrder?.length && entries.length) {
    entries = reorderWizzyColorEntriesToMatch(cachedOrder, entries);
  } else if (entries.length) {
    cacheWizzySiblingGroupColorOrder(product, entries);
  }

  const currentColorKey = normalizeWizzyColorKey(getWizzyProductColorValue(product));
  const cardProductId = String(product?.groupId || product?.productId || "");
  if (entries.length && currentColorKey) {
    entries.forEach(function (entry) {
      entry.selected =
        normalizeWizzyColorKey(entry.value) === currentColorKey ||
        entry.handle === product.productHandle ||
        (cardProductId !== "" &&
          String(entry.productId || "") === cardProductId);
    });
  }

  if (entries.length && !entries.some(function (entry) {
    return entry.selected;
  })) {
    entries[0].selected = true;
  }

  const cardVariationId = String(product?.id || product?.variationId || "");
  const cardHandle =
    product?.productHandle || extractHandleFromUrl(product?.url) || "";

  entries.forEach(function (entry) {
    if (!entry.selected || !cardProductId) {
      return;
    }

    entry.productId = cardProductId;
    if (cardVariationId) {
      entry.variationId = cardVariationId;
    }
    if (cardHandle) {
      entry.handle = cardHandle;
    }
  });

  return entries;
}

function getWizzySelectedColorKey(product) {
  const colors = product?.wizzySwatches?.colors || resolveWizzyColorSwatches(product);
  const selectedColor =
    colors.find(function (entry) {
      return entry.selected;
    }) || colors[0] || null;
  return normalizeWizzyColorKey(selectedColor?.value || getWizzyProductColorValue(product));
}

function resolveWizzySizeSwatches(product, colorKey) {
  const defaults = {
    variationId: product?.variationId || product?.id || null,
    handle: product?.productHandle || extractHandleFromUrl(product?.url),
    inStock: product?.inStock !== false,
  };

  colorKey = colorKey || getWizzySelectedColorKey(product);
  const currentColorKey = normalizeWizzyColorKey(getWizzyProductColorValue(product));
  const associatedColorSizes = parseSiblingColorSizes(product);
  const siblingHasNestedColorSizes = parseSiblingColorSwatches(product).some(function (item) {
    return Array.isArray(item?.sizes) && item.sizes.length;
  });
  const siblingHasColorSizes = siblingHasNestedColorSizes || associatedColorSizes.length > 0;
  let entries = [];

  if (
    associatedColorSizes.length &&
    (!colorKey || !currentColorKey || colorKey === currentColorKey)
  ) {
    entries = associatedColorSizes.slice();
  } else {
    const colorVariant = product?.wizzyColorVariantMap?.[colorKey];
    if (colorVariant?.sizes?.length) {
      entries = colorVariant.sizes.slice();
    }
  }

  if (!entries.length && !siblingHasColorSizes) {
    entries = resolveWizzyGlobalSizeEntries(product, defaults);
  }

  entries = dedupeWizzySwatches(
    entries.filter(Boolean),
    function (entry) {
      return handleizeWizzySizeValue(entry.value);
    }
  );

  entries.sort(function (a, b) {
    return getWizzySizeSortOrder(a.value) - getWizzySizeSortOrder(b.value);
  });

  entries = remapWizzySizeEntriesForProduct(entries, product);

  if (
    entries.length &&
    !associatedColorSizes.length &&
    !siblingHasNestedColorSizes
  ) {
    const currentSizeValue =
      getAttributeValue(product, "product_size_custom") ||
      getAttributeValue(product, "product_value_tags_size");

    if (currentSizeValue) {
      entries.forEach(function (entry) {
        entry.selected =
          handleizeWizzySizeValue(entry.value) ===
          handleizeWizzySizeValue(currentSizeValue);
      });
    }
  }

  if (
    entries.length &&
    !entries.some(function (entry) {
      return entry.selected;
    })
  ) {
    const cardHandle =
      product?.productHandle || extractHandleFromUrl(product?.url) || "";
    const byHandle = cardHandle
      ? entries.find(function (entry) {
          return String(entry.handle || "") === cardHandle;
        })
      : null;

    if (byHandle) {
      byHandle.selected = true;
    } else if (Array.isArray(product?.sizes) && product.sizes[0]?.value) {
      const cardSizeKey = handleizeWizzySizeValue(product.sizes[0].value);
      const byCardSize = entries.find(function (entry) {
        return handleizeWizzySizeValue(entry.value) === cardSizeKey;
      });
      if (byCardSize) {
        byCardSize.selected = true;
      }
    }

    if (
      !entries.some(function (entry) {
        return entry.selected;
      })
    ) {
      const firstAvailable =
        entries.find(function (entry) {
          return entry.inStock !== false;
        }) || entries[0];
      if (firstAvailable) {
        firstAvailable.selected = true;
      }
    }
  }

  return hydrateWizzySizeEntriesFromPayload(product, entries);
}

var wizzySwatchPreserveClearTimer = null;
var wizzySwatchPreserveStabilityTimer = null;
var wizzySwatchObserverRestoreTimer = null;
var wizzySwatchDomRestoreLock = false;
var wizzySwatchStripObserver = null;
var wizzySwatchStripObserverConnected = false;

function getWizzyColorSwatchItemSelector() {
  return [
    ".collection-cetegory--swatches .swatch__button:not(.product-size__swatch-button)",
    ".product-item-swatch-item.swatch__button",
    ".product-item-swatch-item:not(.product-size__swatch-button)",
  ].join(", ");
}

function snapshotWizzyColorSwatchesFromDom(swatchesRoot) {
  if (!swatchesRoot) {
    return [];
  }

  return Array.from(
    swatchesRoot.querySelectorAll(getWizzyColorSwatchItemSelector())
  ).map(function (item) {
    const bg =
      item.querySelector(".swatch-background__button")?.style?.backgroundColor ||
      item.querySelector(".swatch-background__button")?.getAttribute("style") ||
      "";
    let hex = "";
    const hexMatch = String(bg).match(/#[0-9a-fA-F]{3,8}/);
    if (hexMatch) {
      hex = hexMatch[0];
    } else if (String(bg).includes("rgb")) {
      hex = String(bg).trim();
    }

    return {
      productId: item.getAttribute("data-groupid") || "",
      variationId: item.getAttribute("data-variationid") || "",
      handle: item.getAttribute("data-product-handle") || "",
      color:
        item.getAttribute("title") ||
        item.querySelector(".tooltiptext")?.textContent?.trim() ||
        "",
      hex: hex,
      inStock: !item.classList.contains("out-stock-variant"),
      selected: false,
      swatchClass: item.className,
      ariaSelected: "false",
    };
  });
}

function getWizzyCardAnchorContext(card) {
  const cardId = getWizzyCardProductId(card);

  const list = card?.closest(".wizzy-search-results-list");
  if (list) {
    const lists = Array.from(
      document.querySelectorAll(".wizzy-search-results-list")
    );
    const cards = Array.from(list.querySelectorAll(".wizzy-result-product"));
    return {
      cardId: cardId,
      anchorScope: "list",
      listIndex: lists.indexOf(list),
      currentIndex: cards.indexOf(card),
    };
  }

  const autocomplete = card?.closest(".wizzy-autocomplete-wrapper");
  if (autocomplete) {
    const autocompletes = Array.from(
      document.querySelectorAll(".wizzy-autocomplete-wrapper")
    );
    const cards = Array.from(
      autocomplete.querySelectorAll(".wizzy-result-product")
    );
    return {
      cardId: cardId,
      anchorScope: "autocomplete",
      listIndex: autocompletes.indexOf(autocomplete),
      currentIndex: cards.indexOf(card),
    };
  }

  const wrapper = card?.closest(".wizzy-search-wrapper");
  if (wrapper) {
    const cards = Array.from(
      wrapper.querySelectorAll(".wizzy-result-product")
    );
    return {
      cardId: cardId,
      anchorScope: "wrapper",
      listIndex: 0,
      currentIndex: cards.indexOf(card),
    };
  }

  return {
    cardId: cardId,
    anchorScope: "none",
    listIndex: -1,
    currentIndex: -1,
  };
}

function getWizzyCardProductId(card) {
  if (!card) {
    return "";
  }

  return (
    card.getAttribute("data-id") ||
    card.dataset?.id ||
    card.id?.replace("product-item--wizzy-", "") ||
    ""
  );
}

function findWizzyCardFromPreserve(pending) {
  if (!pending) {
    return null;
  }

  const scope = pending.anchorScope || "list";

  function cardFromContainer(container) {
    if (!container) {
      return null;
    }

    const cards = container.querySelectorAll(".wizzy-result-product");
    if (pending.currentIndex > -1 && cards[pending.currentIndex]) {
      return cards[pending.currentIndex];
    }

    if (pending.cardId) {
      const byCardId = container.querySelector(
        '.wizzy-result-product[data-id="' +
          pending.cardId +
          '"], #product-item--wizzy-' +
          pending.cardId
      );
      if (byCardId) {
        return byCardId;
      }
    }

    if (pending.groupId) {
      const cardsArray = Array.from(cards);
      const byTargetId = cardsArray.find(function (cardEl) {
        return (
          String(getWizzyCardProductId(cardEl) || "") ===
          String(pending.groupId)
        );
      });
      if (byTargetId) {
        return byTargetId;
      }
    }

    return null;
  }

  if (scope === "autocomplete") {
    const autocompletes = document.querySelectorAll(
      ".wizzy-autocomplete-wrapper"
    );
    const card = cardFromContainer(autocompletes[pending.listIndex]);
    if (card) {
      return card;
    }
  }

  if (scope === "wrapper") {
    const card = cardFromContainer(
      document.querySelector(".wizzy-search-wrapper")
    );
    if (card) {
      return card;
    }
  }

  const lists = document.querySelectorAll(".wizzy-search-results-list");
  const listCard = cardFromContainer(lists[pending.listIndex]);
  if (listCard) {
    return listCard;
  }

  let fallbackCard = null;
  lists.forEach(function (list) {
    if (fallbackCard) {
      return;
    }
    fallbackCard = cardFromContainer(list);
  });

  return fallbackCard;
}

function getWizzySelectedColorFromStrip(swatches) {
  if (!swatches) {
    return null;
  }

  return swatches.querySelector(
    '.collection-cetegory--swatches .swatch__button[aria-selected="true"], .product-item-swatch-item.swatch__button[aria-selected="true"], .product-item-swatch-item.swatch__button.swatch-selected, .product-item-swatch-item.swatch__button.selected--variant'
  );
}

function pinWizzySearchResultColorStripOrder(root) {
  const scope = root || document;
  scope
    .querySelectorAll(".wizzy-search-results-list .wizzy-result-product")
    .forEach(function (card) {
      const swatches = card.querySelector(".collection-cetegory--swatches");
      if (!swatches) {
        return;
      }

      storeWizzyCardColorStripBaseline(card);
    });
}

function scheduleWizzySearchResultColorStripPin() {
  [0, 100, 300].forEach(function (delay) {
    setTimeout(function () {
      pinWizzySearchResultColorStripOrder(document);
    }, delay);
  });
}

function getWizzyColorStripOrderSignature(stripRoot) {
  if (!stripRoot) {
    return "";
  }

  return Array.from(
    stripRoot.querySelectorAll(getWizzyColorSwatchItemSelector())
  )
    .map(function (item) {
      return (
        item.getAttribute("data-product-handle") ||
        item.getAttribute("data-groupid") ||
        item.querySelector(".tooltiptext")?.textContent?.trim() ||
        ""
      ).toLowerCase();
    })
    .join(">");
}

function isWizzyCardReadyForSwatchRestore(card, pending) {
  if (!card || !pending) {
    return false;
  }

  const swatches = card.querySelector(".collection-cetegory--swatches");
  if (!swatches) {
    return false;
  }

  if (pending.isSizeClick) {
    return true;
  }

  const cardProductId = getWizzyCardProductId(card);
  if (
    pending.cardId &&
    cardProductId &&
    String(cardProductId) !== String(pending.cardId)
  ) {
    return true;
  }

  if (
    pending.groupId &&
    cardProductId &&
    String(cardProductId) === String(pending.groupId)
  ) {
    return true;
  }

  if (pending.html) {
    const wrap = document.createElement("div");
    wrap.innerHTML = pending.html;
    const preservedStrip = wrap.firstElementChild;
    if (preservedStrip) {
      const existingOrder = getWizzyColorStripOrderSignature(swatches);
      const preservedOrder = getWizzyColorStripOrderSignature(preservedStrip);
      if (
        existingOrder &&
        preservedOrder &&
        existingOrder !== preservedOrder
      ) {
        return true;
      }
    }
  }

  return false;
}

function captureWizzySwatchPreserveFromClick(card, swatchEl) {
  if (!card || !swatchEl) {
    return null;
  }

  const isSizeClick = swatchEl.classList.contains("product-size__swatch-button");
  if (!isSizeClick && swatchEl.getAttribute("aria-selected") === "true") {
    return null;
  }

  const swatches = card.querySelector(".collection-cetegory--swatches");
  if (!swatches) {
    return null;
  }

  const anchor = getWizzyCardAnchorContext(card);
  let colorHandle = "";
  let colorGroupId = "";
  let colorVariationId = "";

  if (isSizeClick) {
    const selectedColor = getWizzySelectedColorFromStrip(swatches);
    if (selectedColor) {
      colorHandle = selectedColor.getAttribute("data-product-handle") || "";
      colorGroupId = selectedColor.getAttribute("data-groupid") || "";
      colorVariationId = selectedColor.getAttribute("data-variationid") || "";
    }
  }

  storeWizzyCardColorStripBaseline(card);
  const baseline = getWizzyCardColorStripBaseline(card, null);
  const siblingSwatches =
    baseline?.siblingSwatches?.length
      ? baseline.siblingSwatches.slice()
      : snapshotWizzyColorSwatchesFromDom(swatches);
  const colorStripHtml = baseline?.html || swatches.outerHTML;

  const clickedColor = isSizeClick
    ? ""
    : swatchEl.querySelector(".tooltiptext")?.textContent?.trim() ||
      swatchEl.getAttribute("title") ||
      "";

  const priceSnapshot = getWizzyCardInitialPriceSnapshot(card);

  return {
    html: colorStripHtml,
    siblingSwatches: siblingSwatches,
    colorStripAnchorKey: baseline?.anchorKey || "",
    priceSnapshot: priceSnapshot,
    isSizeClick: isSizeClick,
    colorHandle: colorHandle,
    colorGroupId: colorGroupId,
    colorVariationId: colorVariationId,
    clickedColor: clickedColor,
    handle: swatchEl.getAttribute("data-product-handle") || "",
    groupId: swatchEl.getAttribute("data-groupid") || "",
    variationId: swatchEl.getAttribute("data-variationid") || "",
    cardId: anchor.cardId,
    currentIndex: anchor.currentIndex,
    listIndex: anchor.listIndex,
    anchorScope: anchor.anchorScope,
    domRestoreComplete: false,
    dataApplied: false,
  };
}

function productMatchesWizzySwatchPreserve(product, preserve) {
  if (!product || !preserve) {
    return false;
  }

  const productGroupId = String(
    product.groupId || product.productId || product.singleVarientGroupId || ""
  );
  const productVariationId = String(product.id || product.variationId || "");
  const productHandle =
    product.productHandle || extractHandleFromUrl(product.url) || "";
  const preserveGroupId = String(preserve.groupId || "");
  const preserveVariationId = String(preserve.variationId || "");
  const preserveHandle = String(preserve.handle || "");

  if (preserve.isSizeClick) {
    if (
      preserveGroupId &&
      productGroupId &&
      productGroupId === preserveGroupId
    ) {
      return true;
    }
    if (
      preserveVariationId &&
      productVariationId &&
      productVariationId === preserveVariationId
    ) {
      return true;
    }
    if (
      preserve.cardId &&
      productGroupId &&
      productGroupId === String(preserve.cardId)
    ) {
      return true;
    }
    return false;
  }

  if (preserveGroupId && productGroupId && productGroupId === preserveGroupId) {
    return true;
  }

  if (
    preserveVariationId &&
    productVariationId &&
    productVariationId === preserveVariationId
  ) {
    return true;
  }

  if (
    preserveHandle &&
    productHandle &&
    String(preserveHandle) === String(productHandle)
  ) {
    return true;
  }

  if (
    preserve.cardId &&
    productGroupId &&
    preserveGroupId &&
    productGroupId === preserveGroupId &&
    productGroupId !== String(preserve.cardId)
  ) {
    return true;
  }

  if (
    productGroupId &&
    preserve.siblingSwatches?.some(function (swatch) {
      return String(swatch.productId || "") === productGroupId;
    })
  ) {
    return true;
  }

  return false;
}

function shouldUseWizzySwatchPreserveForProduct(product) {
  const preserve = window.__wizzySwatchPreserve;
  if (!preserve?.siblingSwatches?.length || !product) {
    return false;
  }

  if (productMatchesWizzySwatchPreserve(product, preserve)) {
    return true;
  }

  const productGroupId = String(
    product.groupId || product.productId || product.singleVarientGroupId || ""
  );
  if (
    !preserve.isSizeClick &&
    preserve.cardId &&
    productGroupId &&
    productGroupId !== String(preserve.cardId) &&
    preserve.siblingSwatches.some(function (swatch) {
      return String(swatch.productId || "") === productGroupId;
    })
  ) {
    return true;
  }

  return false;
}

function buildWizzyColorEntriesFromPreserve(product, preserve) {
  const cardProductId = String(product.groupId || product.productId || "");
  const cardVariationId = String(product.id || "");
  const cardHandle =
    product.productHandle || extractHandleFromUrl(product.url) || "";
  const clickedColorKey = normalizeWizzyColorKey(preserve.clickedColor || "");
  const baseline = getWizzyCardColorStripBaseline(null, preserve);
  const swatchSource =
    baseline?.siblingSwatches?.length
      ? baseline.siblingSwatches
      : preserve.siblingSwatches || [];

  return swatchSource.map(function (swatch) {
    let productId = String(swatch.productId || "");
    let variationId = String(swatch.variationId || "");
    let handle = swatch.handle || "";
    let isSelected = false;

    if (preserve.isSizeClick) {
      isSelected =
        (preserve.colorHandle &&
          String(handle) === String(preserve.colorHandle)) ||
        (preserve.colorGroupId &&
          productId === String(preserve.colorGroupId)) ||
        (preserve.colorVariationId &&
          variationId === String(preserve.colorVariationId));
    } else {
      isSelected =
        (clickedColorKey &&
          normalizeWizzyColorKey(swatch.color || "") === clickedColorKey) ||
        (preserve.handle && String(handle) === String(preserve.handle)) ||
        (preserve.groupId &&
          preserve.variationId &&
          productId === String(preserve.groupId) &&
          variationId === String(preserve.variationId)) ||
        (preserve.groupId && productId === String(preserve.groupId));
    }

    if (isSelected && cardProductId) {
      productId = cardProductId;
      if (cardVariationId) {
        variationId = cardVariationId;
      }
      if (cardHandle) {
        handle = cardHandle;
      }
    }

    return {
      value: swatch.color || "",
      productId: productId,
      variationId: variationId,
      handle: handle,
      hex: swatch.hex || null,
      inStock: swatch.inStock !== false,
      selected: isSelected,
    };
  });
}

function getWizzySwatchPreserveMarkContext(pending) {
  if (!pending) {
    return { handle: "", groupId: "", variationId: "", clickedColor: "" };
  }

  if (pending.isSizeClick) {
    return {
      handle: pending.colorHandle || "",
      groupId: pending.colorGroupId || "",
      variationId: pending.colorVariationId || "",
      clickedColor: "",
    };
  }

  return {
    handle: pending.handle || "",
    groupId: pending.groupId || "",
    variationId: pending.variationId || "",
    clickedColor: pending.clickedColor || "",
  };
}

function markWizzyColorStripSelected(swatchesRoot, clicked) {
  if (!swatchesRoot) {
    return;
  }

  const handle = String(clicked.handle || "");
  const groupId = String(clicked.groupId || "");
  const variationId = String(clicked.variationId || "");
  const clickedColorKey = normalizeWizzyColorKey(clicked.clickedColor || "");

  swatchesRoot
    .querySelectorAll(getWizzyColorSwatchItemSelector())
    .forEach(function (item) {
      const itemColor = normalizeWizzyColorKey(
        item.querySelector(".tooltiptext")?.textContent?.trim() ||
          item.getAttribute("title") ||
          ""
      );
      const byColor =
        clickedColorKey !== "" && itemColor === clickedColorKey;
      const byHandle =
        handle !== "" &&
        String(item.getAttribute("data-product-handle") || "") === handle;
      const byIds =
        groupId !== "" &&
        String(item.getAttribute("data-groupid") || "") === groupId &&
        (variationId === "" ||
          String(item.getAttribute("data-variationid") || "") === variationId);
      const isMatch = byColor || byHandle || byIds;

      item.setAttribute("aria-selected", isMatch ? "true" : "false");
      item.classList.toggle("selected--variant", isMatch);
      item.classList.toggle("swatch-selected", isMatch);
      item.classList.toggle("not--selected", !isMatch);
    });
}

function getWizzyColorStripSignature(stripRoot) {
  if (!stripRoot) {
    return "";
  }

  return Array.from(stripRoot.querySelectorAll(getWizzyColorSwatchItemSelector()))
    .map(function (item) {
      return [
        item.getAttribute("data-groupid") || "",
        item.getAttribute("data-variationid") || "",
        item.getAttribute("data-product-handle") || "",
      ].join(":");
    })
    .join("|");
}

function clearWizzySwatchPreserveSession() {
  if (wizzySwatchPreserveClearTimer) {
    clearTimeout(wizzySwatchPreserveClearTimer);
    wizzySwatchPreserveClearTimer = null;
  }
  if (wizzySwatchPreserveStabilityTimer) {
    clearTimeout(wizzySwatchPreserveStabilityTimer);
    wizzySwatchPreserveStabilityTimer = null;
  }
  if (wizzySwatchObserverRestoreTimer) {
    clearTimeout(wizzySwatchObserverRestoreTimer);
    wizzySwatchObserverRestoreTimer = null;
  }
  disconnectWizzySwatchStripObserver();
  window.__wizzySwatchPreserve = null;
}

function setWizzySwatchPreserve(pending) {
  if (!pending) {
    clearWizzySwatchPreserveSession();
    return;
  }

  window.__wizzySwatchPreserve = pending;
  connectWizzySwatchStripObserver();
}

function scheduleWizzySwatchPreserveClear() {
  if (wizzySwatchPreserveClearTimer) {
    clearTimeout(wizzySwatchPreserveClearTimer);
  }

  wizzySwatchPreserveClearTimer = setTimeout(function () {
    wizzySwatchPreserveClearTimer = null;
    clearWizzySwatchPreserveSession();
  }, 3000);
}

function ensureWizzySwatchStripObserver() {
  if (wizzySwatchStripObserver || typeof MutationObserver !== "function") {
    return;
  }

  wizzySwatchStripObserver = new MutationObserver(function (mutations) {
    if (!window.__wizzySwatchPreserve || wizzySwatchDomRestoreLock) {
      return;
    }

    const isRelevant = mutations.some(function (mutation) {
      const target = mutation.target;
      if (!target || target.nodeType !== 1) {
        return false;
      }

      return !!target.closest(
        ".wizzy-search-wrapper .wizzy-result-product, .wizzy-autocomplete-wrapper .wizzy-result-product"
      );
    });

    if (isRelevant) {
      scheduleWizzySwatchObserverRestore();
    }
  });
}

function connectWizzySwatchStripObserver() {
  ensureWizzySwatchStripObserver();
  if (!wizzySwatchStripObserver || wizzySwatchStripObserverConnected) {
    return;
  }

  document
    .querySelectorAll(".wizzy-search-wrapper, .wizzy-autocomplete-wrapper")
    .forEach(function (root) {
      wizzySwatchStripObserver.observe(root, {
        childList: true,
        subtree: true,
      });
    });
  wizzySwatchStripObserverConnected = true;
}

function disconnectWizzySwatchStripObserver() {
  if (!wizzySwatchStripObserver || !wizzySwatchStripObserverConnected) {
    return;
  }

  wizzySwatchStripObserver.disconnect();
  wizzySwatchStripObserverConnected = false;
}

function scheduleWizzySwatchObserverRestore() {
  if (!window.__wizzySwatchPreserve || wizzySwatchDomRestoreLock) {
    return;
  }

  if (wizzySwatchObserverRestoreTimer) {
    clearTimeout(wizzySwatchObserverRestoreTimer);
  }

  wizzySwatchObserverRestoreTimer = setTimeout(function () {
    wizzySwatchObserverRestoreTimer = null;
    if (window.__wizzySwatchPreserve && !wizzySwatchDomRestoreLock) {
      restoreWizzySiblingSwatchDom(false);
    }
  }, 20);
}

function scheduleWizzySwatchPreserveStabilityCheck() {
  const pending = window.__wizzySwatchPreserve;
  if (!pending) {
    return;
  }

  if (wizzySwatchPreserveStabilityTimer) {
    clearTimeout(wizzySwatchPreserveStabilityTimer);
  }

  wizzySwatchPreserveStabilityTimer = setTimeout(function () {
    wizzySwatchPreserveStabilityTimer = null;
    const activePending = window.__wizzySwatchPreserve;
    if (!activePending?.html) {
      return;
    }

    const card = findWizzyCardFromPreserve(activePending);
    const existing = card?.querySelector(".collection-cetegory--swatches");
    if (!existing) {
      scheduleWizzySwatchPreserveStabilityCheck();
      return;
    }

    const wrap = document.createElement("div");
    wrap.innerHTML = activePending.html;
    const restored = wrap.firstElementChild;
    if (!restored) {
      clearWizzySwatchPreserveSession();
      return;
    }

    const preservedOrder = getWizzyColorStripOrderSignature(restored);
    const existingOrder = getWizzyColorStripOrderSignature(existing);

    if (existingOrder !== preservedOrder) {
      restoreWizzySiblingSwatchDom(false);
      return;
    }

    activePending.domRestoreComplete = true;
    if (activePending.dataApplied) {
      scheduleWizzySwatchPreserveClear();
    }
  }, 280);
}

function extractWizzyProductsFromEventData(data) {
  if (Array.isArray(data)) {
    return data;
  }
  if (Array.isArray(data?.payload?.result)) {
    return data.payload.result;
  }
  if (data?.payload?.result && typeof data.payload.result === "object") {
    return [data.payload.result];
  }
  if (Array.isArray(data?.products)) {
    return data.products;
  }
  return null;
}

function finalizeWizzySearchProductVariants(product, groupColorMap) {
  if (!product) {
    return product;
  }

  product.productHandle =
    product.productHandle || extractHandleFromUrl(product.url);
  product.productId =
    product.groupId || product.singleVarientGroupId || product.id || "";
  product.productPath = product.productHandle
    ? `/products/${product.productHandle}`
    : product.url || "#";
  product.collectionHandle =
    getAttributeValue(product, "product_collection_handle") ||
    getWizzySiblingGroupKey(product).replace(/^coll:/, "") ||
    "";

  enrichWizzyProductRating(product);
  enrichWizzyProductSwatches(product, groupColorMap);
  applyWizzySwatchPreserveToProduct(product, {
    forceApply: shouldUseWizzySwatchPreserveForProduct(product),
  });

  const hasColorSwatches = (product.wizzySwatches?.colors || []).length > 0;
  const hasSizeSwatches = (product.wizzySwatches?.sizes || []).length > 0;
  product.hasColorSwatches = hasColorSwatches;
  product.hasSizeSwatches = hasSizeSwatches;
  product.nativeSwatchesHtml = hasColorSwatches
    ? buildWizzyVariantSelectorsHtml(product)
    : "";
  product.nativeSizeSwatchesHtml =
    !hasColorSwatches && hasSizeSwatches
      ? buildWizzySizeSwatchesHtml(product)
      : "";

  return product;
}

function applyWizzySwatchPreserveToProduct(product, options) {
  const preserve = window.__wizzySwatchPreserve;
  if (!preserve?.siblingSwatches?.length || !product) {
    return product;
  }

  const forceApply = !!(options && options.forceApply);
  if (!forceApply && !shouldUseWizzySwatchPreserveForProduct(product)) {
    return product;
  }

  preserve.dataApplied = true;

  product.wizzySwatches = product.wizzySwatches || {};
  product.wizzySwatches.colors = buildWizzyColorEntriesFromPreserve(
    product,
    preserve
  );

  if (product.wizzySwatches.colors.length) {
    product.wizzySwatches.selectedColorKey = getWizzySelectedColorKey(product);
    product.wizzySwatches.sizes = resolveWizzySizeSwatches(
      product,
      product.wizzySwatches.selectedColorKey
    );
    product.wizzySelectedVariant = resolveWizzySelectedVariant(product);
    product.wizzySelectedVariantId = product.wizzySelectedVariant.variationId;
    product.wizzyAtcEnabled =
      !!product.wizzySelectedVariantId &&
      product.wizzySelectedVariant.inStock !== false;
  }

  applyWizzyPreservePriceSnapshotToProduct(product, preserve);

  if (preserve.domRestoreComplete) {
    scheduleWizzySwatchPreserveClear();
  }

  return product;
}

function resolveWizzySelectedVariant(product) {
  const colors = product?.wizzySwatches?.colors || [];
  const sizes = product?.wizzySwatches?.sizes || [];
  const selectedColor =
    colors.find(function (entry) {
      return entry.selected;
    }) || colors[0] || null;
  const selectedSize =
    sizes.find(function (entry) {
      return entry.selected;
    }) || sizes[0] || null;

  let variationId =
    selectedSize?.variationId ||
    selectedColor?.variationId ||
    product?.variationId ||
    product?.id ||
    null;

  const inStock =
    product?.inStock !== false &&
    selectedColor?.inStock !== false &&
    selectedSize?.inStock !== false;

  return {
    variationId: variationId,
    inStock: inStock,
    color: selectedColor,
    size: selectedSize,
  };
}

const WIZZY_EMPTY_STAR_SVG =
  '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13" fill="none"><path d="M10.3878 11.844L10.3879 11.8433L8.18422 10.7373C7.68392 10.4862 7.08851 10.4862 6.58821 10.7373L4.38456 11.8432C3.86182 12.1055 3.3636 11.6596 3.44072 11.2306L3.44074 11.2304L3.86119 8.88779L3.86121 8.88769C3.96096 8.33128 3.76552 7.77122 3.35408 7.38739L3.35378 7.38711L1.57293 5.72819L1.57279 5.72806C1.2307 5.40962 1.37766 4.80841 1.9349 4.73103C1.93493 4.73102 1.93495 4.73102 1.93498 4.73102L4.39798 4.38955L4.39815 4.38953C4.95363 4.31234 5.44458 3.97751 5.70246 3.47835C5.7025 3.47828 5.70254 3.4782 5.70258 3.47813L6.80432 1.34721L6.80443 1.347C7.03674 0.897207 7.73482 0.896359 7.96819 1.34736L9.06985 3.47813C9.06987 3.47816 9.06988 3.47819 9.0699 3.47822C9.06992 3.47826 9.06995 3.47831 9.06997 3.47835C9.32799 3.97778 9.81988 4.31233 10.3741 4.38951L10.3744 4.38955L12.8375 4.73102C12.8375 4.73102 12.8375 4.73102 12.8375 4.73103C13.3948 4.80841 13.5417 5.40962 13.1996 5.72806L11.4173 7.38684C11.0049 7.77042 10.8099 8.33172 10.9096 8.88769L10.9096 8.88778L11.3301 11.2304L11.3301 11.2306C11.4073 11.6599 10.9093 12.105 10.3878 11.844Z" stroke="#1C1C1C" stroke-width="1.09091"/></svg>';

const WIZZY_DROPDOWN_ICON_SVG =
  '<svg xmlns="http://www.w3.org/2000/svg" class="dropdown_icon" width="14" height="7" viewBox="0 0 14 7" fill="none"><path d="M13.2383 1.42773C10.2727 1.42773 8.17651 5.73374 8.17651 5.73374L5.99572 5.73374C5.99572 5.73374 4.33278 1.42773 0.935414 1.42773" stroke="#FF4A00" stroke-width="1.23029" stroke-miterlimit="10"/></svg>';

function getWizzyProductShopifyId(product) {
  if (!product || typeof product !== "object") {
    return "";
  }

  const candidates = [
    product.groupId,
    product.singleVarientGroupId,
    getAttributeValue(product, "product_shopify_id"),
    getAttributeValue(product, "shopify_product_id"),
    product.productId,
    product.id,
  ];

  for (let i = 0; i < candidates.length; i++) {
    const candidate = candidates[i];
    if (candidate !== undefined && candidate !== null && candidate !== "") {
      return String(candidate);
    }
  }

  return "";
}

function loadWizzyJudgeMeBadges() {
  if (!window.jdgm) {
    return false;
  }

  if (typeof window.jdgm.customBadgeInit === "function") {
    window.jdgm.customBadgeInit();
  } else if (typeof window.jdgm.loadBadges === "function") {
    window.jdgm.loadBadges();
  }

  return true;
}

function syncWizzySlpRatingFallbackVisibility() {
  document.querySelectorAll(
    ".wizzy-search-wrapper .wizzy-slp-rating, .wizzy-autocomplete-wrapper .wizzy-slp-rating"
  ).forEach(function (wrapper) {
    const judgemeHost = wrapper.querySelector(".wizzy-slp-rating__judgeme");
    const loadedBadge =
      judgemeHost &&
      (judgemeHost.querySelector(".jdgm-prev-badge.jdgm--loaded") ||
        judgemeHost.querySelector(".jdgm-prev-badge .jdgm-star") ||
        (judgemeHost.querySelector(".jdgm-prev-badge") &&
          judgemeHost.querySelector(".jdgm-prev-badge").textContent.trim().length > 0));

    wrapper.classList.toggle("is-jdgm-loaded", !!loadedBadge);
  });
}

function scheduleWizzyJudgeMeBadgesLoad() {
  const delays = [0, 100, 300, 600, 1000, 2000, 3500];

  delays.forEach(function (delay) {
    setTimeout(function () {
      loadWizzyJudgeMeBadges();
      syncWizzySlpRatingFallbackVisibility();
    }, delay);
  });

  if (window.wizzyJdgmReadyListenerAttached) {
    return;
  }

  window.wizzyJdgmReadyListenerAttached = true;

  let attempts = 0;
  const waitForJdgm = setInterval(function () {
    attempts += 1;
    if (loadWizzyJudgeMeBadges()) {
      syncWizzySlpRatingFallbackVisibility();
    }
    if (window.jdgm || attempts >= 50) {
      clearInterval(waitForJdgm);
    }
  }, 200);
}

function captureWizzyRawProductRatings(products) {
  products?.forEach(function (product) {
    if (
      product?.avgRatings !== undefined &&
      product.avgRatings !== null &&
      product.avgRatings !== ""
    ) {
      product.wizzyRawAvgRatings = product.avgRatings;
    }
  });
}

function normalizeWizzyAvgRatingValue(value) {
  const rating = parseFloat(value);
  if (!Number.isFinite(rating) || rating <= 0) {
    return NaN;
  }

  if (rating > 5) {
    return Math.round((rating / 20) * 10) / 10;
  }

  return Math.round(rating * 10) / 10;
}

function formatWizzyAvgRating(value) {
  const rating = normalizeWizzyAvgRatingValue(value);
  if (!Number.isFinite(rating) || rating <= 0) {
    return "";
  }

  return (Math.round(rating * 10) / 10).toFixed(1);
}

function resolveWizzyProductAvgRating(product) {
  if (!product || typeof product !== "object") {
    return "";
  }

  if (
    product.wizzyRawAvgRatings !== undefined &&
    product.wizzyRawAvgRatings !== null &&
    product.wizzyRawAvgRatings !== ""
  ) {
    return product.wizzyRawAvgRatings;
  }

  const reviewAttributeIds = [
    "product_reviews_rating_metafields",
    "reviews_rating_value",
    "product_reviews_average_judgeme_metafields",
    "product_reviews_average_opinew_metafields",
    "product_avg_rating",
    "avgRating",
  ];

  for (let i = 0; i < reviewAttributeIds.length; i++) {
    const value = getAttributeValue(product, reviewAttributeIds[i]);
    if (value) {
      return value;
    }
  }

  if (
    product.avgRatings !== undefined &&
    product.avgRatings !== null &&
    product.avgRatings !== ""
  ) {
    return product.avgRatings;
  }

  if (
    product.avgRating !== undefined &&
    product.avgRating !== null &&
    product.avgRating !== ""
  ) {
    return product.avgRating;
  }

  return "";
}

function buildWizzyRatingPercentStyle(avgRating) {
  const rating = normalizeWizzyAvgRatingValue(avgRating);
  if (!Number.isFinite(rating) || rating <= 0) {
    return "0%";
  }

  const percent = (rating / 5) * 100 + 2;
  return 100 - percent + "%";
}

function resolveWizzyReviewCount(product) {
  if (!product || typeof product !== "object") {
    return "";
  }

  const candidates = [
    product.totalReviews,
    getAttributeValue(product, "product_reviews_count_opinew_metafields"),
    getAttributeValue(product, "product_reviews_count_judgeme_metafields"),
    getAttributeValue(product, "reviews_count"),
    getAttributeValue(product, "product_reviews_count"),
  ];

  for (let i = 0; i < candidates.length; i++) {
    const parsed = parseInt(String(candidates[i]).replace(/[^\d]/g, ""), 10);
    if (Number.isFinite(parsed) && parsed > 0) {
      return String(parsed);
    }
  }

  return "";
}

function buildWizzyProductRatingFallbackHtml(product) {
  const displayRating = formatWizzyAvgRating(product.avgRating);
  if (!displayRating) {
    return "";
  }

  return (
    '<div class="product__rating" data-product-rating="">' +
    '<span class="rating__star" aria-hidden="true">' +
    WIZZY_EMPTY_STAR_SVG +
    " " +
    escapeHtml(displayRating) +
    "</span>" +
    "</div>"
  );
}

function buildWizzyProductRatingHtml(product) {
  const fallbackHtml = buildWizzyProductRatingFallbackHtml(product);

  if (!fallbackHtml) {
    return "";
  }

  return (
    '<span class="wizzy-slp-rating">' +
    '<span class="wizzy-slp-rating__fallback" data-wizzy-rating-fallback="true">' +
    fallbackHtml +
    "</span>" +
    "</span>"
  );
}

function enrichWizzyProductRating(product) {
  if (!product || typeof product !== "object") {
    return product;
  }

  const rawAvgRating = resolveWizzyProductAvgRating(product);
  const parsedRating = normalizeWizzyAvgRatingValue(rawAvgRating);

  product.avgRating = Number.isFinite(parsedRating) ? parsedRating : rawAvgRating;
  product.avgRatings = product.avgRating;
  product.totalReviews = resolveWizzyReviewCount(product) || product.totalReviews || "";
  product.ratingHtml = buildWizzyProductRatingHtml(product);
  product.ratingPresent =
    !!product.ratingHtml && Number.isFinite(parsedRating) && parsedRating > 0;

  if (product.ratingPresent && Number.isFinite(parsedRating)) {
    product.ratingValue = (5 - parsedRating) * 20;
  }

  return product;
}

function inheritWizzySiblingSizePayload(product) {
  if (!product || product.wizzySiblingSizePayload?.length) {
    return;
  }

  const groupId = normalizeWizzyPayloadId(
    product.groupId || product.productId || product.singleVarientGroupId
  );
  if (groupId && wizzySiblingSizePayloadCache.has("gid:" + groupId)) {
    product.wizzySiblingSizePayload = wizzySiblingSizePayloadCache.get("gid:" + groupId);
    return;
  }

  const groupKey = getWizzySiblingGroupKey(product);
  if (groupKey && wizzySiblingSizePayloadCache.has(groupKey)) {
    product.wizzySiblingSizePayload = wizzySiblingSizePayloadCache.get(groupKey);
    return;
  }

  const cardVariationId = normalizeWizzyPayloadId(product.id || product.variationId);
  if (!cardVariationId) {
    return;
  }

  let inheritedPayload = null;
  wizzySiblingSizePayloadCache.forEach(function (entries) {
    if (inheritedPayload || !Array.isArray(entries) || !entries.length) {
      return;
    }

    if (
      entries.some(function (entry) {
        return normalizeWizzyPayloadId(entry.variationId) === cardVariationId;
      })
    ) {
      inheritedPayload = entries;
    }
  });

  if (inheritedPayload) {
    product.wizzySiblingSizePayload = inheritedPayload;
  }
}

function enrichWizzyProductSwatches(product, groupColorMap) {
  if (!product || typeof product !== "object") {
    return product;
  }

  try {
    product.productHandle =
      product.productHandle || extractHandleFromUrl(product.url);

    inheritWizzySiblingSizePayload(product);
    cacheWizzySiblingSizePayload(product);
    product.wizzySiblingSizePayload = getWizzySiblingSizePayload(product);

    product.wizzyColorVariantMap = buildWizzyColorVariantMap(product, groupColorMap);

    const colors = resolveWizzyColorSwatches(product);
    if (!window.__wizzySwatchPreserve?.siblingSwatches?.length) {
      cacheWizzySiblingGroupColorOrder(product, colors);
    }
    const selectedColorKey = getWizzySelectedColorKey({
      wizzySwatches: { colors: colors },
      productHandle: product.productHandle,
    });

    product.wizzySwatches = {
      colors: colors,
      sizes: resolveWizzySizeSwatches(
        Object.assign({}, product, { wizzyColorVariantMap: product.wizzyColorVariantMap }),
        selectedColorKey
      ),
      selectedColorKey: selectedColorKey,
    };

    product.wizzySelectedVariant = resolveWizzySelectedVariant(product);
    product.wizzySelectedVariantId = product.wizzySelectedVariant.variationId;
    product.wizzyAtcEnabled =
      !!product.wizzySelectedVariantId && product.wizzySelectedVariant.inStock !== false;

    [
      product.productId,
      product.groupId,
      product.id,
      product.variationId,
      product.productHandle,
    ].forEach(function (cacheKey) {
      const normalizedKey = String(cacheKey || "").trim();
      if (normalizedKey) {
        wizzySlpProductCache.set(normalizedKey, product);
      }
    });
  } catch (error) {
    product.wizzyColorVariantMap = product.wizzyColorVariantMap || {};
    product.wizzySwatches = product.wizzySwatches || { colors: [], sizes: [] };
    product.wizzySelectedVariant = product.wizzySelectedVariant || {
      variationId: product?.id || null,
      inStock: product?.inStock !== false,
    };
    product.wizzySelectedVariantId =
      product.wizzySelectedVariantId || product?.id || null;
    product.wizzyAtcEnabled =
      product.wizzyAtcEnabled !== undefined
        ? product.wizzyAtcEnabled
        : !!product.wizzySelectedVariantId && product.inStock !== false;
  }

  return product;
}

function buildWizzyColorSwatchesHtml(product) {
  const colors = product?.wizzySwatches?.colors || [];
  if (!colors.length) {
    return "";
  }

  let html = '<div class="collection-cetegory--swatches ">';

  colors.forEach(function (swatch) {
    const selectedClass = swatch.selected ? "selected--variant swatch-selected" : "not--selected";
    const stockClass = swatch.inStock === false ? "out-stock-variant" : "swatch-in-stock";
    const handle = swatch.handle || product.productHandle || "";
    const groupId =
      normalizeWizzyPayloadId(swatch.productId || swatch.groupId) ||
      (swatch.selected
        ? normalizeWizzyPayloadId(product.groupId || product.productId)
        : "");
    const variationId = swatch.selected
      ? product.wizzySelectedVariantId || swatch.variationId || ""
      : swatch.variationId || "";
    const backgroundCss = getWizzyColorBackgroundCss(
      findHaxCode(swatch.value, swatch.hex)[0]
    );

    html += `<div class="product-item-swatch-item swatch__button ${stockClass} ${selectedClass}" data-product-handle="${escapeHtml(handle)}" data-groupid="${escapeHtml(groupId)}" data-groupId="${escapeHtml(groupId)}" data-variationid="${escapeHtml(variationId)}" data-variation-id="${escapeHtml(variationId)}" aria-selected="${swatch.selected ? "true" : "false"}">`;
    html += `<div class="swatch-background__button" style="background:${escapeHtml(backgroundCss)};">`;
    html += `<span class="icon tooltip"><span class="tooltiptext">${escapeHtml(swatch.value)}</span></span>`;
    html += "</div></div>";
  });

  html += "</div>";
  return html;
}

function buildWizzySizeSwatchesHtml(product) {
  const sizes = hydrateWizzySizeEntriesFromPayload(
    product,
    product?.wizzySwatches?.sizes || []
  );
  if (!sizes.length) {
    return "";
  }

  const selectedSize =
    sizes.find(function (entry) {
      return entry.selected;
    }) || sizes[0];
  const selectedLabel = getWizzySizeDisplayLabel(selectedSize?.value || "");
  let optionsHtml =
    '<div class="product-size-variant wizzy-product-size-variant"><div class="option_size product-size__swatch-container">';

  sizes.forEach(function (swatch) {
    const selectedClass = swatch.selected ? "selected" : "";
    const stockClass = swatch.inStock === false ? "out-of-stock" : "stock";
    const outerSelectedClass = swatch.selected
      ? "selected--variant swatch-selected"
      : "not--selected";
    const outerStockClass =
      swatch.inStock === false ? "out-stock-variant" : "swatch-in-stock";
    const handle = swatch.handle || product.productHandle || "";
    const label = getWizzySizeDisplayLabel(swatch.value);
    const order = getWizzySizeSortOrder(swatch.value);

    const sizeVariationId = getWizzySwatchVariationId(swatch, product, {
      selected: !!swatch.selected,
      fallbackVariantId: product.wizzySelectedVariantId,
    });
    let sizeGroupId = getWizzySwatchGroupId(swatch, product);

    if (!sizeGroupId && sizeVariationId) {
      const payloadMatch = findWizzyPayloadSizeEntryGlobal({
        variationId: sizeVariationId,
        value: swatch.value,
        handle: handle,
      });
      sizeGroupId = payloadMatch?.productId || "";
    }

    optionsHtml += `<div class="product-item-swatch-item swatch__button product-size__swatch-button ${outerStockClass} ${outerSelectedClass}" style="order:${order};" data-product-handle="${escapeHtml(handle)}" data-groupid="${escapeHtml(sizeGroupId)}" data-groupId="${escapeHtml(sizeGroupId)}" data-variationid="${escapeHtml(sizeVariationId)}" data-variation-id="${escapeHtml(sizeVariationId)}" aria-selected="${swatch.selected ? "true" : "false"}">`;
    optionsHtml += `<span class="product-variant-options ${selectedClass} ${stockClass}">`;
    optionsHtml += `<span class="product-size__text" data-size="${escapeHtml(swatch.value)}">${escapeHtml(label)}</span>`;
    optionsHtml += "</span></div>";
  });

  optionsHtml += "</div></div>";

  const dropdownClass = isWizzyPackSizeDropdown(
    selectedLabel,
    selectedSize?.value || ""
  )
    ? " pack-option"
    : "";

  return (
    '<div class="product-size-variants__dropdown' + dropdownClass + '">' +
    '<div class="selected-size__container">' +
    `<span class="selected-size__value">${escapeHtml(selectedLabel)}</span>` +
    WIZZY_DROPDOWN_ICON_SVG +
    "</div>" +
    '<div class="product-size-variants__dropdown__list">' +
    optionsHtml +
    "</div></div>"
  );
}

function buildWizzyVariantSelectorsHtml(product) {
  const colorHtml = buildWizzyColorSwatchesHtml(product);
  const sizeHtml = buildWizzySizeSwatchesHtml(product);

  if (!colorHtml && !sizeHtml) {
    return "";
  }

  const payloadEntries = getWizzySiblingSizePayload(product);
  const payloadAttr = payloadEntries.length
    ? ' data-wizzy-size-payload="' +
      encodeURIComponent(JSON.stringify(payloadEntries)) +
      '"'
    : "";

  let html =
    '<product-card-variants class="product-card__variants-container variant-controls"' +
    payloadAttr +
    ">";

  if (sizeHtml) {
    html += '<div class="size-selector">' + sizeHtml + "</div>";
  }

  if (colorHtml) {
    html += '<div class="color-swatches">' + colorHtml + "</div>";
  }

  html += "</product-card-variants>";
  return html;
}

function buildWizzyVariantSelectorsHtmlFromPreserve(product, preserve) {
  const baseline = getWizzyCardColorStripBaseline(null, preserve);
  const colorStripHtml = baseline?.html || preserve?.html || "";

  if (!colorStripHtml) {
    return buildWizzyVariantSelectorsHtml(product);
  }

  const sizeHtml = buildWizzySizeSwatchesHtml(product);
  const payloadEntries = getWizzySiblingSizePayload(product);
  const payloadAttr = payloadEntries.length
    ? ' data-wizzy-size-payload="' +
      encodeURIComponent(JSON.stringify(payloadEntries)) +
      '"'
    : "";

  let html =
    '<product-card-variants class="product-card__variants-container variant-controls"' +
    payloadAttr +
    ">";

  if (sizeHtml) {
    html += '<div class="size-selector">' + sizeHtml + "</div>";
  }

  html += '<div class="color-swatches">' + colorStripHtml + "</div>";
  html += "</product-card-variants>";
  return html;
}

function getWizzyCardInitialPriceSnapshot(card) {
  if (!card) {
    return null;
  }

  const stored = card.getAttribute("data-wizzy-initial-price-snapshot");
  if (stored) {
    try {
      return JSON.parse(stored);
    } catch (error) {
      /* ignore invalid snapshot */
    }
  }

  const cachedProduct = getWizzySlpProductFromCard(card);
  const snapshot = {
    sellingPrice: cachedProduct?.sellingPrice || null,
    compareAtPrice: cachedProduct?.compareAtPrice || "",
    hasCompareAtPrice: cachedProduct?.hasCompareAtPrice,
    discountPercentage: cachedProduct?.discountPercentage || "",
    price: cachedProduct?.price || null,
  };

  const priceNode = card.querySelector(".product-grid-item__price-new");
  if (priceNode?.textContent) {
    const parsedDom = parseWizzyPriceNumber(priceNode.textContent);
    if (Number.isFinite(parsedDom)) {
      snapshot.sellingPrice = parsedDom;
    }
  }

  if (snapshot.sellingPrice !== null && snapshot.sellingPrice !== undefined) {
    card.setAttribute(
      "data-wizzy-initial-price-snapshot",
      JSON.stringify(snapshot)
    );
  }

  return snapshot;
}

function applyWizzyPreservePriceSnapshotToProduct(product, preserve) {
  const snapshot = preserve?.priceSnapshot;
  if (!snapshot || !product) {
    return product;
  }

  if (
    snapshot.sellingPrice !== undefined &&
    snapshot.sellingPrice !== null &&
    snapshot.sellingPrice !== ""
  ) {
    product.sellingPrice = snapshot.sellingPrice;
  }
  if (snapshot.price !== undefined && snapshot.price !== null && snapshot.price !== "") {
    product.price = snapshot.price;
  }
  if (snapshot.compareAtPrice !== undefined) {
    product.compareAtPrice = snapshot.compareAtPrice;
  }
  if (snapshot.hasCompareAtPrice !== undefined) {
    product.hasCompareAtPrice = snapshot.hasCompareAtPrice;
  }
  if (snapshot.discountPercentage !== undefined) {
    product.discountPercentage = snapshot.discountPercentage;
  }

  return product;
}

function restoreWizzyCardInitialPriceDisplay(card, preserve) {
  const snapshot = preserve?.priceSnapshot;
  if (!card || !snapshot?.sellingPrice) {
    return;
  }

  const sellingLabel = formatWizzyPriceDisplay(snapshot.sellingPrice);
  card.querySelectorAll(".product-grid-item__price-new").forEach(function (priceNode) {
    priceNode.textContent = "₹ " + sellingLabel;
  });

  card.querySelectorAll(".product-grid-item__price s").forEach(function (compareNode) {
    if (snapshot.hasCompareAtPrice && snapshot.compareAtPrice) {
      compareNode.textContent = "₹ " + snapshot.compareAtPrice;
      compareNode.style.display = "";
    } else {
      compareNode.style.display = "none";
    }
  });

  card.querySelectorAll("[data-price-off-amount]").forEach(function (discountNode) {
    const offerWrap = discountNode.closest("[data-price-off], .product__price--off");
    if (snapshot.discountPercentage) {
      discountNode.textContent = String(snapshot.discountPercentage) + "%";
      if (offerWrap) {
        offerWrap.style.display = "";
      }
    } else if (offerWrap) {
      offerWrap.style.display = "none";
    }
  });
}

function getWizzySlpProductFromCard(card) {
  if (!card) {
    return null;
  }

  const cacheKeys = [
    card.dataset.id,
    card.getAttribute("data-id"),
    card.id?.replace("product-item--wizzy-", ""),
    card.getAttribute("data-groupid"),
    card.getAttribute("data-groupId"),
    card.dataset.groupid,
    card.dataset.groupId,
  ]
    .map(function (key) {
      return String(key || "").trim();
    })
    .filter(Boolean);

  for (let i = 0; i < cacheKeys.length; i++) {
    if (wizzySlpProductCache.has(cacheKeys[i])) {
      return wizzySlpProductCache.get(cacheKeys[i]);
    }
  }

  return null;
}

function resolveWizzySwatchSellingPrice(selectedSizeEntry, selectedColorEntry, product) {
  const candidates = [selectedSizeEntry, selectedColorEntry].filter(Boolean);

  for (let i = 0; i < candidates.length; i++) {
    const entry = candidates[i];
    if (entry.sellingPrice !== undefined && entry.sellingPrice !== null && entry.sellingPrice !== "") {
      return entry.sellingPrice;
    }
    if (entry.price !== undefined && entry.price !== null && entry.price !== "" && !entry.sellingPrice) {
      return entry.price;
    }
    const payloadMatch = findWizzyPayloadSizeEntryGlobal({
      variationId: entry.variationId,
      productId: entry.productId || entry.groupId,
      value: entry.value,
      handle: entry.handle,
    });
    if (payloadMatch?.sellingPrice) {
      return payloadMatch.sellingPrice;
    }
  }

  return product?.sellingPrice;
}

function applyWizzySlpProductToCard(card, product, options) {
  options = options || {};
  if (!card || !product) {
    return;
  }

  const selectedSize = product.wizzySelectedVariant?.size;
  const preserve = window.__wizzySwatchPreserve;

  updateWizzySlpCardVariantState(card, {
    variationId:
      product.wizzySelectedVariantId ||
      product.wizzySelectedVariant?.variationId ||
      product.id,
    inStock:
      product.wizzyAtcEnabled !== false &&
      product.inStock !== false &&
      product.wizzySelectedVariant?.inStock !== false,
    mainImage: product.mainImage,
    sizeLabel: selectedSize ? getWizzySizeDisplayLabel(selectedSize.value) : "",
    sizeValue: selectedSize?.value || "",
    updatePrice: options.updatePrice === true,
  });

  if (preserve?.priceSnapshot) {
    restoreWizzyCardInitialPriceDisplay(card, preserve);
  }

  const cacheKeys = [
    String(product.id || ""),
    String(product.groupId || product.productId || ""),
    String(card.dataset.id || card.getAttribute("data-id") || ""),
  ].filter(Boolean);

  applyWizzyPreservePriceSnapshotToProduct(product, preserve);

  cacheKeys.forEach(function (cacheKey) {
    wizzySlpProductCache.set(cacheKey, product);
  });
}

function scheduleWizzyVariationProductCardSync(data) {
  const pending = window.__wizzySwatchPreserve;
  if (!pending) {
    return;
  }

  const products = extractWizzyProductsFromEventData(data);
  if (!products?.length) {
    return;
  }

  const product =
    products.find(function (item) {
      return productMatchesWizzySwatchPreserve(item, pending);
    }) || products[0];

  if (!product) {
    return;
  }

  finalizeWizzySearchProductVariants(product, null);
  applyWizzyPreservePriceSnapshotToProduct(product, pending);

  [0, 50, 150, 350, 700].forEach(function (delay) {
    setTimeout(function () {
      const card = findWizzyCardFromPreserve(pending);
      if (!card) {
        return;
      }
      applyWizzySlpProductToCard(card, product);
      restoreWizzySiblingSwatchDom(false);
    }, delay);
  });
}

function updateWizzySlpCardVariantState(card, variantState) {
  if (!card || !variantState) {
    return;
  }

  const variantId = variantState.variationId || "";
  card.querySelectorAll('input[name="id"]').forEach(function (input) {
    input.value = variantId;
  });

  card.querySelectorAll(".wishlist-btn[data-varid]").forEach(function (button) {
    button.setAttribute("data-varid", variantId);
  });

  card.querySelectorAll("[data-atc-trigger], .product-addtocart__container [data-add-to-cart]").forEach(function (button) {
    button.disabled = !variantId || variantState.inStock === false;
  });

  if (variantState.mainImage) {
    card.querySelectorAll("[data-main-image] img, [data-product-image] img").forEach(function (image) {
      const base = String(variantState.mainImage).split("?")[0];
      image.src = base + "?width=600";
      image.srcset = base + "?width=600 600w";
    });
    card.querySelectorAll("[data-product-image-hover] img").forEach(function (image) {
      const base = String(variantState.mainImage).split("?")[0];
      image.src = base + "?width=1600";
      image.srcset = base + "?width=600 600w";
    });
  }

  if (
    variantState.updatePrice === true &&
    variantState.sellingPrice !== undefined &&
    variantState.sellingPrice !== null &&
    variantState.sellingPrice !== ""
  ) {
    const sellingLabel = formatWizzyPriceDisplay(variantState.sellingPrice);
    card.querySelectorAll(".product-grid-item__price-new").forEach(function (priceNode) {
      priceNode.textContent = "₹ " + sellingLabel;
    });
  }

  if (variantState.updatePrice === true) {
    card.querySelectorAll(".product-grid-item__price s").forEach(function (compareNode) {
      if (variantState.hasCompareAtPrice && variantState.compareAtPrice) {
        compareNode.textContent = "₹ " + variantState.compareAtPrice;
        compareNode.style.display = "";
      } else if (variantState.hasCompareAtPrice === false) {
        compareNode.style.display = "none";
      }
    });

    card.querySelectorAll("[data-price-off-amount]").forEach(function (discountNode) {
      const offerWrap = discountNode.closest("[data-price-off], .product__price--off");
      if (variantState.discountPercentage) {
        discountNode.textContent = String(variantState.discountPercentage) + "%";
        if (offerWrap) {
          offerWrap.style.display = "";
        }
      } else if (variantState.discountPercentage === "" || variantState.hasCompareAtPrice === false) {
        if (offerWrap) {
          offerWrap.style.display = "none";
        }
      }
    });
  }

  const selectedSizeLabel = card.querySelector(".selected-size__value");
  if (selectedSizeLabel && variantState.sizeLabel) {
    selectedSizeLabel.textContent = variantState.sizeLabel;
  }

  const sizeDropdown = card.querySelector(".product-size-variants__dropdown");
  if (sizeDropdown && variantState.sizeLabel) {
    sizeDropdown.classList.toggle(
      "pack-option",
      isWizzyPackSizeDropdown(variantState.sizeLabel, variantState.sizeValue || "")
    );
  }

  primeWizzySearchSwatchData(card);
}

function applyWizzySlpSwatchSelection(card, product, options) {
  options = options || {};
  if (!card || !product) {
    return;
  }

  const colors = product.wizzySwatches?.colors || [];
  let selectedColorKey = product.wizzySwatches?.selectedColorKey || getWizzySelectedColorKey(product);

  if (options.colorValue) {
    selectedColorKey = normalizeWizzyColorKey(options.colorValue);
    colors.forEach(function (entry) {
      entry.selected = normalizeWizzyColorKey(entry.value) === selectedColorKey;
    });

    const colorVariant = product.wizzyColorVariantMap?.[selectedColorKey];
    if (colorVariant) {
      if (colorVariant.mainImage) {
        product.mainImage = colorVariant.mainImage;
      }
      if (colorVariant.sellingPrice) {
        product.sellingPrice = colorVariant.sellingPrice;
      }
      if (colorVariant.handle) {
        product.productHandle = colorVariant.handle;
      }
    }
  }

  product.wizzySwatches.colors = colors;
  product.wizzySwatches.selectedColorKey = selectedColorKey;

  let sizes = product.wizzySwatches.sizes || [];
  if (options.sizeValue && !options.colorValue) {
    sizes.forEach(function (entry) {
      entry.selected =
        handleizeWizzySizeValue(entry.value) ===
        handleizeWizzySizeValue(options.sizeValue);
    });
    product.wizzySwatches.sizes = sizes;
  } else {
    product.wizzySwatches.sizes = resolveWizzySizeSwatches(product, selectedColorKey);
    sizes = product.wizzySwatches.sizes || [];

    if (options.sizeValue) {
      sizes.forEach(function (entry) {
        entry.selected =
          handleizeWizzySizeValue(entry.value) ===
          handleizeWizzySizeValue(options.sizeValue);
      });
    } else if (options.colorValue) {
      const preservedSize = options.preserveSizeValue || null;
      let matchedSize = null;
      if (preservedSize) {
        matchedSize = sizes.find(function (entry) {
          return (
            handleizeWizzySizeValue(entry.value) ===
            handleizeWizzySizeValue(preservedSize)
          );
        });
      }
      sizes.forEach(function (entry) {
        entry.selected = false;
      });
      if (matchedSize) {
        matchedSize.selected = true;
      } else {
        const firstAvailable =
          sizes.find(function (entry) {
            return entry.inStock !== false;
          }) || sizes[0];
        if (firstAvailable) {
          firstAvailable.selected = true;
        }
      }
    }
  }

  product.wizzySwatches.sizes = hydrateWizzySizeEntriesFromPayload(product, sizes);
  product.wizzySelectedVariant = resolveWizzySelectedVariant(product);
  product.wizzySelectedVariantId = product.wizzySelectedVariant.variationId;
  product.wizzyAtcEnabled =
    !!product.wizzySelectedVariantId && product.wizzySelectedVariant.inStock !== false;

  const selectedColorEntry =
    colors.find(function (entry) {
      return entry.selected;
    }) || null;
  const selectedSizeEntry =
    sizes.find(function (entry) {
      return entry.selected;
    }) || null;
  const nextGroupId =
    selectedSizeEntry?.productId ||
    selectedColorEntry?.productId ||
    product.groupId ||
    product.productId ||
    "";
  const nextVariationId =
    selectedSizeEntry?.variationId ||
    selectedColorEntry?.variationId ||
    product.wizzySelectedVariantId ||
    product.id ||
    null;

  if (nextGroupId) {
    setWizzyCardGroupId(card, nextGroupId);
    product.groupId = nextGroupId;
    product.productId = nextGroupId;
  }
  if (nextVariationId) {
    product.wizzySelectedVariantId = nextVariationId;
  }
  if (selectedSizeEntry?.handle) {
    product.productHandle = selectedSizeEntry.handle;
  } else if (selectedColorEntry?.handle) {
    product.productHandle = selectedColorEntry.handle;
  }

  const cacheKey = String(product.productId || product.id || "");
  if (cacheKey) {
    wizzySlpProductCache.set(cacheKey, product);
  }

  const variantsContainer = card.querySelector("product-card-variants");
  if (variantsContainer) {
    variantsContainer.outerHTML = buildWizzyVariantSelectorsHtml(product);
  } else {
    const colorContainer = card.querySelector(".collection-cetegory--swatches");
    if (colorContainer) {
      colorContainer.outerHTML = buildWizzyColorSwatchesHtml(product);
    }
    const sizeWrapper = card.querySelector(
      "product-size-variant, .wizzy-product-size-variant"
    );
    if (sizeWrapper) {
      sizeWrapper.outerHTML = buildWizzySizeSwatchesHtml(product);
    }
  }

  applyWizzySlpProductToCard(card, product);
}

function registerWizzySlpVariantHandlers() {
  if (wizzySlpVariantHandlersRegistered) {
    return;
  }
  wizzySlpVariantHandlersRegistered = true;

  document.addEventListener(
    "click",
    function (event) {
      const wizzyRoot = event.target.closest(
        ".wizzy-search-wrapper, .wizzy-autocomplete-wrapper"
      );
      if (!wizzyRoot) {
        return;
      }

      const swatchEl = event.target.closest(
        ".product-item-swatch-item.swatch__button"
      );
      if (!swatchEl) {
        return;
      }

      const isSizeSwatch = swatchEl.classList.contains("product-size__swatch-button");

      if (swatchEl.getAttribute("data-wizzy-swatch-reclick") === "1") {
        swatchEl.removeAttribute("data-wizzy-swatch-reclick");
        syncWizzySwatchJqueryData(swatchEl);
        return;
      }

      if (!isSizeSwatch && swatchEl.getAttribute("aria-selected") === "true") {
        return;
      }

      const card = swatchEl.closest(".wizzy-result-product");
      if (!card) {
        return;
      }

      const product = getWizzySlpProductFromCard(card);

      if (isSizeSwatch) {
        const existingGroupId = normalizeWizzyPayloadId(
          swatchEl.getAttribute("data-groupid") ||
            swatchEl.getAttribute("data-groupId")
        );

        if (!existingGroupId) {
          event.preventDefault();
          event.stopImmediatePropagation();

          resolveWizzySizeSwatchGroupId(swatchEl, product, card).then(function (
            groupId
          ) {
            if (!groupId) {
              return;
            }

            applyGroupIdToSwatch(swatchEl, groupId);
            swatchEl.setAttribute("data-wizzy-swatch-reclick", "1");

            if (typeof window.jQuery === "function") {
              window.jQuery(swatchEl).trigger("click");
            } else {
              swatchEl.click();
            }
          });
          return;
        }
      }

      ensureWizzySwatchElementData(swatchEl, product, card);

      const captured = captureWizzySwatchPreserveFromClick(card, swatchEl);
      if (captured) {
        setWizzySwatchPreserve(captured);
      }

      syncWizzyCardGroupIdFromSwatch(card, swatchEl);
    },
    true
  );
}

function restoreWizzySiblingSwatchDom(allowEarlyComplete) {
  const pending = window.__wizzySwatchPreserve;
  if (!pending?.html) {
    return true;
  }

  const card = findWizzyCardFromPreserve(pending);
  if (!card) {
    return false;
  }

  if (!isWizzyCardReadyForSwatchRestore(card, pending)) {
    return false;
  }

  const baseline = getWizzyCardColorStripBaseline(card, pending);
  const stripHtml = baseline?.html || pending.html;
  const wrap = document.createElement("div");
  wrap.innerHTML = stripHtml;
  const restored = wrap.firstElementChild;
  if (!restored) {
    clearWizzySwatchPreserveSession();
    return true;
  }

  const markContext = getWizzySwatchPreserveMarkContext(pending);
  const preservedOrder =
    baseline?.orderSignature || getWizzyColorStripOrderSignature(restored);
  const existing = card.querySelector(".collection-cetegory--swatches");

  wizzySwatchDomRestoreLock = true;
  try {
    markWizzyColorStripSelected(restored, markContext);

    if (existing) {
      const existingOrder = getWizzyColorStripOrderSignature(existing);
      const shouldForceBaseline =
        !!baseline?.html && existingOrder !== preservedOrder;
      if (shouldForceBaseline || existingOrder !== preservedOrder) {
        existing.replaceWith(restored);
        markWizzyColorStripSelected(restored, markContext);
      } else {
        markWizzyColorStripSelected(existing, markContext);
      }
    } else {
      const colorWrapper = card.querySelector(".color-swatches");
      if (colorWrapper) {
        colorWrapper.replaceChildren(restored);
        markWizzyColorStripSelected(restored, markContext);
      } else {
        const details = card.querySelector(".product-grid-item__details");
        if (details) {
          details.insertBefore(restored, details.firstChild);
        }
      }
    }
  } finally {
    wizzySwatchDomRestoreLock = false;
  }

  if (allowEarlyComplete === true && pending.isSizeClick) {
    pending.domRestoreComplete = true;
    if (pending.dataApplied) {
      scheduleWizzySwatchPreserveClear();
    }
    return true;
  }

  scheduleWizzySwatchPreserveStabilityCheck();
  return true;
}

function scheduleWizzySiblingSwatchRestore() {
  if (!window.__wizzySwatchPreserve) {
    return;
  }

  [50, 150, 350, 700, 1200].forEach(function (delay) {
    setTimeout(function () {
      if (window.__wizzySwatchPreserve) {
        restoreWizzySiblingSwatchDom(false);
      }
    }, delay);
  });

  let attempts = 0;
  const tick = function () {
    attempts += 1;
    if (restoreWizzySiblingSwatchDom(false) || attempts > 300) {
      return;
    }
    requestAnimationFrame(tick);
  };
  requestAnimationFrame(tick);
}

function applyWizzySwatchPreserveToEventProducts(data) {
  const products = extractWizzyProductsFromEventData(data);
  const preserve = window.__wizzySwatchPreserve;
  if (!products?.length || !preserve) {
    return data;
  }

  products.forEach(function (product) {
    finalizeWizzySearchProductVariants(product, null);
    applyWizzyPreservePriceSnapshotToProduct(product, preserve);
    if (shouldUseWizzySwatchPreserveForProduct(product)) {
      product.hasColorSwatches = (product.wizzySwatches?.colors || []).length > 0;
      product.hasSizeSwatches = (product.wizzySwatches?.sizes || []).length > 0;
      product.nativeSwatchesHtml = product.hasColorSwatches
        ? buildWizzyVariantSelectorsHtmlFromPreserve(product, preserve)
        : "";
      product.nativeSizeSwatchesHtml =
        !product.hasColorSwatches && product.hasSizeSwatches
          ? buildWizzySizeSwatchesHtml(product)
          : "";
    }
  });

  scheduleWizzyVariationProductCardSync(data);

  return data;
}

function registerWizzySiblingSwatchPreserve() {
  if (!window.wizzyConfig?.events) {
    return;
  }

  function getDom(el) {
    if (!el) {
      return null;
    }
    if (el.nodeType === 1) {
      return el;
    }
    if (el.jquery || el[0]) {
      return el[0];
    }
    return null;
  }

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCT_SWATCH_CLICKED,
    function (data) {
      const node = getDom(data?.element);
      if (!node) {
        return data;
      }

      const card = node.closest(".wizzy-result-product");
      if (!card) {
        return data;
      }

      const product = getWizzySlpProductFromCard(card);
      ensureWizzySwatchElementData(node, product, card);

      const captured = captureWizzySwatchPreserveFromClick(card, node);
      if (captured) {
        setWizzySwatchPreserve(captured);
      }

      syncWizzyCardGroupIdFromSwatch(card, node);

      return data;
    }
  );

  [
    "BEFORE_PRODUCTS_BY_IDS_RESULTS_RENDERED",
    "BEFORE_PRODUCTS_BY_IDS_HTML_RENDERED",
    "VIEW_RENDERED",
  ].forEach(function (eventName) {
    const eventKey = window.wizzyConfig.events.allowedEvents[eventName];
    if (!eventKey) {
      return;
    }
    window.wizzyConfig.events.registerEvent(eventKey, function (data) {
      if (
        eventName === "BEFORE_PRODUCTS_BY_IDS_RESULTS_RENDERED" ||
        eventName === "BEFORE_PRODUCTS_BY_IDS_HTML_RENDERED"
      ) {
        applyWizzySwatchPreserveToEventProducts(data);
      }
      scheduleWizzySiblingSwatchRestore();
      return data;
    });
  });

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {
      clearWizzySwatchPreserveSession();
      wizzySiblingGroupColorOrderCache.clear();
      wizzyCardColorStripBaselineCache.clear();
      wizzySiblingSizePayloadCache.clear();
      wizzyPayloadSizeByVariationId.clear();
      wizzyPayloadSizeByHandle.clear();
      wizzyPayloadSizeBySizeKey.clear();
      wizzyPayloadSizeByProductId.clear();
      wizzyHandleToProductIdCache.clear();
      wizzyHandleToProductIdPending.clear();
      return data;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {
      clearWizzySwatchPreserveSession();
      wizzySiblingGroupColorOrderCache.clear();
      wizzyCardColorStripBaselineCache.clear();
      wizzySiblingSizePayloadCache.clear();
      wizzyPayloadSizeByVariationId.clear();
      wizzyPayloadSizeByHandle.clear();
      wizzyPayloadSizeBySizeKey.clear();
      wizzyPayloadSizeByProductId.clear();
      wizzyHandleToProductIdCache.clear();
      wizzyHandleToProductIdPending.clear();
      return data;
    }
  );

  ensureWizzySwatchStripObserver();
}

function parseWizzyPriceInputValue(value) {
  if (value === null || value === undefined || value === "") {
    return null;
  }
  const normalized = String(value).replace(/[^\d.]/g, "");
  if (!normalized) {
    return null;
  }
  const parsed = parseFloat(normalized);
  return Number.isFinite(parsed) ? Math.round(parsed) : null;
}

function formatWizzyPriceRangeLabel(minVal, maxVal, rangeMin, rangeMax) {
  const symbol = window.wizzyConfig?.store?.currency?.symbol || "₹";
  const minLabel = minVal === null || minVal === undefined ? rangeMin : minVal;
  const maxLabel = maxVal === null || maxVal === undefined ? rangeMax : maxVal;
  return symbol + " " + minLabel + " - " + symbol + " " + maxLabel;
}

function syncWizzyPriceRangeSummaryLabel(rangeItem) {
  if (!rangeItem) {
    return;
  }

  const slider = rangeItem.querySelector(".wizzy-facet-range-slider");
  const rangeMax = slider ? Number(slider.dataset.max) : NaN;
  const symbol = (window.wizzyConfig?.store?.currency?.symbol || "₹").trim();
  const minLabel = 0;
  const maxLabel = Number.isFinite(rangeMax) ? Math.ceil(rangeMax) : "";
  const summaryText =
    "Apply Price " + symbol + " " + minLabel + " - " + symbol + " " + maxLabel;

  let summary = rangeItem.querySelector(".wizzy-price-range-summary");
  if (!summary) {
    rangeItem.querySelectorAll(":scope > button, :scope > span, :scope > p, :scope > label, :scope > a").forEach(function (element) {
      if (
        element.closest(".wizzy-facet-range-inputs") ||
        element.closest(".wizzy-price-input-field") ||
        element.closest(".wizzy-facet-range-slider")
      ) {
        return;
      }
      const text = (element.textContent || "").trim();
      if (/Apply Price/i.test(text)) {
        summary = element;
      }
    });
  }

  if (!summary) {
    summary = document.createElement("span");
  }

  summary.classList.add("wizzy-price-range-summary");
  summary.removeAttribute("aria-hidden");
  summary.style.display = "";
  summary.textContent = summaryText;

  const sliderEl = rangeItem.querySelector(".wizzy-facet-range-slider");
  if (sliderEl && summary.previousElementSibling !== sliderEl) {
    sliderEl.insertAdjacentElement("afterend", summary);
  } else if (!sliderEl && summary.parentElement !== rangeItem) {
    rangeItem.appendChild(summary);
  }
}

function getWizzyPriceRangeSliderValues(rangeItem) {
  const slider = rangeItem.querySelector(".wizzy-facet-range-slider");
  if (!slider) {
    return null;
  }

  if (slider.noUiSlider) {
    return slider.noUiSlider.get().map(function (value) {
      return Math.round(Number(value));
    });
  }

  const rangeMin = Number(slider.dataset.min);
  const rangeMax = Number(slider.dataset.max);
  if (!Number.isFinite(rangeMin) || !Number.isFinite(rangeMax)) {
    return null;
  }

  return [rangeMin, rangeMax];
}

function setWizzyPriceRangeInputDisplay(input, value) {
  if (!input || value === null || value === undefined) {
    return;
  }

  input.value = String(value);
  input.setAttribute("value", String(value));
}

function wrapWizzyPriceRangeInputs(rangeItem) {
  const symbol = (window.wizzyConfig?.store?.currency?.symbol || "₹").trim();
  const container = rangeItem.querySelector(".wizzy-facet-range-inputs");
  const wrappers = rangeItem.querySelectorAll(".wizzy-range-input-wrapper");
  const slider = rangeItem.querySelector(".wizzy-facet-range-slider");
  const sliderValues = getWizzyPriceRangeSliderValues(rangeItem);

  if (!wrappers.length) {
    return;
  }

  if (container) {
    container.classList.add("filter__price__fields");
  }

  wrappers.forEach(function (wrapper, index) {
    if (wrapper.dataset.wizzyPriceWrapped === "true") {
      return;
    }

    wrapper.dataset.wizzyPriceWrapped = "true";
    wrapper.classList.add(
      "wizzy-price-input-field",
      "filter__price__field",
      index === 0 ? "filter__price__from" : "filter__price__to"
    );

    const input = wrapper.querySelector("input");
    if (!input) {
      return;
    }

    if (!wrapper.querySelector(".wizzy-price-input-symbol")) {
      const symSpan = document.createElement("span");
      symSpan.className = "wizzy-price-input-symbol";
      symSpan.textContent = symbol;
      wrapper.insertBefore(symSpan, input);
    }

    input.classList.add("filter__price__input", "wizzy-price-input");
    input.removeAttribute("placeholder");

    if (!input.value && sliderValues) {
      setWizzyPriceRangeInputDisplay(input, sliderValues[index]);
    } else if (!input.value && slider) {
      const fallbackValue = index === 0 ? slider.dataset.min : slider.dataset.max;
      if (fallbackValue !== undefined && fallbackValue !== "") {
        setWizzyPriceRangeInputDisplay(input, fallbackValue);
      }
    }
  });
}

function syncWizzyPriceRangeInputsFromSlider(rangeItem) {
  if (!rangeItem) {
    return;
  }

  const inputs = rangeItem.querySelectorAll(".wizzy-facet-range-inputs input");
  if (!inputs.length) {
    return;
  }

  const values = getWizzyPriceRangeSliderValues(rangeItem);
  if (!values) {
    return;
  }

  if (inputs[0]) {
    setWizzyPriceRangeInputDisplay(inputs[0], values[0]);
  }
  if (inputs[1]) {
    setWizzyPriceRangeInputDisplay(inputs[1], values[1]);
  }
}

function applyWizzyPriceRangeFromInputs(rangeItem, shouldApply) {
  if (!rangeItem || typeof window.jQuery === "undefined") {
    return false;
  }

  const $ = window.jQuery;
  const $rangeItem = $(rangeItem);
  const $slider = $rangeItem.find(".wizzy-facet-range-slider");
  const sliderEl = $slider[0];
  const inputs = $rangeItem.find(".wizzy-facet-range-inputs input");

  if (!sliderEl?.noUiSlider || !inputs.length) {
    return false;
  }

  const rangeMin = Number($slider.data("min"));
  const rangeMax = Number($slider.data("max"));
  let minVal = parseWizzyPriceInputValue(inputs.eq(0).val());
  let maxVal = parseWizzyPriceInputValue(
    inputs.eq(1).val() !== undefined ? inputs.eq(1).val() : inputs.eq(0).val()
  );

  if (inputs.length > 1 && minVal === null) {
    minVal = rangeMin;
  }
  if (inputs.length > 1 && maxVal === null) {
    maxVal = rangeMax;
  }
  if (minVal === null) {
    minVal = rangeMin;
  }
  if (maxVal === null) {
    maxVal = rangeMax;
  }

  minVal = Math.max(rangeMin, Math.min(minVal, rangeMax));
  maxVal = Math.max(rangeMin, Math.min(maxVal, rangeMax));
  if (minVal > maxVal) {
    const swap = minVal;
    minVal = maxVal;
    maxVal = swap;
  }

  sliderEl.noUiSlider.set([minVal, maxVal]);
  syncWizzyPriceRangeInputsFromSlider(rangeItem);

  if (!shouldApply || typeof $.fn.applyWizzyFilters !== "function") {
    return true;
  }

  const handles = sliderEl.querySelectorAll(".noUi-handle");
  if (handles.length) {
    handles[handles.length - 1].dispatchEvent(
      new MouseEvent("mouseup", { bubbles: true })
    );
    handles[handles.length - 1].dispatchEvent(
      new MouseEvent("touchend", { bubbles: true })
    );
  }

  return true;
}

function bindWizzyPriceRangeSliderEvents(rangeItem) {
  const slider = rangeItem.querySelector(".wizzy-facet-range-slider");
  if (!slider?.noUiSlider || slider.dataset.wizzyPriceSliderBound === "true") {
    return;
  }

  slider.dataset.wizzyPriceSliderBound = "true";
  slider.noUiSlider.on("update", function () {
    if (!rangeItem.querySelector(".wizzy-facet-range-inputs input:focus")) {
      syncWizzyPriceRangeInputsFromSlider(rangeItem);
    }
  });
  slider.noUiSlider.on("change", function () {
    syncWizzyPriceRangeInputsFromSlider(rangeItem);
  });
}

function setupWizzyPriceRangeFilters(root) {
  const scope = root || document;
  scope.querySelectorAll(".facet-range-item").forEach(function (rangeItem) {
    if (rangeItem.dataset.wizzyPriceRangeBound === "true") {
      syncWizzyPriceRangeSummaryLabel(rangeItem);
      wrapWizzyPriceRangeInputs(rangeItem);
      bindWizzyPriceRangeSliderEvents(rangeItem);
      syncWizzyPriceRangeInputsFromSlider(rangeItem);
      return;
    }

    rangeItem.dataset.wizzyPriceRangeBound = "true";
    syncWizzyPriceRangeSummaryLabel(rangeItem);
    wrapWizzyPriceRangeInputs(rangeItem);
    bindWizzyPriceRangeSliderEvents(rangeItem);
    syncWizzyPriceRangeInputsFromSlider(rangeItem);

    rangeItem.querySelectorAll(".wizzy-facet-range-inputs input").forEach(function (input, index, inputs) {
      input.removeAttribute("readonly");
      input.removeAttribute("disabled");

      input.addEventListener("keydown", function (event) {
        if (event.key === "Enter") {
          event.preventDefault();
          applyWizzyPriceRangeFromInputs(rangeItem, true);
        }
      });

      input.addEventListener("blur", function () {
        applyWizzyPriceRangeFromInputs(rangeItem, false);
      });

      input.addEventListener("change", function () {
        applyWizzyPriceRangeFromInputs(rangeItem, index === inputs.length - 1);
      });
    });
  });
}

function scheduleWizzyPriceRangeSetup() {
  [0, 300, 800, 1500].forEach(function (delay) {
    setTimeout(function () {
      setupWizzyPriceRangeFilters(document);
    }, delay);
  });
}

function registerWizzyPriceRangeHandlers() {
  if (wizzyPriceRangeHandlersRegistered) {
    return;
  }
  wizzyPriceRangeHandlersRegistered = true;

  document.addEventListener(
    "click",
    function (event) {
      const applyButton = event.target.closest(
        ".wizzy-search-wrapper .facet-body-sellingPrice button, .wizzy-search-wrapper .facet-range-item button, .wizzy-search-wrapper [data-wizzy-price-apply]"
      );
      if (!applyButton || applyButton.classList.contains("wizzy-price-range-summary")) {
        return;
      }

      const rangeItem = applyButton.closest(".facet-range-item, .wizzy-filters-facet-block");
      if (rangeItem) {
        applyWizzyPriceRangeFromInputs(rangeItem, true);
      }
    },
    true
  );
}

var wizzyCollectionFilterHandlersRegistered = false;

const WIZZY_CLP_CLOSE_ICON =
  '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 192 192"><path d="M150 42 42 150M150 150 42 42" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>';

const WIZZY_CLP_FILTER_ICON =
  '<svg width="16" height="16" viewBox="0 0 18 18" fill="none" aria-hidden="true"><path d="M2 5h14M4.5 9h9M7 13h4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';

const WIZZY_CMB_GRID_TWO_SVG =
  '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true"><rect x="1" y="1" width="7" height="7" fill="currentColor"/><rect x="10" y="1" width="7" height="7" fill="currentColor"/><rect x="1" y="10" width="7" height="7" fill="currentColor"/><rect x="10" y="10" width="7" height="7" fill="currentColor"/></svg>';

const WIZZY_CMB_GRID_ONE_SVG =
  '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true"><rect x="1" y="1" width="16" height="7" fill="currentColor"/><rect x="1" y="10" width="16" height="7" fill="currentColor"/></svg>';

const WIZZY_CMB_SORT_SVG =
  '<svg width="16" height="16" viewBox="0 0 18 18" fill="none" aria-hidden="true"><path d="M6 3v12M6 15l-3-3M12 15V3M12 3l3 3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

const WIZZY_DESKTOP_SORT_SVG =
  '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true"><path d="M11.9766 2.97711C12.0288 2.92481 12.0909 2.88332 12.1592 2.85501C12.2274 2.8267 12.3006 2.81213 12.3746 2.81213C12.4485 2.81213 12.5217 2.8267 12.59 2.85501C12.6582 2.88332 12.7203 2.92481 12.7725 2.97711L15.0225 5.22711C15.1013 5.30578 15.1549 5.40604 15.1767 5.51522C15.1984 5.62439 15.1873 5.73756 15.1447 5.8404C15.102 5.94323 15.0299 6.03112 14.9373 6.09292C14.8447 6.15472 14.7359 6.18766 14.6246 6.18758L12.9371 6.18758L12.9371 14.6251C12.9371 14.7743 12.8778 14.9173 12.7723 15.0228C12.6668 15.1283 12.5237 15.1876 12.3746 15.1876C12.2254 15.1876 12.0823 15.1283 11.9768 15.0228C11.8713 14.9173 11.8121 14.7743 11.8121 14.6251L11.8121 6.18758L10.1246 6.18758C10.0132 6.18766 9.9044 6.15472 9.81182 6.09292C9.71923 6.03112 9.64707 5.94323 9.60446 5.8404C9.56185 5.73756 9.55071 5.62439 9.57245 5.51522C9.59419 5.40604 9.64783 5.30578 9.72659 5.22711L11.9766 2.97711ZM6.02253 15.023L8.27253 12.773C8.35128 12.6944 8.40493 12.5941 8.42667 12.4849C8.44841 12.3758 8.43727 12.2626 8.39466 12.1598C8.35205 12.0569 8.27988 11.969 8.1873 11.9072C8.09471 11.8454 7.98587 11.8125 7.87456 11.8126L6.18706 11.8126L6.18706 3.37508C6.18706 3.22589 6.12779 3.08282 6.0223 2.97733C5.91682 2.87184 5.77374 2.81258 5.62456 2.81258C5.47537 2.81258 5.3323 2.87184 5.22681 2.97733C5.12132 3.08282 5.06206 3.22589 5.06206 3.37508L5.06206 11.8126L3.37456 11.8126C3.26324 11.8125 3.1544 11.8454 3.06182 11.9072C2.96923 11.969 2.89707 12.0569 2.85446 12.1598C2.81185 12.2626 2.80071 12.3758 2.82245 12.4849C2.84419 12.5941 2.89783 12.6944 2.97659 12.773L5.22659 15.023C5.27883 15.0753 5.34087 15.1168 5.40915 15.1451C5.47744 15.1734 5.55063 15.188 5.62456 15.188C5.69848 15.188 5.77167 15.1734 5.83996 15.1451C5.90825 15.1168 5.97028 15.0753 6.02253 15.023Z" fill="black"/></svg>';

const WIZZY_CLP_ARROW_ICON =
  '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 13 14" fill="none" aria-hidden="true"><path d="M12.2011 8.18741C12.2011 8.18741 6.80632 10.014 6.80632 13.7467H4.16997C4.16997 13.5551 4.16235 13.356 4.15472 13.1495C4.14709 12.8981 4.13947 12.6368 4.13947 12.3706C4.13947 10.33 4.68351 8.44124 8.62406 8.44124V8.1899H0.720093V5.79598H8.6266V5.54464C4.67843 5.54464 4.13438 3.70067 4.13438 1.70988C4.13438 1.42619 4.14455 1.14748 4.15472 0.878724C4.16235 0.657249 4.16997 0.44075 4.17252 0.236694H6.80887C6.80887 3.49412 12.2036 5.79598 12.2036 5.79598V8.1899L12.2011 8.18741Z" fill="#FB5B23"/></svg>';

function getWizzySelectedFilterCount() {
  const source = ensureWizzySelectedFiltersRoot();
  if (source) {
    return source.querySelectorAll(".wizzy-selected-facet-list-item").length;
  }
  return 0;
}

function ensureWizzySelectedFiltersRoot() {
  const wrapper = document.querySelector(".wizzy-search-wrapper");
  if (!wrapper) {
    return null;
  }

  const blocks = wrapper.querySelectorAll(".wizzy-selected-filters");
  for (let i = 0; i < blocks.length; i++) {
    if (blocks[i].closest("[data-wizzy-mobile-applied-filters]")) {
      continue;
    }
    if (blocks[i].querySelector(".wizzy-selected-facet-list-item")) {
      return blocks[i];
    }
  }

  const chips = [];
  wrapper.querySelectorAll(".wizzy-selected-facet-list-item").forEach(function (chip) {
    if (!chip.closest("[data-wizzy-mobile-applied-filters]")) {
      chips.push(chip);
    }
  });
  if (!chips.length) {
    return null;
  }

  let list = chips[0].closest(".wizzy-selected-facet-list");
  if (!list) {
    list = document.createElement("ul");
    list.className = "wizzy-selected-facet-list";
    chips.forEach(function (chip) {
      list.appendChild(chip);
    });
  }

  const selected = document.createElement("div");
  selected.className = "wizzy-selected-filters";
  selected.innerHTML = '<div class="wizzy-filters-selected-facets-block"></div>';
  selected.querySelector(".wizzy-filters-selected-facets-block").appendChild(list);
  return selected;
}

function closeWizzyMobileFilterDrawer() {
  const closeTrigger = document.querySelector(
    ".wizzy-search-wrapper .wizzy-filters-close-btn, .wizzy-search-wrapper .wizzy-filters-bg"
  );
  if (closeTrigger) {
    closeTrigger.click();
  }
  document.body.classList.remove("wizzy-filters-overlay");
  document.querySelector(".wizzy-search-wrapper .wizzy-search-filters-left")?.classList.remove(
    "collection__filters--visible"
  );
  syncWizzySlpBackgroundScrollLock();
}

function injectWizzyCollectionFilterChrome(filtersLeft) {
  if (!filtersLeft.querySelector("[data-wizzy-clp-header]")) {
    const header = document.createElement("div");
    header.className = "collection__filters-header wizzy-clp-filters-header hidden";
    header.setAttribute("data-wizzy-clp-header", "true");
    header.innerHTML =
      '<button class="collection__filters__close" type="button" data-wizzy-clp-close>' +
      '<span class="visually-hidden">Close</span>' +
      WIZZY_CLP_CLOSE_ICON +
      "</button>" +
      '<div class="collection__filters__top">' +
      '<div class="collection__filters__title"><span data-wizzy-clp-title>Filters</span></div>' +
      '<a href="#" class="collection__filters__reset wizzy-filters-clear-all" data-wizzy-clp-clear>Clear all</a>' +
      "</div>" +
      '<div class="collection__filters__clear" data-wizzy-clp-chips></div>' +
      '<hr class="hr--full collection__filters__line">';

    const wrapper = filtersLeft.querySelector(".wizzy-search-filters-left-wrapper");
    if (wrapper) {
      filtersLeft.insertBefore(header, wrapper);
    } else {
      filtersLeft.prepend(header);
    }
  }

  if (!filtersLeft.querySelector("[data-wizzy-clp-bottom]")) {
    const bottom = document.createElement("div");
    bottom.className = "collection__filters-bottom wizzy-clp-filters-bottom";
    bottom.setAttribute("data-wizzy-clp-bottom", "true");
    bottom.innerHTML =
      '<button class="collection__filters__close-bottom btn btn--primary btn--advanced btn--advanced-width-height wizzy-apply-all-button" type="button" data-wizzy-clp-apply>' +
      "<hover-button></hover-button>Show my results" +
      WIZZY_CLP_ARROW_ICON +
      "</button>" +
      '<a href="#" class="collection__filters__reset wizzy-filters-clear-all" data-wizzy-clp-clear>Clear Filters</a>';
    filtersLeft.appendChild(bottom);
  }
}

function adaptWizzyFilterSections(filtersLeft) {
  filtersLeft.querySelectorAll(".wizzy-filters-facet-block").forEach(function (block) {
    block.classList.add("collection__filter");

    const head = block.querySelector(".wizzy-facet-head");
    if (head) {
      head.classList.add("collection__filter__title", "label-typography");
      if (!block.classList.contains("collapsed")) {
        head.classList.add("is-expanded");
      } else {
        head.classList.remove("is-expanded");
      }

      const iconHost = head.querySelector(".facet-head-right, .collection__filter__count");
      if (iconHost) {
        iconHost.querySelectorAll(".dropdown_icon").forEach(function (icon) {
          icon.remove();
        });
      }

      const activeCount = block.querySelectorAll(".wizzy-facet-list-item.active").length;
      const title = head.querySelector(".facet-head-title");
      if (title) {
        let countEl = title.querySelector(".wizzy-clp-active-count");
        if (activeCount > 0) {
          if (!countEl) {
            countEl = document.createElement("span");
            countEl.className = "wizzy-clp-active-count";
            title.appendChild(countEl);
          }
          countEl.textContent = " (" + activeCount + ")";
        } else if (countEl) {
          countEl.remove();
        }
      }
    }

    const list = block.querySelector(".wizzy-facet-list");
    if (list) {
      list.classList.add("collection__filter-tags");
      const isColor =
        block.getAttribute("data-key") === "product_Color" ||
        block.getAttribute("data-key") === "colors" ||
        !!block.querySelector(".facet-body-product_Color, .facet-body-colors, .wizzy-color-filter-item");
      if (isColor) {
        list.classList.add(
          "collection__filter-tags--swatches",
          "collection__filter-tags--swatches-rectangle"
        );
      }
    }

    block.querySelectorAll(".wizzy-facet-list-item").forEach(function (item) {
      if (item.classList.contains("facet-range-item")) {
        item.classList.add("filter__price");
        return;
      }
      item.classList.add("collection__filter-tag");
      if (item.classList.contains("wizzy-color-filter-item")) {
        item.classList.add("collection__filter-tag--swatch");
        item.classList.remove("collection__filter-tag--default");
      } else {
        item.classList.add("collection__filter-tag--default");
        item.classList.remove("collection__filter-tag--swatch");
      }
      if (item.classList.contains("active")) {
        item.classList.add("is-active");
      } else {
        item.classList.remove("is-active");
      }
    });
  });
}

var wizzyAppliedFiltersResizeBound = false;
var wizzyAppliedFiltersObserverBound = false;
var wizzyAppliedFiltersSyncTimer = null;

function syncWizzySlpBackgroundScrollLock() {
  if (!document.querySelector(".wizzy-search-wrapper") || window.innerWidth >= 768) {
    return;
  }

  const filterDrawerOpen = document.body.classList.contains("wizzy-filters-overlay");
  const sortDrawerOpen = document.body.classList.contains("wizzy-sort-overlay");
  const shouldLock = filterDrawerOpen || sortDrawerOpen;
  const isLocked = document.documentElement.hasAttribute("data-wizzy-slp-scroll-locked");

  if (shouldLock) {
    if (!isLocked) {
      document.documentElement.setAttribute("data-wizzy-slp-scroll-locked", "");
    }
    // CSS (body.wizzy-filters-overlay) already blocks background scroll.
    // Theme scroll lock only allows TEXTAREA touch-move, which breaks drawer scrolling.
    if (document.documentElement.hasAttribute("data-scroll-locked")) {
      document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: true }));
    }
    refreshWizzyMobileFilterDrawerScroll();
    return;
  }

  if (!shouldLock && isLocked) {
    document.documentElement.removeAttribute("data-wizzy-slp-scroll-locked");
    document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: true }));
  }
}

function refreshWizzyMobileFilterDrawerScroll() {
  if (window.innerWidth >= 768 || !document.querySelector(".wizzy-search-wrapper")) {
    return;
  }

  const filterDrawerOpen = document.body.classList.contains("wizzy-filters-overlay");
  const sortDrawerOpen = document.body.classList.contains("wizzy-sort-overlay");

  if (!filterDrawerOpen && !sortDrawerOpen) {
    return;
  }

  if (document.documentElement.hasAttribute("data-scroll-locked")) {
    document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: true }));
  }

  const scrollTarget = filterDrawerOpen
    ? document.querySelector(
        ".wizzy-search-wrapper .wizzy-search-filters-left .wizzy-search-filters-left-wrapper"
      )
    : document.querySelector(
        ".wizzy-search-wrapper .wizzy-mobile-sort-drawer .cmb-sort-sheet__panel"
      );

  if (!scrollTarget) {
    return;
  }

  scrollTarget.style.overflowY = "auto";
  scrollTarget.style.webkitOverflowScrolling = "touch";
  scrollTarget.style.touchAction = "pan-y";
  scrollTarget.style.overscrollBehavior = "contain";
}

var wizzyMobileFilterDrawerScrollRefreshTimer = null;

function scheduleWizzyMobileFilterDrawerScrollRefresh() {
  if (wizzyMobileFilterDrawerScrollRefreshTimer) {
    clearTimeout(wizzyMobileFilterDrawerScrollRefreshTimer);
  }

  [0, 50, 180, 450].forEach(function (delay) {
    setTimeout(refreshWizzyMobileFilterDrawerScroll, delay);
  });

  wizzyMobileFilterDrawerScrollRefreshTimer = setTimeout(function () {
    wizzyMobileFilterDrawerScrollRefreshTimer = null;
  }, 500);
}

function releaseWizzyMobileScrollLockIfIdle() {
  if (!document.querySelector(".wizzy-search-wrapper") || window.innerWidth >= 768) {
    return;
  }

  syncWizzySlpBackgroundScrollLock();

  const overlayOpen =
    document.body.classList.contains("wizzy-filters-overlay") ||
    document.body.classList.contains("wizzy-sort-overlay");

  if (overlayOpen) {
    return;
  }

  if (document.documentElement.hasAttribute("data-wizzy-slp-scroll-locked")) {
    document.documentElement.removeAttribute("data-wizzy-slp-scroll-locked");
  }

  if (document.documentElement.hasAttribute("data-scroll-locked")) {
    document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: true }));
  }
}

function scheduleWizzyMobileScrollUnlockAfterFilterApply() {
  [0, 150, 450, 900].forEach(function (delay) {
    setTimeout(function () {
      closeWizzyMobileFilterDrawer();
      releaseWizzyMobileScrollLockIfIdle();
    }, delay);
  });
}

function ensureWizzyMobileAppliedFiltersHost() {
  const filtersTop = document.querySelector(
    ".wizzy-search-wrapper .wizzy-search-results-container > .wizzy-search-filters-top, .wizzy-search-wrapper .wizzy-search-filters-top"
  );
  if (!filtersTop || !filtersTop.parentNode) {
    return null;
  }

  let host = document.querySelector(".wizzy-search-wrapper [data-wizzy-mobile-applied-filters]");
  if (!host) {
    host = document.createElement("div");
    host.className = "wizzy-mobile-applied-filters";
    host.setAttribute("data-wizzy-mobile-applied-filters", "");
  }

  const summaryEl = document.querySelector(
    ".wizzy-search-wrapper .wizzy-summary-text"
  );
  const anchor =
    summaryEl && summaryEl.parentNode === filtersTop.parentNode
      ? summaryEl
      : filtersTop;

  if (host.previousElementSibling !== anchor) {
    anchor.insertAdjacentElement("afterend", host);
  }

  return host;
}

function syncWizzyMobileAppliedFiltersFromSource() {
  const source = ensureWizzySelectedFiltersRoot();
  const host = ensureWizzyMobileAppliedFiltersHost();
  if (!host) {
    return;
  }

  if (!source) {
    host.replaceChildren();
    host.classList.remove("is-visible");
    host.hidden = true;
    return;
  }

  const count = source.querySelectorAll(".wizzy-selected-facet-list-item").length;
  host.replaceChildren();
  if (count > 0) {
    host.appendChild(source.cloneNode(true));
    normalizeWizzyAppliedFilterChipLabels(host);
  }
  host.classList.toggle("is-visible", count > 0);
  host.hidden = count === 0;
}

function scheduleWizzyMobileAppliedFiltersSync() {
  if (wizzyAppliedFiltersSyncTimer) {
    clearTimeout(wizzyAppliedFiltersSyncTimer);
  }
  wizzyAppliedFiltersSyncTimer = setTimeout(function () {
    wizzyAppliedFiltersSyncTimer = null;
    if (window.innerWidth < 768 && document.querySelector(".wizzy-search-wrapper")) {
      syncWizzyMobileAppliedFiltersFromSource();
      placeWizzySummaryText();
    }
  }, 50);
}

function bindWizzyAppliedFiltersObserver() {
  if (wizzyAppliedFiltersObserverBound) {
    return;
  }
  wizzyAppliedFiltersObserverBound = true;

  const observer = new MutationObserver(function () {
    if (window.innerWidth >= 768 || !document.querySelector(".wizzy-search-wrapper")) {
      return;
    }
    if (document.querySelector(".wizzy-search-wrapper .wizzy-selected-facet-list-item")) {
      scheduleWizzyMobileAppliedFiltersSync();
    }
  });

  function attachObserver() {
    const wrapper = document.querySelector(".wizzy-search-wrapper");
    if (!wrapper || wrapper.dataset.wizzyAppliedFiltersObserved === "true") {
      return;
    }
    wrapper.dataset.wizzyAppliedFiltersObserved = "true";
    observer.observe(wrapper, { childList: true, subtree: true });
  }

  attachObserver();
  document.addEventListener("DOMContentLoaded", attachObserver);
}

function normalizeWizzyAppliedFilterChipLabels(root) {
  const scope = root || ensureWizzySelectedFiltersRoot();
  if (!scope) {
    return;
  }

  const isMobileHost = !!scope.closest("[data-wizzy-mobile-applied-filters]");

  scope.querySelectorAll(".wizzy-selected-facet-list-item").forEach(function (item) {
    if (isMobileHost) {
      let term =
        item.getAttribute("data-term") ||
        item.getAttribute("title") ||
        item.querySelector(".wizzy-selected-facet-list-item-label")?.textContent ||
        item.querySelector(".facet-item-label-value")?.textContent ||
        item.querySelector(".facet-item-label-value-id")?.textContent ||
        "";
      if (!term.trim()) {
        term = (item.textContent || "").replace(/\s*✕\s*$/, "");
      }
      const normalized = term
        .replace(/\s+/g, " ")
        .replace(/^(size|colour|color|product_color|colors)\s*:\s*/i, "")
        .trim();
      if (!normalized) {
        return;
      }

      item.querySelectorAll(
        ".wizzy-facet-item-swatch-wrapper, .facet-item-label-value-id, .wizzy-selected-facet-delete"
      ).forEach(function (el) {
        el.remove();
      });

      let labelEl = item.querySelector(".wizzy-selected-facet-list-item-label");
      if (!labelEl) {
        labelEl = document.createElement("span");
        labelEl.className = "wizzy-selected-facet-list-item-label";
        item.insertBefore(labelEl, item.firstChild);
      }
      labelEl.textContent = normalized;

      Array.from(item.childNodes).forEach(function (node) {
        if (node.nodeType === Node.TEXT_NODE) {
          item.removeChild(node);
        }
      });
      return;
    }

    let text = "";
    item.childNodes.forEach(function (node) {
      if (node.nodeType === Node.TEXT_NODE) {
        text += node.textContent;
      }
    });
    if (!text.trim()) {
      text = (item.textContent || "").replace(/\s*✕\s*$/, "");
    }
    text = text.trim();
    const normalized = text.replace(/^(colour|color|product_color|colors)\s*:\s*/i, "").trim();
    if (!normalized || normalized === text) {
      return;
    }

    Array.from(item.childNodes).forEach(function (node) {
      if (node.nodeType === Node.TEXT_NODE) {
        item.removeChild(node);
      }
    });
    item.insertBefore(document.createTextNode(normalized), item.firstChild);
  });
}

function relocateWizzySelectedFilters(filtersLeft) {
  const isMobile = window.innerWidth < 768;

  if (isMobile) {
    syncWizzyMobileAppliedFiltersFromSource();
    placeWizzySummaryText();
    return;
  }

  const selected = ensureWizzySelectedFiltersRoot();
  const target = filtersLeft?.querySelector("[data-wizzy-clp-chips]");
  const host = document.querySelector(".wizzy-search-wrapper [data-wizzy-mobile-applied-filters]");

  if (host) {
    host.replaceChildren();
    host.classList.remove("is-visible");
    host.hidden = true;
  }

  if (!selected || !target) {
    return;
  }

  if (selected.parentElement !== target) {
    target.appendChild(selected);
  }

  normalizeWizzyAppliedFilterChipLabels(selected);
}

function bindWizzyAppliedFiltersResize() {
  if (wizzyAppliedFiltersResizeBound) {
    return;
  }
  wizzyAppliedFiltersResizeBound = true;
  window.addEventListener("resize", function () {
    const filtersLeft = document.querySelector(".wizzy-search-wrapper .wizzy-search-filters-left");
    if (filtersLeft) {
      relocateWizzySelectedFilters(filtersLeft);
      placeWizzySummaryText();
    }
  });
}

function syncWizzyCollectionFilterChrome(filtersLeft) {
  const count = getWizzySelectedFilterCount();
  const header = filtersLeft.querySelector("[data-wizzy-clp-header]");
  const bottom = filtersLeft.querySelector("[data-wizzy-clp-bottom]");
  const title = filtersLeft.querySelector("[data-wizzy-clp-title]");
  const isMobile = window.innerWidth < 768;

  if (title) {
    title.textContent = count > 0 ? "Filters (" + count + ")" : "Filters";
  }

  filtersLeft.querySelectorAll("[data-wizzy-clp-clear]").forEach(function (clearLink) {
    clearLink.classList.toggle("is-visible", count > 0);
  });

  if (header) {
    if (isMobile) {
      header.classList.remove("hidden");
    } else {
      header.classList.toggle("hidden", count === 0);
    }
  }

  if (bottom) {
    bottom.classList.toggle("is-visible", count > 0);
  }

  if (document.body.classList.contains("wizzy-filters-overlay")) {
    filtersLeft.classList.add("collection__filters--visible");
    if (isMobile) {
      scheduleWizzyMobileFilterDrawerScrollRefresh();
    }
  } else if (!isMobile) {
    filtersLeft.classList.remove("collection__filters--visible");
  }
}

function adaptWizzyMobileFilterEntry() {
  const entry = document.querySelector(".wizzy-search-wrapper .wizzy-filters-mobile-entry");
  if (!entry) {
    return;
  }

  if (entry.dataset.wizzyClpEntry !== "true") {
    const existingCount = entry.querySelector(".wz-active-filters-mobile-count");
    const countHtml = existingCount ? existingCount.outerHTML : '<span class="wz-active-filters-mobile-count"></span>';
    entry.innerHTML = WIZZY_CLP_FILTER_ICON + "<span>Filter</span>" + countHtml;
    entry.dataset.wizzyClpEntry = "true";
  }
}

function adaptWizzyFiltersToCollectionUI() {
  const filtersLeft = document.querySelector(".wizzy-search-wrapper .wizzy-search-filters-left");

  if (filtersLeft) {
    filtersLeft.classList.add("collection__filters");
    injectWizzyCollectionFilterChrome(filtersLeft);
    adaptWizzyFilterSections(filtersLeft);
    syncWizzyCollectionFilterChrome(filtersLeft);
  }

  relocateWizzySelectedFilters(filtersLeft);
  adaptWizzyMobileFilterEntry();
  injectWizzyDesktopSortChrome();
  injectWizzyCollectionMobileBar();
  bindWizzyAppliedFiltersResize();
  bindWizzyAppliedFiltersObserver();
  placeWizzySummaryText();

  if (
    window.innerWidth < 768 &&
    document.body.classList.contains("wizzy-filters-overlay")
  ) {
    scheduleWizzyMobileFilterDrawerScrollRefresh();
  }
}

function scheduleWizzyCollectionFilterAdapt() {
  [0, 100, 300, 800, 1500, 2500].forEach(function (delay) {
    setTimeout(adaptWizzyFiltersToCollectionUI, delay);
  });
}

function registerWizzyCollectionFilterHandlers() {
  if (wizzyCollectionFilterHandlersRegistered) {
    return;
  }
  wizzyCollectionFilterHandlersRegistered = true;

  document.addEventListener(
    "change",
    function (event) {
      if (window.innerWidth >= 768) {
        return;
      }
      if (
        !document.body.classList.contains("wizzy-filters-overlay") &&
        !document.body.classList.contains("wizzy-sort-overlay")
      ) {
        return;
      }
      if (
        event.target.closest(
          ".wizzy-search-wrapper .wizzy-search-filters-left, .wizzy-search-wrapper .wizzy-mobile-sort-drawer"
        )
      ) {
        scheduleWizzyMobileFilterDrawerScrollRefresh();
      }
    },
    true
  );

  document.addEventListener("click", function (event) {
    if (!document.querySelector(".wizzy-search-wrapper")) {
      return;
    }

    if (event.target.closest("[data-wizzy-clp-close]")) {
      event.preventDefault();
      closeWizzyMobileFilterDrawer();
      return;
    }

    if (event.target.closest("[data-wizzy-clp-apply]")) {
      scheduleWizzyCollectionFilterAdapt();
      scheduleWizzyMobileScrollUnlockAfterFilterApply();
      return;
    }

    if (event.target.closest("[data-wizzy-mobile-filter], [data-mobile-filter]")) {
      const entry = document.querySelector(".wizzy-search-wrapper .wizzy-filters-mobile-entry");
      if (entry && !event.target.closest(".wizzy-filters-mobile-entry")) {
        event.preventDefault();
        entry.click();
      }
      return;
    }

    if (event.target.closest("[data-wizzy-mobile-sort], [data-mobile-sort-open]")) {
      event.preventDefault();
      openWizzySortDrawer();
      return;
    }

    if (event.target.closest("[data-wizzy-sort-close]")) {
      event.preventDefault();
      closeWizzySortDrawer();
      return;
    }

    const sortOption = event.target.closest("[data-wizzy-sort-option]");
    if (sortOption) {
      event.preventDefault();
      applyWizzySortFromDrawer(
        sortOption.getAttribute("data-field"),
        sortOption.getAttribute("data-order"),
        sortOption.getAttribute("data-index")
      );
    }
  });

  const observer = new MutationObserver(function () {
    const filtersLeft = document.querySelector(".wizzy-search-wrapper .wizzy-search-filters-left");
    if (!filtersLeft) {
      return;
    }
    if (document.body.classList.contains("wizzy-filters-overlay")) {
      filtersLeft.classList.add("collection__filters--visible");
    } else {
      filtersLeft.classList.remove("collection__filters--visible");
    }
    syncWizzySlpBackgroundScrollLock();
  });
  observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });

  const filtersMutationObserver = new MutationObserver(function () {
    if (
      window.innerWidth < 768 &&
      document.body.classList.contains("wizzy-filters-overlay")
    ) {
      scheduleWizzyMobileFilterDrawerScrollRefresh();
    }
  });

  function attachFiltersMutationObserver() {
    const wrapper = document.querySelector(
      ".wizzy-search-wrapper .wizzy-search-filters-left .wizzy-search-filters-left-wrapper"
    );
    if (wrapper) {
      filtersMutationObserver.observe(wrapper, { childList: true, subtree: true });
    }
  }

  attachFiltersMutationObserver();
  [300, 1000, 2500].forEach(function (delay) {
    setTimeout(attachFiltersMutationObserver, delay);
  });
}

const syncWizzyTileViewLevel = function (mode) {
  const wizzyWrapper = document.querySelector(".wizzy-search-wrapper");
  if (!wizzyWrapper) return;

  const level = mode === "one" ? "1" : "2";
  wizzyWrapper.setAttribute("wizzy-tile-view-level", level);
};

const applyWizzyProductGridItemClasses = function (mode) {
  const wizzyWrapper = document.querySelector(".wizzy-search-wrapper");
  if (!wizzyWrapper) return;

  const single = mode === "one";

  wizzyWrapper.querySelectorAll(".wizzy-result-product").forEach(function (item, index) {
    item.classList.remove(
      "mobile--one-half",
      "mobile--one-whole",
      "one-third",
      "one-quarter",
      "grid-item--column-1",
      "grid-item--column-2",
      "grid-item--column-3",
      "grid-item--even",
      "grid-item--second-tablet",
      "grid-item--third-tablet"
    );

    if (single) {
      item.classList.add("mobile--one-whole");
      return;
    }

    item.classList.add("mobile--one-half", "one-third");
    item.classList.add("grid-item--column-" + ((index % 3) + 1));
    if (index % 2 === 1) {
      item.classList.add("grid-item--even");
    }
  });
};

const syncWizzyViewInfoToggle = function (mode) {
  document
    .querySelectorAll(".wizzy-search-wrapper [data-wizzy-view-info-toggle]")
    .forEach(function (toggle) {
      toggle.setAttribute("aria-pressed", String(mode === "one"));
    });
};

const setCollectionGridMode = function (mode) {
  if (!mode) return;

  const single = mode === "one";
  sessionStorage.setItem("collectionGridMode", mode);

  document
    .querySelectorAll("[data-collection-products], .wizzy-search-wrapper .collection__products")
    .forEach((element) => {
      element.classList.add("collection__products");
      element.classList.toggle("one-grid-view", single);
      element.classList.toggle("two-grid-view", !single);
      element.classList.remove("three-grid-view");
    });

  document.querySelectorAll(".grid-view__option").forEach((button) => {
    button.classList.toggle("active-grid", button.dataset.gridOption === mode);
  });

  document.querySelectorAll("[data-mobile-grid]").forEach((button) => {
    button.classList.toggle("is-active", button.dataset.mobileGrid === mode);
  });

  syncWizzyViewInfoToggle(mode);
  syncWizzyTileViewLevel(mode);
  applyWizzyProductGridItemClasses(mode);
};

const scheduleWizzyCollectionGridSync = function () {
  setTimeout(setupWizzyCollectionGrid, 0);
};

const injectWizzyGridButtons = function () {
  const savedMode = sessionStorage.getItem("collectionGridMode") || "two";
  const filtersLeft = document.querySelector(".wizzy-search-filters-left");
  const template = document.getElementById("wizzy-grid-options-template");
  if (!template) {
    return;
  }

  if (filtersLeft && !filtersLeft.querySelector(".wizzy-grid-filters-toolbar")) {
    const toolbar = document.createElement("div");
    toolbar.className = "wizzy-grid-filters-toolbar";
    toolbar.innerHTML = template.innerHTML;

    const filtersHeader = filtersLeft.querySelector(".wizzy-filters-header");
    if (filtersHeader) {
      filtersLeft.insertBefore(toolbar, filtersHeader);
      const headerTitle = filtersHeader.querySelector(".header-title");
      if (headerTitle) headerTitle.style.display = "none";
    } else {
      filtersLeft.prepend(toolbar);
    }

    toolbar.querySelectorAll(".grid-view__option").forEach((button) => {
      button.classList.toggle("active-grid", button.dataset.gridOption === savedMode);
    });
  }

  injectWizzyDesktopSortChrome();
  injectWizzyCollectionMobileBar();
};

function getWizzySearchTotal() {
  return window.wizzyLastSearchTotal != null && window.wizzyLastSearchTotal !== ""
    ? window.wizzyLastSearchTotal
    : "";
}

function captureWizzySearchTotal(data) {
  if (!data || data.api === "autocomplete") {
    return data;
  }

  const total =
    data?.response?.payload?.total ??
    data?.payload?.total ??
    data?.response?.total ??
    data?.total;

  if (total != null && total !== "") {
    window.wizzyLastSearchTotal = total;
    placeWizzySummaryText();
  }

  return data;
}

function placeWizzySummaryText() {
  const summaryEl = document.querySelector(
    ".wizzy-search-wrapper .wizzy-summary-text"
  );
  if (!summaryEl) {
    return;
  }

  const isMobile = window.innerWidth < 768;
  const filtersTop = document.querySelector(
    ".wizzy-search-wrapper .wizzy-search-filters-top"
  );
  const collectionProducts = document.querySelector(
    ".wizzy-search-wrapper [data-collection-products]"
  );
  const resultsList = document.querySelector(
    ".wizzy-search-wrapper .wizzy-search-results-list"
  );

  if (isMobile && filtersTop && filtersTop.parentNode) {
    if (summaryEl.previousElementSibling !== filtersTop) {
      filtersTop.insertAdjacentElement("afterend", summaryEl);
    }
    const pillsHost = document.querySelector(
      ".wizzy-search-wrapper [data-wizzy-mobile-applied-filters]"
    );
    if (
      pillsHost &&
      pillsHost.parentNode === filtersTop.parentNode &&
      pillsHost.previousElementSibling !== summaryEl
    ) {
      summaryEl.insertAdjacentElement("afterend", pillsHost);
    }
    return;
  }

  if (filtersTop && filtersTop.parentNode) {
    if (summaryEl.previousElementSibling !== filtersTop) {
      filtersTop.insertAdjacentElement("afterend", summaryEl);
    }
    return;
  }

  if (
    collectionProducts &&
    resultsList &&
    resultsList.parentNode === collectionProducts &&
    summaryEl.nextElementSibling !== resultsList
  ) {
    collectionProducts.insertBefore(summaryEl, resultsList);
    return;
  }

  if (collectionProducts && summaryEl.nextElementSibling !== collectionProducts) {
    collectionProducts.parentNode.insertBefore(summaryEl, collectionProducts);
  }
}

function injectWizzyDesktopSortChrome() {
  const container = document.querySelector(".wizzy-search-wrapper .wizzy-sort-container");
  if (!container) {
    return;
  }

  container.classList.add("collection__sort-bar");
  if (!container.querySelector(".sort_title")) {
    const title = document.createElement("div");
    title.className = "sort_title";
    title.innerHTML =
      WIZZY_DESKTOP_SORT_SVG +
      '<span class="collection__sort__label">Sort by:</span>';
    container.insertBefore(title, container.firstChild);
  } else {
    const label = container.querySelector(".collection__sort__label");
    if (label && label.textContent.trim() !== "Sort by:") {
      label.textContent = "Sort by:";
    }
  }

  injectWizzyViewInfoToggle();
  revealWizzyMobileSortPills();
  enableWizzySortPillsScroll();
}

function getWizzySearchQuery() {
  const nodes = document.querySelectorAll(
    ".wizzy-search-wrapper [data-wizzy-search-query]"
  );
  let query = "";
  nodes.forEach(function (node) {
    const text = node.textContent.trim();
    if (text && !node.closest("[data-wizzy-query-header]")) {
      query = text;
    }
  });
  if (!query && nodes.length) {
    query = nodes[nodes.length - 1].textContent.trim();
  }
  if (query) {
    return query;
  }
  const input = document.querySelector(".wizzy-search-input");
  if (input && input.value.trim()) {
    return input.value.trim();
  }
  return new URLSearchParams(window.location.search).get("q") || "";
}

var wizzyQueryHeaderResizeBound = false;

function injectWizzyViewInfoToggle() {
  const filtersTop = document.querySelector(
    ".wizzy-search-wrapper .wizzy-search-results-container > .wizzy-search-filters-top, .wizzy-search-wrapper .wizzy-search-filters-top"
  );
  if (!filtersTop || !filtersTop.parentNode) {
    return;
  }

  const isDesktop = window.innerWidth >= 768;
  const wrapper =
    filtersTop.querySelector(".search-filters-top-wrapper") || filtersTop;
  const parent = isDesktop ? filtersTop.parentNode : wrapper;

  let row = document.querySelector(".wizzy-search-wrapper [data-wizzy-query-header]");
  if (!row) {
    row = document.createElement("div");
    row.className = "wizzy-search-query-header";
    row.setAttribute("data-wizzy-query-header", "");
  }

  if (isDesktop) {
    if (row.parentNode !== parent || row.nextElementSibling !== filtersTop) {
      parent.insertBefore(row, filtersTop);
    }
  } else if (row.parentNode !== wrapper || row !== wrapper.firstChild) {
    wrapper.insertBefore(row, wrapper.firstChild);
  }

  if (!wizzyQueryHeaderResizeBound) {
    wizzyQueryHeaderResizeBound = true;
    window.addEventListener("resize", injectWizzyViewInfoToggle);
  }

  row.querySelectorAll(".wizzy-search-query").forEach(function (el) {
    el.remove();
  });

  let button = document.querySelector(
    ".wizzy-search-wrapper [data-wizzy-view-info-toggle]"
  );
  if (!button) {
    const mode = sessionStorage.getItem("collectionGridMode") || "two";
    button = document.createElement("button");
    button.type = "button";
    button.className = "view-info-toggle";
    button.setAttribute("data-wizzy-view-info-toggle", "");
    button.setAttribute("aria-pressed", String(mode === "one"));
    button.innerHTML =
      '<span class="view-info-toggle__label">View Info</span>' +
      '<span class="view-info-toggle__switch" aria-hidden="true"></span>';
  }
  if (button.parentNode !== row) {
    row.appendChild(button);
  }
}

function enableWizzySortPillsScroll() {
  document
    .querySelectorAll(".wizzy-search-wrapper .wizzy-common-select-options")
    .forEach(function (el) {
      if (el.dataset.scrollEnhanced) {
        return;
      }
      el.dataset.scrollEnhanced = "true";

      function getMaxScroll() {
        return el.scrollWidth - el.clientWidth;
      }

      el.addEventListener(
        "wheel",
        function (e) {
          if (e.ctrlKey) {
            return;
          }

          const maxScroll = getMaxScroll();
          if (maxScroll <= 1) {
            return;
          }

          const usingVertical = Math.abs(e.deltaY) >= Math.abs(e.deltaX);
          let delta = usingVertical ? e.deltaY : e.deltaX;
          if (e.deltaMode === 1) {
            delta *= 16;
          } else if (e.deltaMode === 2) {
            delta *= el.clientWidth;
          }

          const next = Math.max(0, Math.min(maxScroll, el.scrollLeft + delta));
          if (next === el.scrollLeft) {
            return;
          }

          el.scrollLeft = next;
          e.preventDefault();
        },
        { passive: false }
      );

      let pointerId = null;
      let startX = 0;
      let startScroll = 0;
      let dragging = false;
      let justDragged = false;

      el.addEventListener("pointerdown", function (e) {
        if (e.button !== 0) {
          return;
        }
        if (getMaxScroll() <= 1) {
          return;
        }
        pointerId = e.pointerId;
        startX = e.clientX;
        startScroll = el.scrollLeft;
        dragging = false;
        justDragged = false;
      });

      el.addEventListener("pointermove", function (e) {
        if (e.pointerId !== pointerId) {
          return;
        }
        const dx = e.clientX - startX;
        if (!dragging) {
          if (Math.abs(dx) < 5) {
            return;
          }
          dragging = true;
          el.setPointerCapture(pointerId);
          el.classList.add("is-dragging");
        }
        el.scrollLeft = startScroll - dx;
        e.preventDefault();
      });

      function endDrag(e) {
        if (e.pointerId !== pointerId) {
          return;
        }
        if (dragging) {
          justDragged = true;
          el.classList.remove("is-dragging");
          if (el.hasPointerCapture(pointerId)) {
            el.releasePointerCapture(pointerId);
          }
        }
        pointerId = null;
        dragging = false;
      }

      el.addEventListener("pointerup", endDrag);
      el.addEventListener("pointercancel", endDrag);
      el.addEventListener("click", function (e) {
        if (!justDragged) {
          return;
        }
        justDragged = false;
        e.preventDefault();
        e.stopPropagation();
      }, true);
    });
}

function revealWizzyMobileSortPills() {
  if (window.innerWidth > 767) {
    return;
  }

  document
    .querySelectorAll(".wizzy-search-wrapper .wizzy-common-select-options")
    .forEach(function (el) {
      el.style.removeProperty("display");
      el.style.removeProperty("position");
      el.style.removeProperty("top");
      el.style.removeProperty("left");
      el.style.removeProperty("right");
      el.style.removeProperty("width");
      el.style.removeProperty("height");
    });
}

function openWizzySortDrawer() {
  if (window.innerWidth > 767) {
    return;
  }
  renderWizzyMobileSortOptions();
  const drawer = ensureWizzyMobileSortDrawer();
  if (!drawer) {
    return;
  }
  drawer.classList.add("is-open");
  document.body.classList.add("wizzy-sort-overlay");
  syncWizzySlpBackgroundScrollLock();
}

function closeWizzySortDrawer() {
  document.querySelector("[data-wizzy-sort-drawer]")?.classList.remove("is-open");
  document.body.classList.remove("wizzy-sort-overlay");
  syncWizzySlpBackgroundScrollLock();
}

function applyWizzySortFromDrawer(field, order, index) {
  const select = document.querySelector(
    ".wizzy-search-wrapper .wizzy-sort-select, .wizzy-search-wrapper #wizzy-sort-select"
  );
  if (!select) {
    closeWizzySortDrawer();
    return;
  }

  let optionIndex = parseInt(index, 10);
  if (!Number.isFinite(optionIndex) || optionIndex < 0) {
    optionIndex = Array.prototype.findIndex.call(select.options, function (opt) {
      return (
        opt.value === field &&
        String(opt.getAttribute("data-order") || "") === String(order || "")
      );
    });
  }
  if (optionIndex < 0) {
    optionIndex = Array.prototype.findIndex.call(select.options, function (opt) {
      return opt.value === field;
    });
  }
  if (optionIndex < 0) {
    closeWizzySortDrawer();
    return;
  }

  Array.prototype.forEach.call(select.options, function (opt, i) {
    opt.selected = i === optionIndex;
  });
  select.selectedIndex = optionIndex;

  const jq = window.jQuery || window.$;
  const customOptions = document.querySelectorAll(
    ".wizzy-search-wrapper .wizzy-sort-container .wizzy-common-select-option, .wizzy-search-wrapper .wizzy-search-sort-wrapper .wizzy-common-select-option"
  );

  if (customOptions[optionIndex]) {
    customOptions[optionIndex].click();
  } else if (jq) {
    jq(select.options[optionIndex]).prop("selected", true);
    jq(select).trigger("change");
  } else {
    select.dispatchEvent(new Event("change", { bubbles: true }));
  }

  closeWizzySortDrawer();
}

function getWizzyResultsCountLabel() {
  const summaryEl = document.querySelector(
    ".wizzy-search-wrapper .wizzy-summary-text"
  );
  const text = summaryEl
    ? summaryEl.textContent.replace(/\s+/g, " ").trim()
    : "";
  return text || "Sort";
}

function ensureWizzyMobileSortDrawer() {
  const wizzyWrapper = document.querySelector(".wizzy-search-wrapper");
  if (!wizzyWrapper) {
    return null;
  }

  let drawer = wizzyWrapper.querySelector("[data-wizzy-sort-drawer]");
  if (drawer && !drawer.querySelector(".cmb-sort-sheet__panel")) {
    drawer.remove();
    drawer = null;
  }
  if (!drawer) {
    drawer = document.createElement("div");
    drawer.className = "cmb-sort-sheet wizzy-mobile-sort-drawer";
    drawer.setAttribute("data-wizzy-sort-drawer", "true");
    drawer.innerHTML =
      '<div class="cmb-sort-sheet__overlay" data-wizzy-sort-close></div>' +
      '<div class="cmb-sort-sheet__panel" role="dialog" aria-label="Sort">' +
      '<div class="cmb-sort-sheet__head">' +
      '<span class="wizzy-mobile-sort-drawer__count" data-wizzy-sort-count></span>' +
      '<button type="button" class="cmb-sort-sheet__close" data-wizzy-sort-close aria-label="Close">&times;</button>' +
      "</div>" +
      '<div class="cmb-sort-sheet__list" data-wizzy-sort-list></div>' +
      "</div>";
    wizzyWrapper.appendChild(drawer);
  }
  return drawer;
}

function renderWizzyMobileSortOptions() {
  const select = document.querySelector(
    ".wizzy-search-wrapper .wizzy-sort-select, .wizzy-search-wrapper #wizzy-sort-select"
  );
  const drawer = ensureWizzyMobileSortDrawer();
  const list = drawer?.querySelector("[data-wizzy-sort-list]");
  if (!select || !list) {
    return;
  }

  const countEl = drawer.querySelector("[data-wizzy-sort-count]");
  if (countEl) {
    countEl.textContent = getWizzyResultsCountLabel();
  }

  list.innerHTML = Array.prototype.map
    .call(select.options, function (option, index) {
      const selected = option.selected ? " is-active" : "";
      const order = option.getAttribute("data-order") || "";
      return (
        '<button type="button" class="cmb-sort-sheet__option' +
        selected +
        '" data-wizzy-sort-option data-index="' +
        index +
        '" data-field="' +
        escapeHtml(option.value) +
        '" data-order="' +
        escapeHtml(order) +
        '">' +
        escapeHtml(option.text.trim()) +
        "</button>"
      );
    })
    .join("");
}

function injectWizzyCollectionMobileBar() {
  const wizzyWrapper = document.querySelector(".wizzy-search-wrapper");
  if (!wizzyWrapper) {
    return;
  }

  let bar = wizzyWrapper.querySelector("[data-wizzy-mobile-bar]");
  if (!bar) {
    bar = document.createElement("div");
    bar.className = "collection-mobile-bar wizzy-collection-mobile-bar";
    bar.setAttribute("data-wizzy-mobile-bar", "true");
    bar.innerHTML =
      '<div class="collection-mobile-bar__inner">' +
      '<div class="collection-mobile-bar__grid">' +
      '<button type="button" class="cmb__grid-btn grid-view__option" data-grid-option="two" data-mobile-grid="two" aria-label="Two column view">' +
      WIZZY_CMB_GRID_TWO_SVG +
      "</button>" +
      '<button type="button" class="cmb__grid-btn grid-view__option" data-grid-option="one" data-mobile-grid="one" aria-label="Single column view">' +
      WIZZY_CMB_GRID_ONE_SVG +
      "</button>" +
      "</div>" +
      '<button type="button" class="cmb__action" data-wizzy-mobile-filter data-mobile-filter>' +
      WIZZY_CLP_FILTER_ICON +
      "<span>Filter</span>" +
      "</button>" +
      '<button type="button" class="cmb__action" data-wizzy-mobile-sort data-mobile-sort-open>' +
      WIZZY_CMB_SORT_SVG +
      "<span>Sort</span>" +
      "</button>" +
      "</div>";
    wizzyWrapper.appendChild(bar);
  }

  const savedMode = sessionStorage.getItem("collectionGridMode") || "two";
  bar.querySelectorAll("[data-mobile-grid]").forEach(function (button) {
    button.classList.toggle("is-active", button.dataset.mobileGrid === savedMode);
    button.classList.toggle("active-grid", button.dataset.gridOption === savedMode);
  });
}

const setupWizzyCollectionGrid = function () {
  const wizzyWrapper = document.querySelector(".wizzy-search-wrapper");
  if (!wizzyWrapper) return;

  document.querySelectorAll(".wizzy-tile-view-icon").forEach((element) => {
    element.style.display = "none";
  });

  injectWizzyGridButtons();

  const resultsList = wizzyWrapper.querySelector(".wizzy-search-results-list");
  if (resultsList) {
    resultsList.classList.add("grid", "grid--empty-items-0");
  }

  let collectionProducts = document.querySelector("[data-collection-products]");
  const savedMode = sessionStorage.getItem("collectionGridMode") || "two";

  if (!collectionProducts && resultsList) {
    collectionProducts = document.createElement("div");
    collectionProducts.className = `collection__products ${savedMode}-grid-view`;
    collectionProducts.setAttribute("data-collection-products", "");
    resultsList.parentNode.insertBefore(collectionProducts, resultsList);
    collectionProducts.appendChild(resultsList);
  }

  setCollectionGridMode(savedMode);
  placeWizzySummaryText();
  revealWizzyMobileSortPills();
  enableWizzySortPillsScroll();
  scheduleWizzyJudgeMeBadgesLoad();

  if (typeof window.refreshHulkWishlist === "function") {
    window.refreshHulkWishlist();
  }
};

function applyWizzyColorSwatchToIndicator(indicator, color) {
  if (!indicator || !color || !color[0]) {
    return;
  }

  const value = color[0];
  const isImage = color[1] || isWizzyCssGradient(value);

  indicator.classList.toggle(
    "wizzy-color-filter-swatch--split",
    isWizzyCssGradient(value)
  );
  indicator.style.backgroundColor = isImage ? "" : value;
  indicator.style.backgroundImage = color[1]
    ? "url(" + value + ")"
    : isWizzyCssGradient(value)
      ? value
      : "";

  if (!isImage && /^#fff(fff)?$/i.test(value)) {
    indicator.style.border = "1px solid rgba(0, 0, 0, 0.12)";
  }
}

function getWizzyResponseFacets(data) {
  return (
    data?.response?.payload?.facets ||
    data?.response?.facets ||
    data?.payload?.facets ||
    null
  );
}

function shouldCustomizeWizzyFacetResponse(data) {
  if (!data || data.api === "autocomplete") {
    return false;
  }
  return Array.isArray(getWizzyResponseFacets(data));
}

function isWizzyColorsFacet(facet) {
  if (!facet?.key) {
    return false;
  }
  const key = String(facet.key).toLowerCase();
  return key.includes("color") || key.includes("colour");
}

function resolveWizzyColorSwatch(item) {
  const apiValue =
    item?.data?.swatch?.value ||
    item?.swatchValue ||
    item?.swatch?.value ||
    (typeof item?.swatch === "string" ? item.swatch : "");
  const color = findHaxCode(item.label || item.key, apiValue);
  return color[0] ? color : [WIZZY_COLOR_SWATCH_FALLBACK, false];
}

function applyWizzyColorFacetSwatches(facets) {
  if (!Array.isArray(facets)) {
    return;
  }

  facets.forEach(function (facet) {
    if (!isWizzyColorsFacet(facet) || !Array.isArray(facet.data)) {
      return;
    }

    facet.data.forEach(function (item) {
      const color = resolveWizzyColorSwatch(item);

      item.isSwatch = true;
      item.isURLSwatch = color[1];
      item.isVisualSwatch = true;
      item.swatchValue = color[0];
      item.data = {
        value: item.key,
        swatch: {
          type: "visual",
          value: color[0],
        },
      };
    });
  });
}

function processWizzyResultsFacets(data) {
  applyWizzyColorFacetSwatches(getWizzyResponseFacets(data));
  return data;
}

var WIZZY_COLOR_FACET_ITEM_SELECTOR =
  '.wizzy-filters-facet-block[data-key="product_Color"] .wizzy-facet-list-item,' +
  '.wizzy-filters-facet-block[data-key="colors"] .wizzy-facet-list-item,' +
  ".facet-body-product_Color .wizzy-facet-list-item," +
  ".facet-body-colors .wizzy-facet-list-item";

function scheduleWizzyColorFilterSwatchesInDom() {
  setTimeout(applyWizzyColorFilterSwatchesInDom, 100);
}

function applyWizzyColorFilterSwatchesInDom(root) {
  const scope = root || document;
  scope.querySelectorAll(WIZZY_COLOR_FACET_ITEM_SELECTOR).forEach(function (item) {
    const key = item.getAttribute("data-key") || item.dataset.key || "";
    const label = (item.getAttribute("title") || "").trim();
    const swatchValue =
      item.getAttribute("data-swatch-value") || item.dataset.swatchValue || "";
    const checkbox = item.querySelector(".wizzy-facet-list-item-checkbox");
    if (!checkbox) {
      return;
    }

    let indicator = checkbox.querySelector(".checkbox-indicator");
    if (!indicator) {
      indicator = document.createElement("span");
      indicator.className = "checkbox-indicator wizzy-color-filter-swatch";
      checkbox.insertBefore(indicator, checkbox.firstChild);
    }

    const color = findHaxCode(label || key, swatchValue);
    item.classList.add("wizzy-color-filter-item");
    indicator.classList.add("wizzy-color-filter-swatch");
    applyWizzyColorSwatchToIndicator(indicator, color);

    if (!indicator.querySelector(".icon-check")) {
      const check = document.createElement("span");
      check.className = "icon icon-check";
      check.setAttribute("aria-hidden", "true");
      indicator.appendChild(check);
    }
  });
  adaptWizzyFiltersToCollectionUI();
}

var wizzyCustomEventsRegistered = false;

function registerWizzyCustomEvents() {
  if (wizzyCustomEventsRegistered || !window.wizzyConfig?.events) {
    return;
  }
  wizzyCustomEventsRegistered = true;

  registerWizzySlpVariantHandlers();
  registerWizzySiblingSwatchPreserve();
  registerWizzyPriceRangeHandlers();
  registerWizzyCollectionFilterHandlers();
  changeTemplate("wizzy-search-results-product");
  changeTemplate("wizzy-autocomplete-topproducts");
  changeTemplate("wizzy-search-empty-results");
  changeTemplate("wizzy-search-sort");
  changeTemplate("wizzy-search-summary");

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {
      data.search.configs.facets.showPriceInputRangeFields = true;
      data.search.configs.pagination.appendInExistingList = true;
      data.search.configs.facets.leftFacets.mobileCollapsible = true;
      data["filters"]["configs"]["keepOpenedInMobileAfterApply"] = true;
      if (data.search?.view?.templates) {
        data.search.view.templates.summary = "#wizzy-search-summary";
      }
      window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
        {
          dom: "wizzy-search-input",
          type: "text",
        },
        {
          dom: "header input",
          type: "search",
        },
      ];
      window.wizzyConfig["search"]["configs"]["pagination"][
        "infiniteScrollOffset"
      ] = { desktop: 3000, mobile: 2000 };
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (filter) {
      if (!filter.sort) {
        filter.sort = [
          {
            field: "relevance",
            order: "asc",
          },
        ];
      }
      return filter;
    }
  );

  let clicked_on = "NA";
    $(document).on('mousedown', '.autocomplete-item a', function () {
      const $item = $(this).closest('.autocomplete-item');
      const $head = $item.prevAll('.autocomplete-item-head').first();

      if ($head.length) {
        const sectionTitle = $head.text().trim();

        if (sectionTitle === 'Categories') {
          clicked_on = 'categories';
        } else if (sectionTitle === 'Trending Searches') {
          clicked_on = 'trending_searches';
        }
      }
    });

  $(document).on('mousedown', '.autocomplete-top-products .topproduct-item', function () {
      let section_name = "top_products";
      let selection_type = "suggested_search_term";

      let productName = $(this).find('.product-grid-item__title').text().trim();
      let search_term = productName;

      let cta_text = productName;

      
      const eventData = {
        event: 'search_term_entered',
        section_name,
        search_term,
        selection_type,
        cta_text
      };

      if (!window.dataLayer) window.dataLayer = [];
      
      const index = window.dataLayer.findIndex(e => e.event === 'search_term_entered');
      
      if (index > -1) {
        Object.assign(window.dataLayer[index], eventData);
      } else {
        window.dataLayer.push(eventData);
      }
      
    });

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {
      data.getAllvariants = 'true';
      let section_name = clicked_on;
      let selection_type = clicked_on != "NA" ? "suggested_search_term" : "manual";
      let search_term = data.q;
      let cta_text = data.q;

      const eventData = {
        event: "search_term_entered",
        search_term,
        section_name,
        selection_type,
        cta_text,
      };
      if (!window.dataLayer) window.dataLayer = [];
      window.dataLayer.push(eventData);

      var closeButton = document.querySelector(".search-bar-close__button");
      if (closeButton) {
        closeButton.click();
      }

      data.sort = [
        {
          field: "product_wizzy-best-selling_sortOrder:float",
          order: "asc",
        },
        {
          field: "relevance",
          order: "asc",
        },
      ];

      if (localStorage.getItem("wizzyIsRedirectedFlag") === "true") {
        window.location.replace("https://nashermiles.com/collections/best-seller");
      }
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      clicked_on = "NA";
      scheduleWizzyCollectionGridSync();
      scheduleWizzyJudgeMeBadgesLoad();
      scheduleWizzyColorFilterSwatchesInDom();
      scheduleWizzyPriceRangeSetup();
      adaptWizzyFiltersToCollectionUI();
      scheduleWizzyCollectionFilterAdapt();
      scheduleWizzySearchResultColorStripPin();
      primeWizzySearchSwatchData(document);
      if (window.__wizzySwatchPreserve) {
        scheduleWizzySiblingSwatchRestore();
      }
      releaseWizzyMobileScrollLockIfIdle();
      return data;
    });

  const wizzyAllowedEvents = window.wizzyConfig.events.allowedEvents;

  if (wizzyAllowedEvents.PRODUCTS_RESULTS_RENDERED) {
    window.wizzyConfig.events.registerEvent(
      wizzyAllowedEvents.PRODUCTS_RESULTS_RENDERED,
      function (data) {
        scheduleWizzyCollectionGridSync();
        scheduleWizzyJudgeMeBadgesLoad();
        scheduleWizzyPriceRangeSetup();
        scheduleWizzyCollectionFilterAdapt();
        scheduleWizzySearchResultColorStripPin();
        releaseWizzyMobileScrollLockIfIdle();
        return data;
      }
    );
  }

  if (wizzyAllowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED) {
    window.wizzyConfig.events.registerEvent(
      wizzyAllowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
      function (data) {
        scheduleWizzyCollectionGridSync();
        scheduleWizzyJudgeMeBadgesLoad();
        scheduleWizzyPriceRangeSetup();
        scheduleWizzyCollectionFilterAdapt();
        releaseWizzyMobileScrollLockIfIdle();
        return data;
      }
    );
  }

  if (wizzyAllowedEvents.AFTER_WIZZY_API_RESPONDED) {
    window.wizzyConfig.events.registerEvent(
      wizzyAllowedEvents.AFTER_WIZZY_API_RESPONDED,
      function (data) {
        captureWizzySearchTotal(data);
        if (shouldCustomizeWizzyFacetResponse(data)) {
          processWizzyResultsFacets(data);
          scheduleWizzyColorFilterSwatchesInDom();
        }
        releaseWizzyMobileScrollLockIfIdle();
        return data;
      }
    );
  }

  if (wizzyAllowedEvents.BEFORE_RENDER_RESULTS) {
    window.wizzyConfig.events.registerEvent(
      wizzyAllowedEvents.BEFORE_RENDER_RESULTS,
      function (data) {
        captureWizzySearchTotal(data);
        if (shouldCustomizeWizzyFacetResponse(data)) {
          processWizzyResultsFacets(data);
        }
        return data;
      }
    );
  }

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER,
    function (data) {
      localStorage.setItem("wizzyIsRedirectedFlag", false);
      let x = document.querySelector(".wizzy-body-end-wrapper");
      if (
        x &&
        typeof data.isForDefault !== "undefined" &&
        data.isForDefault === true
      ) {
        x.classList.add("wizzy-view-more-hide");
      } else if (x && x.classList.contains("wizzy-view-more-hide")) {
        x.classList.remove("wizzy-view-more-hide");
      }
      if (data?.payload?.products?.result?.length == 0) {
        localStorage.setItem("wizzyIsRedirectedFlag", true);
      } else {
        localStorage.setItem("wizzyIsRedirectedFlag", false);
      }
      setTimeout(scheduleWizzyJudgeMeBadgesLoad, 0);
      // setTimeout(positionWizzyAutocompleteWrapper, 0);
      return data;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {
      if (data.group === "defaultMenu" && data.filters && data.filters.sort) {
        data.filters.sort = [
          {
            field: "product_top-products_sortOrder:float",
            order: "asc",
          },
        ];
      }
      return data;
    }
  );


  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_PRODUCTS_TRANSFORMED,
    function (data) {
      captureWizzyRawProductRatings(data);
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (data) {
      data?.forEach((product) => {
        product.total = getWizzySearchTotal();
      });

      data?.forEach((product) => {
        product.indiTags = "";
        product?.attributes?.forEach((attribute) => {
          if (attribute.id === "product_indi_tags") {
            if (attribute.values.length > 0) {
              product.indiTags = attribute.values[0].value[0];
            }
          }
        });
      });

      data?.forEach((product) => {
        if (!product.totalReviews) {
          product.totalReviews =
            getAttributeValue(product, "product_reviews_count_opinew_metafields") ||
            product.totalReviews ||
            "";
        }
      });

      data?.forEach((product) => {
        product.newArrival = false;
        product.bestSeller = false;
        product.bestSellerLabel = "";
        product.backInStock = false;
        product.showTagBadge = false;
        product.tagBadge = "";
        product.valueLabel = "";

        (product.attributes || []).forEach(function (attribute) {
          if (attribute.id !== "product_value_tags_labels") {
            return;
          }
          const rawValue = attribute.values && attribute.values[0] && attribute.values[0].value;
          const firstValue = Array.isArray(rawValue) ? rawValue[0] : rawValue;
          if (firstValue) {
            product.valueLabel = firstValue;
          }
        });

        const productTags = getWizzyProductTags(product);

        productTags.forEach(function (tag) {
          const lower = String(tag).toLowerCase();
          if (
            String(tag).toLowerCase().indexOf("tag__newlaunch") > -1 ||
            lower === "new launch" ||
            lower === "new_launch" ||
            lower === "new-launch"
          ) {
            product.newArrival = true;
          }
          if (String(tag).toLowerCase().indexOf("tag__backinstock") > -1) {
            product.backInStock = true;
          }
        });

        let tagBadge = resolveTagBadgeLabel(productTags);
        if (!tagBadge && product.valueLabel) {
          tagBadge = normalizeValueTagLabel(product.valueLabel);
        }

        if (tagBadge) {
          product.tagBadge = tagBadge;
          product.showTagBadge = true;
          product.bestSeller = true;
          product.bestSellerLabel = tagBadge;
        }
      });

      data?.forEach((product) => {
        function removeLastThreeIfDotZero(str) {
          if (str.endsWith(".00")) {
            return str.substring(0, str.length - 3);
          }
          return str;
        }
        if (product.sellingPrice) {
          product.sellingPrice = removeLastThreeIfDotZero(product.sellingPrice);
        }
        if (product.price) {
          product.price = removeLastThreeIfDotZero(product.price);
        }
        enrichWizzyProductPricing(product);
      });

      data?.forEach(function (product) {
        cacheWizzySiblingSizePayload(product);
      });

      const wizzyGroupProducts = new Map();
      data?.forEach(function (product) {
        const groupKey = String(product?.groupId || product?.id || "");
        if (!groupKey) {
          return;
        }
        if (!wizzyGroupProducts.has(groupKey)) {
          wizzyGroupProducts.set(groupKey, []);
        }
        wizzyGroupProducts.get(groupKey).push(product);
      });

      wizzyGroupProducts.forEach(function (groupProducts, groupKey) {
        if (groupProducts.length > 1) {
          wizzySlpGroupColorVariantCache.set(
            groupKey,
            buildWizzyGroupColorVariantMap(groupProducts)
          );
        }
      });

      data?.forEach((product) => {
        const groupKey = String(product?.groupId || product?.id || "");
        const groupColorMap =
          wizzySlpGroupColorVariantCache.get(groupKey) || null;
        finalizeWizzySearchProductVariants(product, groupColorMap);
      });
      return data;
    }
  );
}

window.onWizzyScriptLoaded = registerWizzyCustomEvents;
window.onWizzyLoaded = window.onWizzyLoaded || [];
window.onWizzyLoaded.push(registerWizzyCustomEvents);

if (window.wizzyScriptLoaded || window.wizzyConfig?.events) {
  registerWizzyCustomEvents();
}

document.addEventListener(
  "click",
  function (event) {
    if (!document.querySelector(".wizzy-search-wrapper")) {
      return;
    }

    const viewInfo = event.target.closest("[data-wizzy-view-info-toggle]");
    if (viewInfo && viewInfo.closest(".wizzy-search-wrapper")) {
      event.stopPropagation();
      const newMode =
        viewInfo.getAttribute("aria-pressed") === "true" ? "two" : "one";
      setCollectionGridMode(newMode);
      scheduleWizzyCollectionGridSync();
      return;
    }
  },
  true
);

document.addEventListener("click", function (event) {
  const gridButton = event.target.closest("[data-grid-option], [data-mobile-grid]");
  if (!gridButton || !document.querySelector(".wizzy-search-wrapper")) return;
  const mode = gridButton.dataset.gridOption || gridButton.dataset.mobileGrid;
  if (!mode) return;
  setCollectionGridMode(mode);
  scheduleWizzyCollectionGridSync();
});

document.addEventListener("DOMContentLoaded", () => {
  registerWizzyAutocompletePositionListeners();
  bindWizzyDesktopSearchIconAutocomplete();
  registerWizzySlpVariantHandlers();
  registerWizzyPriceRangeHandlers();
  registerWizzyCollectionFilterHandlers();
  scheduleWizzyPriceRangeSetup();
  scheduleWizzyCollectionFilterAdapt();

  const searchButton = document.querySelector(".mobile-search-bar__button");
  const searchInputSecond = document.querySelector(
    ".mobile-recommended-search__container .wizzy-search-input"
  );
  if (searchButton && searchInputSecond) {
    searchButton.addEventListener("click", () => {
      setTimeout(() => {
        searchInputSecond.click();
        searchInputSecond.focus();
      }, 900);
    });
  } else {
    console.warn("Button or input field not found.");
  }

  const searchButtonTwo = document.querySelector(
    ".mobile-menu__link.mobile-search-bar__button"
  );
  if (searchButtonTwo && searchInputSecond) {
    searchButtonTwo.addEventListener("click", () => {
      setTimeout(() => {
        searchInputSecond.click();
        searchInputSecond.focus();
      }, 900);
    });
  }
});
 document.addEventListener('click', function (e) {
  if (e.target.closest('.search-popdown__toggle.navlink.navlink--icon')) {
    setTimeout(function () {
      document.querySelector('.search-form__input.wizzy-search-input')?.click();
    }, 200);
  }
});